/* tshirt-order-flow.js — 本体ロジック（データは window.TF_DATA から）
   2026-11-04：注文のメモ（cart note）を、カートにある商品の「担当者からのメモ」「備考」だけで作り直す（前の注文や消した商品の備考が残らないように）
   2026-10-27：「納品予定日」を「出荷予定日」に変更（工場の混み具合から自動計算・API rafees-congestion /api/capacity）
   2026-10-27：出荷予定日（目安）を注文の商品情報に保存
   2026-10-27：STEP9「お届け日の指定」を追加（指定なし／日付を指定。出荷予定日の遅い方＋1日以降だけ選べる）。備考欄はSTEP10に
   2026-10-27：お届け希望日をオリジナルのカレンダーで選ぶ形に
   2026-10-27：出荷予定日は、ご注文から完成イメージのOKまで2営業日かかる見込みで出す（CONFIRM_DAYS。API の ?confirm= で計算）
   2026-10-27：お客様用URLで担当者が「完成イメージ確認済み」にチェックした注文は、確認の日数を足さない
   2026-10-27：休みを2種類に（臨時休業日＝事務だけ・完成イメージ確認の日数に使う／工場の休業日＝制作日数に使う）
   2026-10-27：営業日カレンダーの臨時休業日・臨時営業日を反映（API 側で計算。API が読めないときは window.ONDP_SHIP_CAL）
   2026-11-02：見出し・カラー名・画像は snippets/odp-color-list.liquid でHTMLに出す（SEO）。このファイルは在庫と動きを足す（スニペットがなければ自分で出す）
   2026-11-02：商品ページの「商品詳細」の上に「カラー・在庫」（STEP2と同じ画像・カラー名＋在庫）。押すとサイズごとの在庫と「このカラーで枚数を入れる」
               ・「商品詳細」の欄（.op-spec__inner）がない商品は、説明文の下に出す
   2026-11-02：担当者モードの「追加料金（担当者用）」欄に「出荷予定日」「お届け日」を追加（STAFF_FEES.ship / .wish）
               ・出荷予定日を入れると、自動計算の代わりにその日を出す（お客様用URL・カートにも入る）
               ・お届け日を入れると、出荷予定日より前の日でも「日付を希望する」でその日が選ばれる（お客様の画面でもそのまま）
   2026-10-20：自動お見積りページからの引き継ぎ（draft.src === 'quote'）に対応
   2026-10-20：カートに入れる前に入稿データの未アップロード確認を追加（必須にはしない）
   2026-10-20：印刷箇所を最大4箇所に／「センター ラージサイズ」に大判オプションを追加
   2026-10-21：お客様用URL（担当者が入力した内容をURLで送る・複数商品対応）を追加
   2026-10-21：お客様用URLを短いURL（/pages/order-link/〇〇・rafees-congestion 経由でShopifyに保存）に変更
   2026-10-21：見積りページ・お客様用URLから開いたときに在庫を確認し、在庫がないサイズを外して知らせる
   2026-10-21：自動お見積りから来た注文に「_op_自動見積りから」（見積り番号）を付ける
   2026-10-21：担当者パネルに「保存したURLを開く」「読み込む」を追加（あとから追加・修正できる）
   2026-10-21：担当者パネルを作り直し（①保存したお客様の一覧 → ②開いて編集。保存とURLコピーは別ボタン）
   2026-10-21：お客様用URLに「入稿データ受け取り済み」を追加（お客様の画面でアップロード不要と表示・確認画面を出さない）
   2026-10-21：ご注文内容確認の「印刷方法・印刷箇所」「入稿データ」を表で表示に変更（CSSは tshirt-order-flow.css の末尾）
   2026-10-22：シルクスクリーンの版分け（印刷箇所ごとに「全サイズ共通（1版）」初期値／「3サイズごと（おすすめ）」）
               デザインは同じなので印刷代は合計枚数の単価のまま。版代だけ「サイズ分けの数 × 色数」かかる。1版10枚以上必要
               自動お見積りページで「自分で分ける」にした分け方も引き継ぐ（placement.plateSplit / plateGroupsFixed）
   2026-10-22：シルクのオプション（印刷箇所ごと）
               ・特殊インク：なし／蓄光／クラック（＋110円／枚）
               ・リピート（前回の版を使う）：版代0円。前回の注文番号は必須。リピートが10枚以下ならセットアップ代1,100円／版
                 インクの色を変えて20枚以下なら版の清掃代1,100円／版。リピートは10枚未満でも注文できる（印刷代は10〜19枚の単価）
               ・インクの色替え（1色のデザインのみ）：本体の色ごとにインクを選ぶ。同じ版のまま。
                 いちばん枚数の多いインクを基本にして、それ以外のインクは色ごとに20枚以下なら版の清掃代1,100円
                 → 同日：分かりにくいため、いったん非表示（INK_CHANGE_ON = false）
   2026-10-22：担当者が自動お見積りで入れた「追加料金」（セットアップ代・版の清掃代・特殊インク・メモ）を引き継ぐ
               ・draft.staffFees = { setup, cleaning, special, memo }。お客様は変更できない（表示だけ）
               ・確認欄に「追加料金（担当者のお見積り）」、カートに料金の商品を入れる。メモは注文の項目に残す
               ・データ作成費（design：1100／3300／5500）は DESIGN_REQUEST_VARIANTS の商品を1つ入れる
   2026-10-26：シルクの合計10枚未満はサンプル・少量として受ける（今までは10枚以上でないとカートに入れられなかった）
               ・印刷代は10〜19枚の単価 × 枚数、版代は版の数だけ。10枚未満は版を自由に分けてよい（1版10枚以上は10枚以上のときだけ）
               ・サンプルのあとの量産は「リピート」（前回の注文番号にサンプルの注文番号）で版代0円
   2026-10-26：担当者の追加料金に特急料金（express：3300／5500／11000）。カートにはカスタム商品（DESIGN_REQUEST_VARIANTS）を組み合わせて入れる
   2026-10-26：別の商品と同じ版を使う（担当者だけ選べる・版の欄の「別の商品と共通」）。p.sharedPlate / p.tierQty
               ・その箇所は版代なし。印刷代は「ほかの商品と合わせた合計枚数」（tierQty）の単価で表示（請求はHulkAppsが同じ印刷代の商品を合計して割引）
               ・2026-10-26：名前を「ほかと同じ版」に変更。同じ商品のほかの印刷箇所（左胸と背面が同じデザイン・大きさ・色など）にも使う。
                 そのときは tierQty は空欄のまま（印刷代はこの商品の枚数の単価）。見積りページの「ほかと同じ版」からも引き継ぐ
   2026-10-26：商品ページの担当者モードでも追加料金を入れられる（備考欄の下・initStaffFeeBox）。お客様用URLにも入る
   2026-10-26：シルクの設定の枠の上に「写真・グラデーション・4色以上はできません」の注意書き
   2026-10-27：お客様用URLの一覧で、チェックを入れてまとめて削除できる（「注文済みを選ぶ」もある）
               ・注文済みのお客様に「注文済み #D〇〇〇〇」を出す（rafees-congestion の list が order を返す）
               ・お客様用URLから入れた本体の商品に「_op_お客様用URL」（URLの〇〇）を残す（注文済みかどうかを見るため）
   2026-10-27：お客様用URLに、同じ商品を別のデザインで入れられる（担当者パネル「同じ商品を別のデザインとして追加」）
               ・e.cur＝このページで読み込み中・追加した商品の番号。「置き換え」と保存はその商品だけを直す
               ・お客様の画面では「デザイン1・2…」と出し、カートに入れると同じ商品ページを開き直して次のデザインを読み込む
               ・印刷代は今まで通り、カートで同じ印刷代の商品がまとまり、合計枚数で割引される
   2026-10-27：お客様用URLで、ほかの商品・デザインに「同じ箇所の順番・同じ色数」のシルクがあるときは、
               注文ページの印刷代も合計枚数の単価で出す（カートでまとまって合計枚数の単価になるのと合わせる）。
               window.__odpSilkMergeQty(p)＝ほかの商品・デザインの枚数。印刷代の下に「合計〇枚の単価」と出す
   2026-10-23：自動お見積りでシルクのインクの色を選べるようにした（placement.inks で引き継ぐ）。全部選んであれば「インクの色を選んでください」を出さない */
const TF = window.TF_DATA || {};

/* =======================================================================
   T-shirt Order Flow – size as line-item property  (2025-06-21 rev)
   ======================================================================= */
(function () {
  // ★二重読み込み防止（これが無いとイベント多重で壊れやすい）
if (window.__tshirtFlowLoaded) return;
  window.__tshirtFlowLoaded = true;
  /* ★ 商品ごとに非表示にするステップID（Liquidメタフィールド由来） */
  const HIDE_STEPS = TF.HIDE_STEPS || [];
  const SHOW_PRINT_SIDES = TF.SHOW_PRINT_SIDES;
  const SKIP_PROOF_IMAGE = TF.SKIP_PROOF_IMAGE === true;
  if (!SHOW_PRINT_SIDES && !HIDE_STEPS.includes('step-print-sides')) {
    HIDE_STEPS.push('step-print-sides');
  }
  /* ★追加：データ作成の依頼有無（STEP7）を全商品で非表示にする。戻すときは false に */
  const HIDE_DESIGN_REQUEST = true;
  if (HIDE_DESIGN_REQUEST && !HIDE_STEPS.includes('step-design-request')) {
    HIDE_STEPS.push('step-design-request');
  }
  const isHiddenStep = (id) => Array.isArray(HIDE_STEPS) && HIDE_STEPS.includes(id);




  /* ──────────── 固定定数 ──────────── */
const SIZE_LIST = TF.SIZE_LIST;

/* ===== メーカー在庫（custom.stock / #tshirt-stock-data） ===== */
const _stockEl = document.getElementById('tshirt-stock-data');
let STOCK_DATA = null;
try { STOCK_DATA = _stockEl ? JSON.parse(_stockEl.textContent) : null; } catch(e){ STOCK_DATA = null; }
const STOCK_MAP = (STOCK_DATA && STOCK_DATA.c) ? STOCK_DATA.c : null;
const COLOR_ALIAS = {
  'スミ':'SUMI','バナナ':'BANANA','ダークブラウン':'D ブラウン',
  'ライトブルー':'Lブルー','ライトピンク':'Lピンク','ライトグレー':'L グレー',
  'バーガンディー':'バーガンディ','サンドカーキー':'サンドカーキ',
  'アシッドカーキー':'アシッドカーキ','OX グレー':'OX Gray',
  'ナチュラル/ライトグレー':'ﾅﾁｭﾗﾙ/Lｸﾞﾚｰ'   /* 1460-01 配色（在庫データは半角カナ表記） */
};
const LOW_STOCK_THRESHOLD = 100;
const normColor = (s) => (s||'').normalize('NFKC').replace(/[\s\u3000]/g,'').toUpperCase();
/* サイズ表記のゆらぎ候補を返す（在庫データに実在する方に当てる）
   例: '3XL'→['3XL','3L'] / 'XL'→['XL','LL'] / '100'→['100','100CM']
   メーカーで体系が違う（UA=XL系/cm無し, PS・glimmer=L系/cm付き, XL⇔LLは排他）ため両対応にする */
const sizeVariants = (size) => {
  const n = normColor(size);
  const out = [n];
  const m = n.match(/^(\d)XL$/);
  if (m) out.push(m[1] + 'L');          /* 3XL→3L */
  if (n === '2XL')  out.push('XXL');
  if (n === 'XXL')  out.push('2XL');
  if (n === 'XXXL') out.push('3XL', '3L');
  if (n === 'XL')   out.push('LL');     /* XL⇔LL（排他表記） */
  if (n === 'LL')   out.push('XL');
  if (/^\d{2,3}$/.test(n))   out.push(n + 'CM');       /* 100→100CM */
  if (/^\d{2,3}CM$/.test(n)) out.push(n.replace('CM','')); /* 100CM→100 */
  return [...new Set(out)];
};
function getColorStock(color){
  if (!STOCK_MAP) return { found:false, noData:true };
  if (STOCK_MAP[color]) return { found:true, sizes:STOCK_MAP[color] };
  const al = COLOR_ALIAS[color];
  if (al && STOCK_MAP[al]) return { found:true, sizes:STOCK_MAP[al] };
  /* ★修正：読み替え後の名前も半角・全角をそろえて照合（在庫データは半角カナ表記のため） */
  const nc = normColor(color);
  const na = al ? normColor(al) : '';
  for (const k of Object.keys(STOCK_MAP)){
    const nk = normColor(k);
    if (nk === nc || (na && nk === na)) return { found:true, sizes:STOCK_MAP[k] };
  }
  return { found:false };
}
function getSizeStock(color, size){
  const cs = getColorStock(color);
  if (cs.noData) return { status:'unknown' };
  if (!cs.found) return { status:'discontinued' };
  let entry = cs.sizes[size];
  if (!entry){
    /* 在庫側キーを正規化した辞書を作り、onday側サイズのゆらぎ候補を順に試す */
    const keyMap = {};
    for (const k of Object.keys(cs.sizes)) keyMap[normColor(k)] = cs.sizes[k];
    for (const cand of sizeVariants(size)){
      if (keyMap[cand]){ entry = keyMap[cand]; break; }
    }
  }
  if (!entry) return { status:'discontinued' };
  const qty = Number(entry[0]) || 0;
  const eta = entry[1] || '';
  if (qty <= 0) return { status:'soldout', qty:0, eta };
  if (qty <= LOW_STOCK_THRESHOLD) return { status:'low', qty, eta };
  return { status:'ok', qty, eta };
}
function fmtEta(eta){
  if (!eta) return '';
  const m = String(eta).match(/(\d{4})\/(\d{1,2})\/(\d{1,2})/);
  return m ? `${Number(m[2])}月${Number(m[3])}日` : eta;
}

// ここ追加（ゆれ対応）
const WHITE_COLOR_NAMES = ['ホワイト', '白', 'WHITE', 'White'];
const WHITE_COLOR_NAME  = WHITE_COLOR_NAMES[0]; // 互換用（updateSummaryが参照しても落ちない）
const INKJET_WHITE_INK_VARIANT = null; // 追加商品をカートに入れない


  /* 追加料金 SKU（必要に応じて書き換え） */
/* ¥220：追加料金：XXlサイズ / ¥330：追加料金：XXXlサイズ */
const SURCHARGE_VARIANTS = {
  XXL:   51597236306199,  // ¥220
  '2XL': 51597236306199,  // ¥220
  XXXL:  51597236404503,  // ¥330（旧：XXLのIDが入っていた）
  '3XL': 51597236404503,  // ¥330
  '4XL': 51597236404503,  // ¥330
  '5XL': 51597236404503,  // ¥330
  '6XL': 51597236404503,  // ¥330
  '7XL': 51597236404503,  // ¥330
};

/* ★追加：サイズ表記ゆれ（全角・空白・L系）をそろえて追加料金IDを返す */
const SURCHARGE_ALIAS = {
  '3L': 'XXL',      // ¥220（要確認）
  '4L': 'XXXL',     // ¥330
  '5L': '4XL',
  '6L': '5XL',
  '7L': '6XL',
  'XXXXL': '4XL',
};
function getSurchargeVariantId(size){
  const n = String(size || '').normalize('NFKC').replace(/[\s\u3000]/g, '').toUpperCase();
  return SURCHARGE_VARIANTS[n] || SURCHARGE_VARIANTS[SURCHARGE_ALIAS[n]] || null;
}

/* お急ぎ便の追加料金用バリアント ID（¥5,500） */
const EXPRESS_FEE_VARIANT = 51612934799639;
/* 袋詰めオプション用バリアント ID（¥55/枚）★追加 */
const BAGGING_VARIANT     = 50194341331223;
/* データ作成依頼オプション用バリアントID（¥1,100 / ¥3,300 / ¥5,500） */
const DESIGN_REQUEST_VARIANTS = {
  1100: 52887471489303,
  3300: 52887470604567,
  5500: 52887471751447,
};
/* シルクスクリーン調色料（1色あたり）のバリアントID */
const CHOSYOKU_VARIANT  = 67632474882327;
/* 2026-10-22：シルクのオプション（料金用の商品） */
const SILK_SETUP_VARIANT   = 67899247984919;  /* リピートのセットアップ代（1版）1,100円：リピートが10枚以下のとき */
const SILK_CLEANING_VARIANT= 67899248017687;  /* 版の清掃代 1,100円（1版）：リピートでインクの色を変える・20枚以下のとき */
const SILK_SPECIAL_VARIANT = 67899248050455;  /* 特殊インク（蓄光・クラック）110円／枚 */
const SILK_SPECIAL_NAMES   = { glow: '蓄光', crack: 'クラック' };
/* 2026-10-22：担当者が自動お見積りで入れた追加料金（お見積りページから引き継ぐ） */
var STAFF_FEES = null;
function normStaffFees(x){
  if (!x || typeof x !== 'object') return null;
  const n = (v) => { const k = parseInt(v, 10); return k > 0 && k <= 9999 ? k : 0; };
  const dz = parseInt(x.design, 10);
  const f = { setup: n(x.setup), cleaning: n(x.cleaning), special: n(x.special), memo: String(x.memo || '').slice(0, 300),
              design: [1100, 3300, 5500].includes(dz) ? dz : 0 };
  const ex = parseInt(x.express, 10);
  f.express = [3300, 5500, 11000].includes(ex) ? ex : 0;   /* 2026-10-26：特急料金 */
  /* 2026-11-02：担当者が決めた出荷予定日・お届け日（YYYY-MM-DD） */
  const ymdOk = (v) => /^\d{4}-\d{2}-\d{2}$/.test(String(v || '')) ? String(v) : '';
  f.ship = ymdOk(x.ship);
  f.wish = ymdOk(x.wish);
  return (f.setup || f.cleaning || f.special || f.memo || f.design || f.express || f.ship || f.wish) ? f : null;
}
/* 2026-11-02：担当者が決めた出荷予定日・お届け日（Date か null） */
function staffDate(k){
  const v = STAFF_FEES && STAFF_FEES[k];
  if (!v) return null;
  const p = String(v).split('-').map(Number);
  return p.length === 3 ? new Date(p[0], p[1] - 1, p[2]) : null;
}
/* 追加料金の内訳 [{label, qty, variant}] */
function staffFeeLines(){
  const f = STAFF_FEES;
  if (!f) return [];
  const out = [];
  if (f.setup)    out.push({ label: `セットアップ代 × ${f.setup}回`, qty: f.setup, variant: SILK_SETUP_VARIANT });
  if (f.cleaning) out.push({ label: `版の清掃代 × ${f.cleaning}回`, qty: f.cleaning, variant: SILK_CLEANING_VARIANT });
  if (f.special)  out.push({ label: `特殊インク × ${f.special}枚`, qty: f.special, variant: SILK_SPECIAL_VARIANT });
  if (f.design && DESIGN_REQUEST_VARIANTS[f.design]) out.push({ label: `データ作成費 ${f.design.toLocaleString()}円`, qty: 1, variant: DESIGN_REQUEST_VARIANTS[f.design], design: true });
  /* 2026-10-26：特急料金。カスタム商品（5,500／3,300／1,100円）を組み合わせて金額にする（例：11,000円＝5,500円×2） */
  if (f.express){
    let rest = f.express;
    [5500, 3300, 1100].forEach(u => {
      const q = Math.floor(rest / u);
      if (q > 0 && DESIGN_REQUEST_VARIANTS[u]){ out.push({ label: `特急料金 ${f.express.toLocaleString()}円` + (q > 1 ? `（${u.toLocaleString()}円×${q}）` : ''), qty: q, variant: DESIGN_REQUEST_VARIANTS[u], express: true }); rest -= q * u; }
    });
  }
  return out;
}
/* プルダウン表示用の金額（実際の請求額はShopifyの商品価格） */
const CHOSYOKU_UNIT_YEN = 1500;




/* 🔻ここに追記 ─────────────────────────────── */
/* 版代（シルクスクリーン専用） */
const SILK_PLATE_VARIANTS = {
  WP:     51597239091479,   // 12×12cm（ワンポイント）
  '20x27':51597239189783,   // 20×28cm 
  '34x40':51597239255319    // 34×40cm
};

/* ★追加：印刷箇所の上限（4箇所目まで） */
const MAX_PLACES = 4;

/* ★追加：大判プリント（「センター ラージサイズ W34×H40」の箇所だけ選べる）
   ・DTF／インクジェット：大の加工代に「大判追加料金」を加算（1〜19枚 ¥1,100／20枚〜 ¥880）
   ・シルク：版代は特大版 ¥8,800（1色1版）、印刷代は通常の2割増 → 差額を「大判加算」で請求 */
const LARGE_FEE_VARIANTS = { under20: 67877001232663, over20: 67877001265431 };
const LARGE_FEE_YEN      = { under20: 1100, over20: 880 };
const SILK_PLATE_XL_VARIANT = 67877001298199;
const SILK_LARGE_ADD_VARIANTS = {
  1: { 10: 67877001330967, 20: 67877001363735, 30: 67877001396503, 40: 67877001429271, 50: 67877001462039, 100: 67877001494807 },
  2: { 10: 67877001527575, 20: 67877001560343, 30: 67877001593111, 40: 67877001625879, 50: 67877001658647, 100: 67877001691415 },
  3: { 10: 67877001724183, 20: 67877001756951, 30: 67877001789719, 40: 67877001822487, 50: 67877001855255, 100: 67877001888023 },
};
const SILK_LARGE_ADD_YEN = {
  1: { 10: 100, 20: 80,  30: 70,  40: 60,  50: 50,  100: 30 },
  2: { 10: 190, 20: 150, 30: 130, 40: 110, 50: 100, 100: 60 },
  3: { 10: 280, 20: 220, 30: 190, 40: 160, 50: 140, 100: 90 },
};
function silkLargeBand(q){
  q = Number(q) || 0;
  return q >= 100 ? 100 : q >= 50 ? 50 : q >= 40 ? 40 : q >= 30 ? 30 : q >= 20 ? 20 : q >= 10 ? 10 : 0;
}
function largeFeeKey(q){ return (Number(q) || 0) >= 20 ? 'over20' : 'under20'; }
/* 大判を選べる箇所か（ジップパーカーの前面はファスナーがあるため対象外） */
function isLargeEligible(p){
  if (!p) return false;
  if (!/ラージサイズ\s*W\s*34\s*×\s*H\s*40/.test(p.label || '')) return false;
  if (typeof PLACEMENT_PROFILE_KEY !== 'undefined' && PLACEMENT_PROFILE_KEY === 'zip_hoodie_cotton' && p.side === 'front') return false;
  return true;
}
/* ─────────────────────────────────────────── */
/* ↓↓↓【ここから新規追加】↓↓↓ */

// ✅ シルク系判定（silk_1 / silk_2 / silk_3 を全部シルク扱い）
const isSilk = (m) => /^silk(_\d+)?$/.test(m || '');

// ✅ 料金テーブルやバリアント表が "silk" キー前提なら正規化して使う
const baseMethod = (m) => (isSilk(m) ? 'silk' : (m || ''));

// ✅ シルクの色数（silk_1/2/3 → 1/2/3）を返す
const silkInkCount = (m) => {
  const mm = (m || '').match(/^silk_(\d)$/);
  if (mm) return parseInt(mm[1], 10);
  if (m === 'silk') return 1; // 予備（基本使わない想定）
  return 0;
};

// ✅ inks配列を「必要色数」に合わせて整形
function normalizeInksByMethod(p){
  const n = silkInkCount(p.method);
  if (!n) { p.inks = []; return; }

  const uniq = [];
  (p.inks || []).forEach(k => { if (k && !uniq.includes(k)) uniq.push(k); });
  p.inks = uniq.slice(0, n);
}





/* ① プリント面積を 4 種に正規化するヘルパー（差し替え） */
const detectAreaKey = (label='') => {
  label = (label || '').toString();

  // ワンポイント系（W10×H10 / W10×H7 / W7×H7 などもまとめてWP）
  if (label.includes('ワンポイント')) return 'WP';
  // ★ 7x7, 10x7, 10x10 を WP 扱い（縦横入れ替えもOK）
  if (/W\s*(7|10)\s*[×xX]\s*H\s*(7|10)/.test(label)) return 'WP';

  // 「W20×H27」みたいな表記を拾う
  const m = label.match(/W\s*(\d+)\s*[×xX]\s*H\s*(\d+)/);
  if (m){
    const w = parseInt(m[1], 10);
    const h = parseInt(m[2], 10);
    const max = Math.max(w,h);
    const min = Math.min(w,h);

    // ★ 34x40 に寄せたい特殊サイズ（縦横どっちでも）
    // W8×H34 / W34×H34 / W14×H38 → 34x40
    if (
      (max === 34 && (min === 8  || min === 34)) ||
      (max === 38 &&  min === 14)
    ) return '34x40';

    // （既存）W34×H16 を 34x40 扱い
    if (max === 34 && min === 16) return '34x40';

    // 20×27相当
    if (max <= 28 && min <= 20) return '20x27';

    // 34×40相当（← 28×40 より先に置くと「だいたい全部34」に寄るので注意）
    // ここは「ラージ領域」を広めに取りたいときだけ使う
    if (max <= 40 && min <= 34 && max >= 34) return '34x40';

    // 28×40相当
    if (max <= 40 && min <= 28) return '28x40';

    // 最後の保険
    if (max <= 40 && min <= 34) return '34x40';
  }

  // 文言だけで判定したい保険（ラージ/レギュラー）
  if (label.includes('ラージ')) return '34x40';
  if (label.includes('レギュラー')) return '20x27';

  return '';
};



/* ② 面・面積ごとにバリエーション ID を即座に取り出す 2 行だけの関数 */
const getFrontVariantId = (m,a) => PRINT_VARIANTS?.[m]?.front?.[a]||0;
const getBackVariantId  = (m,a) => PRINT_VARIANTS?.[m]?.back?.[a] || 0;

/* ③ 全プリント方法×面×面積のマッピング */
const PRINT_VARIANTS = {
  omakase: {              // おまかせプリント
    front: {
      WP: 50207766511895,
      '20x27': 50207783911703,
      '28x40': 50207792431383,
      '34x40': 50207794561303,
    },
    back: {
      WP: 50207816679703,
      '20x27': 50207818449175,
      '28x40': 50207818678551,
      '34x40': 50207819333911,
    },
  },
  dtf: {                  // DTFプリント
    front: {
      WP: 50192416964887,
      '20x27': 50194285494551,
      '28x40': 50194330288407,
      '34x40': 50194332516631,
    },
    back: {
      WP: 50192416964887,
      '20x27': 50194285494551,
      '28x40': 50194330288407,
      '34x40': 50194332516631,
    },
  },
  inkjet: {               // インクジェット
    front: {
      WP: 50203150909719,
      '20x27': 50203151139095,
      '28x40': 50203151434007,
      '34x40': 50203151630615,
    },
back: {
      WP: 50203150909719,
      '20x27': 50203151139095,
      '28x40': 50203151434007,
      '34x40': 50203151630615,
    },
  },

};



/* ===== 追加プリント（2/3箇所目）用バリアントID =====
   構造：EXTRA_PRINT_VARIANTS[method][side][areaKey][placeNo]
   placeNo: 2 or 3
*/
const EXTRA_PRINT_VARIANTS = {
  dtf: {
    WP:     { 2: 51801462440215, 3: 51801514049815, 4: 67877094457623 },
    '20x27':{ 2: 51801734545687, 3: 51801735135511, 4: 67877096292631 },
    '28x40':{ 2: null, 3: null },
    '34x40':{ 2: 51801735659799, 3: 51801737101591, 4: 67877096620311 },
  },
  inkjet: {
    WP:     { 2: 51801746374935, 3: 51801747390743, 4: 67877096849687 },
    '20x27':{ 2: 51801748373783, 3: 51801748635927, 4: 67877097079063 },
    '28x40':{ 2: null, 3: null },
    '34x40':{ 2: 51801749061911, 3: 51801750896919, 4: 67877097603351 },
  },
  silk: {
    WP:     { 2: null, 3: null },
    '20x27':{ 2: null, 3: null },
    '28x40':{ 2: null, 3: null },
    '34x40':{ 2: null, 3: null },
  },
};


/* ===== シルクスクリーン：箇所 × 色数 → variantId =====
   index: 0=1箇所目 / 1=2箇所目 / 2=3箇所目
*/
const SILK_COLOR_VARIANTS = {
  0: { // 1箇所目
    1: 51804179595543, // 1色
    2: 51804185690391, // 2色
    3: 51804200534295, // 3色
  },
  1: { // 2箇所目
    1: 51804182479127,
    2: 51804195029271,
    3: 51804205089047,
  },
  2: { // 3箇所目
    1: 51804182806807,
    2: 51804196765975,
    3: 51804206760215,
  },
  3: { // 4箇所目（★追加）
    1: 67877097898263,
    2: 67877098455319,
    3: 67877098815767,
  },
};
/* ===== シルク判定：silk_1/2/3 でも true にする ===== */
function isSilkMethod(method){
  return typeof method === 'string' && method.indexOf('silk') === 0; // 'silk', 'silk_1', 'silk_2', 'silk_3'
}

/* ===== この箇所(idx)の色数を取得：inks[] の選択数ベース =====
   - 0..3 を返す（未選択なら 0）
*/
function getSilkColorCount(placements, idx){
  const p = placements?.[idx];
  if (!p || !isSilkMethod(p.method)) return 0;

  const n = Array.isArray(p.inks) ? p.inks.filter(Boolean).length : 0;
  // 念のため 1..3 に丸める（0は0のまま）
  return Math.max(0, Math.min(3, n));
}

/* ===== 箇所×色数 → variantId を返す（無ければ null） ===== */
function getSilkVariantIdByPlacement(placements, idx){
  const colors = getSilkColorCount(placements, idx);
  if (colors < 1) return null;
  return SILK_COLOR_VARIANTS?.[idx]?.[colors] ?? null;
}







/* ==== ▼▼ 印刷代テーブル（税込・円） ▼▼ ==== */
const PRINT_PRICE_TABLE = {
  /* ― おまかせプリント（転写紙） ― */
  omakase: {
    WP:     [[4, 850],[19,650],[29,550],[49,450],[99,390]],
    '20x27':[[4,1000],[19,850],[29,750],[49,550],[99,470]],
    '28x40':[[4,1200],[19,1100],[29,900],[49,800],[99,700]],
    '34x40':[[4,1300],[19,1150],[29,950],[49,880],[99,800]],
  },




/* ― DTF（新表） ― */
dtf: {
  // 小（10×10cm）→ WP 扱い
  WP: [
    [4, 1200],
    [9, 1050],
    [19, 900],
    [29, 700],
    [49, 500],
    [99, 450],
    [999999, 390], // 100〜
  ],

  // 中（20×27cm）
  '20x27': [
    [4, 1400],
    [9, 1350],
    [19, 1200],
    [29, 1000],
    [49, 750],
    [99, 600],
    [999999, 550], // 100〜
  ],

  // 28×40：画像の表に無いので“仮”のまま（あとで決めて差し替え）
  // いったん 34×40 と同じに寄せたいならここも同値にしてOK
  '28x40': [
    [4, 1800],
    [9, 1600],
    [19, 1300],
    [29, 1150],
    [49, 950],
    [99, 880],
    [999999, 800], // 仮：100〜
  ],

  // 大（34×40cm）
  '34x40': [
    [4, 1800],
    [9, 1600],
    [19, 1300],
    [29, 1150],
    [49, 950],
    [99, 880],
    [999999, 800], // 100〜
  ],
},















/* ― インクジェット（白インク有無を統合） ― */
inkjet: {
  WP: [
    [4, 1480],
    [9, 1280],
    [19, 980],
    [29, 680],
    [49, 600],
    [99, 550],
    [999999, 490], // 100〜
  ],
  '20x27': [
    [4, 1880],
    [9, 1580],
    [19, 1380],
    [29, 1180],
    [49, 1080],
    [99, 880],
    [999999, 850], // 100〜
  ],
  // 表に無いので一旦34x40同値（後で表が出たら差し替え）
  '28x40': [
    [4, 2480],
    [9, 2180],
    [19, 1980],
    [29, 1480],
    [49, 1280],
    [99, 1100],
    [999999, 990], // 100〜
  ],
  '34x40': [
    [4, 2480],
    [9, 2180],
    [19, 1980],
    [29, 1480],
    [49, 1280],
    [99, 1100],
    [999999, 990], // 100〜
  ],
},

/* 旧キー互換（既存ロジックがinkjetColor/inkjetWhite参照でも壊れないように同値で残す） */
inkjetColor: null,
inkjetWhite: null,

  /* ― シルクスクリーン（1カラー） ― */
  silk: {
    // ワンポイント（12×12cm以内）
    WP: [
      [49, 200],   // 30～49枚 → 200円
      [99, 150],   // 50～99枚 → 150円
      [299,  80],  // 100～299枚 → 80円
      [999,  60],  // 300～999枚 → 60円
    ],
    // 20×28cm以内
    '20x27': [
      [49, 300],
      [99, 200],
      [299,100],
      [999, 70],
    ],
    '28x40':[ [49,400],[99,250],[299,120],[999,80] ],
    // 34×40cm以内
    '34x40': [
      [49, 400],
      [99, 250],
      [299,120],
      [999, 80],
    ],
  },
};

// ✅ここが正しい場所（オブジェクト定義の外）
PRINT_PRICE_TABLE.inkjetColor = PRINT_PRICE_TABLE.inkjet;
PRINT_PRICE_TABLE.inkjetWhite = PRINT_PRICE_TABLE.inkjet;

/* ― シルクスクリーンのプリント代（色数ごとの合計単価・円/枚）
     枚数帯：10-19 / 20-29 / 30-39 / 40-49 / 50-99 / 100- ― */
const SILK_UNIT_TABLE = {
  '10':  { 1: 500, 2: 950,  3: 1400 },
  '20':  { 1: 400, 2: 750,  3: 1100 },
  '30':  { 1: 350, 2: 650,  3: 950  },
  '40':  { 1: 300, 2: 550,  3: 800  },
  '50':  { 1: 250, 2: 480,  3: 710  },
  '100': { 1: 160, 2: 300,  3: 440  },
};

/* シルク特大版の版代（表示用。請求は SILK_PLATE_XL_VARIANT の価格） */
let SILK_PLATE_XL_YEN = 8800;

/* =========================================================
   2026-10-21：料金データ（ショップのメタフィールド custom.print_prices）
   snippets/odp-print-prices が window.ODP_PRINT_PRICES に出したものがあれば、
   上の表（PRINT_PRICE_TABLE・SILK_UNIT_TABLE・LARGE_FEE_YEN・SILK_LARGE_ADD_YEN）を上書きする。
   データが無い・形がおかしい項目は、上の表（今の料金）のまま。
   ※請求額は Shopify の印刷代の商品価格＋HulkAppsの割引。料金を変えたら両方直すこと
   ========================================================= */
(function applyOdpPrintPrices(){
  const pp = window.ODP_PRINT_PRICES;
  if (!pp || typeof pp !== 'object') return;

  /* DTF・インクジェット：[1,5,10,20,30,50,100] → [[4,円],[9,円],…,[999999,円]] */
  if (Array.isArray(pp.tiers) && pp.dtf && pp.ij){
    const toTable = (arr) => arr.map((price, i) => [i < pp.tiers.length - 1 ? pp.tiers[i + 1] - 1 : 999999, price]);
    const areaOf = { WP: 'S', '20x27': 'M', '28x40': 'L', '34x40': 'L' };
    Object.keys(areaOf).forEach((areaKey) => {
      const a = areaOf[areaKey];
      if (Array.isArray(pp.dtf[a])) PRINT_PRICE_TABLE.dtf[areaKey] = toTable(pp.dtf[a]);
      if (Array.isArray(pp.ij[a]))  PRINT_PRICE_TABLE.inkjet[areaKey] = toTable(pp.ij[a]);
    });
  }

  /* シルク：プリント代・大判加算（枚数帯 10/20/30/40/50/100 × 1〜3色） */
  if (Array.isArray(pp.silkTiers) && Array.isArray(pp.silk) && Array.isArray(pp.silkBigAdd)){
    pp.silkTiers.forEach((t, i) => {
      const band = String(t);
      if (!SILK_UNIT_TABLE[band]) return;
      [1, 2, 3].forEach((c) => {
        if (pp.silk[i] && typeof pp.silk[i][c - 1] === 'number') SILK_UNIT_TABLE[band][c] = pp.silk[i][c - 1];
        if (pp.silkBigAdd[i] && typeof pp.silkBigAdd[i][c - 1] === 'number' && SILK_LARGE_ADD_YEN[c]) SILK_LARGE_ADD_YEN[c][band] = pp.silkBigAdd[i][c - 1];
      });
    });
  }

  /* 大判追加料金（DTF・インクジェット） */
  if (typeof pp.bigAddUnder20 === 'number') LARGE_FEE_YEN.under20 = pp.bigAddUnder20;
  if (typeof pp.bigAdd20 === 'number')      LARGE_FEE_YEN.over20  = pp.bigAdd20;
  if (typeof pp.silkPlateXL === 'number')   SILK_PLATE_XL_YEN     = pp.silkPlateXL;
})();




/* ---- 面積 × 枚数で単価を返すユーティリティ ---- */
function getPrintUnitPrice(method, areaKey, qty){
  const pm = baseMethod(method);

  // inkjet / inkjetColor / inkjetWhite を全部 inkjet に寄せる
  const key =
    (pm === 'inkjet' || pm === 'inkjetColor' || pm === 'inkjetWhite')
      ? 'inkjet'
      : pm;

  const tiers = PRINT_PRICE_TABLE?.[key]?.[areaKey] || [];
  for (const [max, price] of tiers){
    if (Number(qty) <= Number(max)) return Number(price);
  }
  return tiers.length ? Number(tiers[tiers.length - 1][1]) : null;
}


/* ↑↑↑【ここまで新規追加】↑↑↑ */
const PRINT_LABEL = {
  omakase:'おまかせ',
  dtf:'DTF',
  inkjet:'インクジェット',
  silk_1:'【1色】シルクスクリーン',
  silk_2:'【2色】シルクスクリーン',
  silk_3:'【3色】シルクスクリーン',
  silk:'シルクスクリーン'
};

/* ===== 印刷サイズ（例：フロント: ワンポイント / バック: 28×40cm以内）を返す ===== */
function getPrintSizeLabel(mainSide){
  const labels = [];
  if (mainSide !== 'back'){                     // フロント面を使うとき
    const front = document
      .querySelector('#plc-front .plc-box.is-selected p')
      ?.textContent.trim();
   if (front) labels.push(`フロント: ${front}`);
  }
 if (mainSide !== 'front'){                    // バック面を使うとき
    const back = document
      .querySelector('#plc-back  .plc-box.is-selected p')
     ?.textContent.trim();
    if (back)  labels.push(`バック: ${back}`);
  }
  return labels.join(' / ');
}
const PLACEMENT_PROFILE_KEY = TF.PLACEMENT_PROFILE_KEY || '';
function isInkjetDisabledByProfile(){
  // 商品メタフィールド custom.no_inkjet が true の商品（例：製品洗い加工の4230-01）もインクジェット不可
  if (TF.NO_INKJET === true) return true;
  return ['tshirt_dry','longtee_dry','polo','polo_pocket'].includes(PLACEMENT_PROFILE_KEY);
}
  /* Liquid 変数を受け取る */
  const variants  = TF.variants;
  const COLOR_IDX = TF.COLOR_IDX;
  const PRINT_OPT_IDX = TF.PRINT_OPT_IDX;

  /* ★追加：カラー＋印刷面 → variantId のマップ
     ※ PRINT_OPT_IDX < 0（印刷オプション無し商品）の場合は構築しない */
  const VARIANT_BY_COLOR_PRINT = {};
  if (PRINT_OPT_IDX >= 0) {
    variants.forEach(v => {
      const color = v.options[COLOR_IDX];
      if (!VARIANT_BY_COLOR_PRINT[color]) VARIANT_BY_COLOR_PRINT[color] = {};
      const printVal = (v.options[PRINT_OPT_IDX] || '').toString();
      const sideKey  = printVal.includes('両面') ? 'both' : 'one';
      VARIANT_BY_COLOR_PRINT[color][sideKey] = v.id;
    });
  }

  /* ★追加：現在の印刷面に応じた variantId を返す */
  function getVariantIdByColor(color){
    // 印刷オプション無し商品（Tシャツ等）は従来動作と完全一致
    if (PRINT_OPT_IDX < 0) {
      const v = variants.find(v => v.options[COLOR_IDX] === color);
      return v ? v.id : '';
    }
    // 印刷オプション有り商品：現在の印刷面に対応するID
    const side = document.getElementById('print_sides_input')?.value || 'one';
    const map  = VARIANT_BY_COLOR_PRINT[color];
    if (!map) {
      const v = variants.find(v => v.options[COLOR_IDX] === color);
      return v ? v.id : '';
    }
    return map[side] || map.one || map.both;
  }

  /* ★追加：サイズの選択肢がある商品（トート等）は 色＋サイズ でバリエーションを返す */
  const SIZE_OPT_IDX = (typeof TF.SIZE_OPT_IDX === 'number') ? TF.SIZE_OPT_IDX : -1;
  function getVariantIdByColorSize(color, size){
    if (SIZE_OPT_IDX < 0) return getVariantIdByColor(color);
    const v = variants.find(v =>
      v.options[COLOR_IDX] === color && String(v.options[SIZE_OPT_IDX]) === String(size)
    );
    return v ? v.id : '';
  }
  /* ──────────── 状態保持 ──────────── */
  let currentColor = '';                       // いま編集中のカラー
  const cartSelections = {};                   // key → {variantId,size,qty}

  /* ──────────── ヘルパー ──────────── */
  const colorOfVariant = id => {
    const v = variants.find(v => v.id == id);
    return v ? v.options[COLOR_IDX] : '';
  };

  const sumByColor = color =>
    Object.values(cartSelections)
      .filter(item => colorOfVariant(item.variantId) === color)
      .reduce((t,item) => t + item.qty, 0);

  const refreshSwatch = color => {
    const sw = document.querySelector(`.color-swatch[data-color="${color}"]`);
    if (!sw) return;
    const total = sumByColor(color);

    let badge = sw.querySelector('.color-total');
    if (!badge){
      badge = document.createElement('span');
      badge.className = 'color-total';
      sw.appendChild(badge);
    }
    badge.textContent = total ? `計 ${total} 枚` : '';
    sw.classList.toggle('is-active', total>0);
  };

  /* =====================================================================
     DOM 準備
     ===================================================================== */
document.addEventListener('DOMContentLoaded', () => {
      // ★サマリー要素が無い/取得できないと以後全部無意味なので即ガード
  const summaryBox = document.getElementById('order-summary');
  if (!summaryBox) {
    console.error('[tshirt-flow] #order-summary が見つかりません');
    return;
  }

  // ★初期表示（何も選ばれてなくても「枠だけは出す」）
  summaryBox.style.display = 'block';
  summaryBox.innerHTML = `
    <div class="order-summary__title">ご注文内容確認</div>
    <div class="order-summary__row">
      <span class="order-summary__label">現在の選択状況:</span>
      まだサイズ・枚数が選択されていません。
    </div>
  `;

    /* ★追加：モーダルを body 直下へ移動（親要素の重なり順の影響で、ヘッダーより下に表示されてしまうため） */
    ['modal-color', 'modal-size', 'modal-placement'].forEach(id => {
      const m = document.getElementById(id);
      if (m && m.parentElement !== document.body) document.body.appendChild(m);
    });

    /* ★ 非表示ステップ処理＋デフォルト値セット */
    HIDE_STEPS.forEach(id => {
      const el = document.getElementById(id);
      if (el) el.classList.add('is-hidden');
    });
    if (isHiddenStep('step-order-type')) {
      const inp = document.getElementById('order_type_input');
      if (inp) inp.value = 'print';
    }
if (isHiddenStep('step-bagging')) {
      const inp = document.getElementById('bagging_input');
      if (inp) inp.value = 'none';
    }
    /* ★追加：データ作成依頼を非表示にしている間は「不要」扱い */
    if (isHiddenStep('step-design-request')) {
      const inp = document.getElementById('design_request_input');
      if (inp) inp.value = 'no';
      const sel = document.getElementById('design_request_select');
      if (sel) sel.value = 'no';
    }

    /* ★追加: 完成イメージ送付スキップ商品の処理 */
    if (SKIP_PROOF_IMAGE) {
      const stepContact = document.getElementById('step-contact');
      if (stepContact) stepContact.classList.add('skip-proof');
      const cmHidden = document.getElementById('contact_method_input');
      if (cmHidden) cmHidden.value = 'none';
    }


    
/* ★ 表示中STEPの番号を1から振り直す（関数化して再実行できるように） */
    function renumberVisibleSteps(){
      const visibleSteps = document.querySelectorAll('#tshirt-order-flow .tshirt-step:not(.is-hidden)');
      visibleSteps.forEach((step, i) => {
        const ribbon = step.querySelector('.step-ribbon');
        if (ribbon) ribbon.innerHTML = `STEP&nbsp;${i + 1}`;
      });
    }
    window.__renumberVisibleSteps = renumberVisibleSteps;
    renumberVisibleSteps();



/* =========================================================
   新：加工位置（最大3箇所）+ 箇所ごとのプリント方法/インクカラー
   ========================================================= */
const plcSelectedInput = document.getElementById('plc_selected_json');
const pmSelectedWrap   = document.getElementById('pm-selected');
let pmBoxes = [];


/* 既存の detectAreaKey を使う（あなたのコードに既にある） */

/* 1箇所 = {id, side, label, areaKey, method, inks[]} */
let placements = [];

/* ===== ★追加：入稿データ（印刷箇所ごとに保持） =====
   キー＝印刷箇所（面＋加工位置名）。印刷箇所を選び直しても、同じ箇所に入れたファイルは残る */
const UPLOAD_ALL_KEY = '__all';     // 「まとめ・その他」欄
const uploadedFiles  = {};          // キー → { url, name }
const uploadingKeys  = new Set();   // アップロード中のキー

/* ===== ★追加：アップロード済みデータの使い回し（同じデザインを別商品でも使う） =====
   このブラウザでアップロードしたデータを localStorage に控えておき、
   別の商品ページでも「前のデータから選ぶ」で同じURLを使えるようにする。
   同じデータには同じ「デザイン番号」が付くので、注文を見る側は番号だけで同一デザインと分かる */
const UPL_LIB_KEY  = 'odp_upload_library_v1';
const UPL_LIB_DAYS = 30;     // 保存日数
const UPL_LIB_MAX  = 20;     // 保存件数
const uplLibOpen   = new Set();   // 「前のデータから選ぶ」を開いている欄

function uplLibLoad(){
  try{
    const list = JSON.parse(localStorage.getItem(UPL_LIB_KEY) || '[]');
    const limit = Date.now() - UPL_LIB_DAYS * 864e5;
    return Array.isArray(list) ? list.filter(x => x && x.url && x.no && (x.ts || 0) > limit) : [];
  }catch(e){ return []; }
}
function uplLibSave(list){
  try{ localStorage.setItem(UPL_LIB_KEY, JSON.stringify(list.slice(0, UPL_LIB_MAX))); }catch(e){}
}
/* アップロード完了時に控える。戻り値＝デザイン番号（中身が同じ＝hash一致なら同じ番号） */
function uplLibAdd(url, name, hash){
  const list = uplLibLoad();
  const hit  = list.find(x => x.url === url || (hash && x.hash === hash));
  if (hit){ hit.ts = Date.now(); uplLibSave(list); return hit.no; }
  const no = list.reduce((m, x) => Math.max(m, x.no || 0), 0) + 1;
  list.unshift({ url, name, no, hash: hash || '', ts: Date.now() });
  uplLibSave(list);
  return no;
}
/* 中身が同じデータを控えから探す */
function uplLibFindByHash(hash){
  if (!hash) return null;
  return uplLibLoad().find(x => x.hash === hash) || null;
}
/* ファイルの中身から指紋（SHA-256）を作る。使えない環境では '' */
async function uplFileHash(file){
  try{
    if (!window.crypto || !crypto.subtle) return '';
    const buf = await crypto.subtle.digest('SHA-256', await file.arrayBuffer());
    return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
  }catch(e){ return ''; }
}
function designLabel(no){
  if (!no) return '';
  const circled = ['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫','⑬','⑭','⑮','⑯','⑰','⑱','⑲','⑳'];
  return 'デザイン' + (circled[no - 1] || `No.${no}`);
}
function uplFmtDate(ts){
  const d = new Date(ts || 0);
  return isNaN(d) ? '' : `${d.getMonth() + 1}/${d.getDate()}`;
}

function uplEsc(s){
  return String(s == null ? '' : s).replace(/[&<>"']/g, c => (
    { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]
  ));
}

/* 加工位置を選ぶ商品か（選ばない商品は従来どおり ファイル01〜03 の3欄） */
function uplUsePlacements(){
  return !isHiddenStep('step-placement');
}

/* いま出すアップロード欄の一覧（印刷箇所の数だけ ＋ まとめ・その他） */
function getUploadSlots(){
  if (!uplUsePlacements()){
    return [1, 2, 3].map(n => ({
      key: `file${n}`,
      badge: `ファイル0${n}`,
      title: '',
      img: '',
      propKey: `入稿データURL_0${n}`
    }));
  }

  const slots = (Array.isArray(placements) ? placements : []).slice(0, MAX_PLACES).map((p, i) => {
    const place = `${p.side === 'front' ? '前面' : '背面'}／${p.label || ''}`;
    return {
      key: `plc|${p.side}|${p.label}`,
      badge: `${i+1}箇所目`,
      title: place,
      img: p.img || '',
      propKey: `入稿データURL_0${i+1}（${place}）`
    };
  });

  slots.push({
    key: UPLOAD_ALL_KEY,
    badge: 'まとめ・その他',
    title: '全箇所を1つにまとめたデータ／完成イメージなどの資料',
    img: '',
    propKey: '入稿データURL_まとめ・その他'
  });
  return slots;
}

/* メッセージ・サマリー用の欄の呼び名（例：1箇所目（前面／左胸 ワンポイント W10×H10）） */
function uplSlotLabel(s){
  return (s.title && s.key !== UPLOAD_ALL_KEY) ? `${s.badge}（${s.title}）` : s.badge;
}

/* カートに入れる properties（アップロード済みの欄だけ） */
function getUploadProps(){
  const out = {};
  getUploadSlots().forEach(s => {
    const f = uploadedFiles[s.key];
    if (f && f.url){
      /* 例）入稿データ_01（前面／左胸 ワンポイント）：デザイン① ロゴ.ai ＝ 同じ番号なら同じデータ */
      out[s.propKey.replace('入稿データURL_', '入稿データ_')] = `${designLabel(f.designNo)} ${f.name || ''}`.trim();
      out[s.propKey] = f.url;
    }
  });
  return out;
}

/* ★追加：お客様用URLで「入稿データ受け取り済み」になっているか（担当者がメール・LINEでデータを受け取っている） */
function uplReceivedByStaff(){
  return !!(window.__odpLinkInfo && window.__odpLinkInfo.received);
}

/* ご注文内容確認に出す「入稿データ」の内訳
   ★変更（2026-10-21）：表で出す（No は「印刷方法・印刷箇所」の表と同じ番号。デザイン番号＋ファイル名） */
function getUploadSummaryHtml(){
  const lines = [];
  getUploadSlots().forEach((s, i) => {
    const f = uploadedFiles[s.key];
    const optional = (s.key === UPLOAD_ALL_KEY) || !uplUsePlacements();
    if (!f && optional) return;   // 任意の欄は、入っているときだけ出す
    const no = (s.key === UPLOAD_ALL_KEY) ? '他' : String(i + 1);
    const body = f
      ? `<div class="os-file"><span class="os-design">${uplEsc(designLabel(f.designNo) || 'データ')}</span>` +
        `<span class="os-fname" title="${uplEsc(f.name || '')}">${uplEsc(f.name || '')}</span></div>`
      : uplReceivedByStaff()
        ? '<span style="color:#1d6b4a;font-weight:700;">受け取り済み（メール・LINE）</span>'
        : '<span class="os-none">未アップロード</span>';
    lines.push(`<tr><td class="os-n">${no}</td><td>${body}</td></tr>`);
  });
  return lines.length
    ? `<table class="os-tbl"><thead><tr><th class="os-n">No</th><th>データ</th></tr></thead><tbody>${lines.join('')}</tbody></table>`
    : '<span class="os-none">未アップロード</span>';
}

/* ===== ★追加：シルクスクリーンの調色オプション ===== */
/* シルクで選ばれている色数の合計（全箇所）＝調色できる色数の上限 */
function getSilkColorTotal(){
  return (Array.isArray(placements) ? placements : [])
    .slice(0, MAX_PLACES)
    .reduce((t, p) => t + (p ? silkInkCount(p.method) : 0), 0);
}
/* 調色する色数（無地購入・シルクなしは0） */
function getChosyokuCount(){
  if (document.getElementById('order_type_input')?.value === 'sample') return 0;
  const sel = document.getElementById('chosyoku_count_select');
  if (!sel) return 0;
  const n = parseInt(sel.value, 10) || 0;
  return Math.max(0, Math.min(n, getSilkColorTotal()));
}
/* 調色する色番号 */
function getChosyokuCode(){
  return (document.getElementById('chosyoku_code_input')?.value || '').trim();
}
/* 調色ありなら色番号の入力まで必須 */
function isChosyokuDone(){
  return getChosyokuCount() === 0 || !!getChosyokuCode();
}
/* 表示・選択肢を現在の選択に合わせる */
function syncChosyoku(){
  const wrap   = document.getElementById('chosyoku-wrap');
  const sel    = document.getElementById('chosyoku_count_select');
  const detail = document.getElementById('chosyoku-detail');
  const code   = document.getElementById('chosyoku_code_input');
  if (!wrap || !sel) return;

  const max = getSilkColorTotal();

  /* 選択肢を作り直す（上限が変わったときだけ） */
  if (sel.dataset.max !== String(max)){
    const cur = Math.min(parseInt(sel.value, 10) || 0, max);
    let html = '<option value="0">調色しない</option>';
    for (let i = 1; i <= max; i++){
      html += `<option value="${i}">${i}色を調色する（+¥${(CHOSYOKU_UNIT_YEN * i).toLocaleString()}）</option>`;
    }
    sel.innerHTML = html;
    sel.value = String(cur);
    sel.dataset.max = String(max);
  }

  const show = max > 0;
  const wasShown = wrap.style.display !== 'none';
  wrap.style.display = show ? 'block' : 'none';

  const on = show && (parseInt(sel.value, 10) || 0) > 0;
  if (detail) detail.style.display = on ? 'block' : 'none';
  if (!on && code){
    code.value = '';
    code.classList.remove('is-error');
  }

  if (wasShown !== show){
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  }
}


// ✅ 刺繍を今は無効（後で true にするだけで解放）
const ENABLE_EMBROIDERY = false;




// ▼プリント方法ごとの画像（Shopifyなら assets か Files のURLに差し替え）
const METHOD_IMAGES = {
  consult:  'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/fdsghrhjt.webp?v=1767840345',   // 担当と相談して決定
  factory:  'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/rthhytrjjk.webp?v=1767840345',   // 工場のプロにお任せ

  dtf:      'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/gfdgfghe.webp?v=1767840345',       // DTFプリント
  inkjet:   'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/thhrtherj.webp?v=1767840345',    // インクジェットプリント

  silk_1:   'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/gfurfewg.webp?v=1767840345',    // 【1色】シルクスクリーン
  silk_2:   'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/yregdsfesrhy.webp?v=1767840345',    // 【2色】シルクスクリーン
  silk_3:   'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/fsfregherh.webp?v=1767840345',    // 【3色】シルクスクリーン
  // ✅ 追加：刺繍（画像URLは仮でもOK。無ければ空でもOK）
  embroidery: 'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/25466341.webp?v=1767841462',
};

const PLACEMENT_PROFILES = {

  /* =========================
     Tシャツ DRY（添付そのまま）
  ========================= */
  tshirt_dry: {
    items: [
      // --- FRONT ---
      { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front01.jpg' },
      { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front02.jpg' },
      { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front03.jpg?v=1767850426' },

      { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front04.jpg?v=1767850427' },
      { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front05.jpg?v=1767850426' },
      { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front06.jpg?v=1767850426' },

      { side:'front', label:'左袖 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front04.jpg?v=1767850427' },
      { side:'front', label:'右袖 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front08.jpg?v=1767850427' },
      { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_front09.jpg?v=1767850427' },

      // --- BACK ---
      { side:'back', label:'首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back01.jpg?v=1767850476' },
      { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back02.jpg?v=1767850476' },
      { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back03.jpg?v=1767850476' },

      { side:'back', label:'横長 上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back04.jpg?v=1767850476' },
      { side:'back', label:'横長 中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back05.jpg?v=1767850476' },
      { side:'back', label:'横長 下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back06.jpg?v=1767850476' },

      { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back07.jpg?v=1767850476' },
      { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back08.jpg?v=1767850476' },
      { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_dry_back09.jpg?v=1767850476' },
    ]
  },

/* =========================
   Tシャツ コットン（画像テキスト準拠）
========================= */
tshirt_cotton: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front06.jpg' },

    { side:'front', label:'左そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front07.jpg', note:'※インクジェット不可' },
    { side:'front', label:'右そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front08.jpg', note:'※インクジェット不可' },
    { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tshirt_cotton_back09.jpg' },
  ]
},




  /* =========================
     ZIPパーカー コットン（画像どおり）
  ========================= */
zip_hoodie_cotton: {
  items: [
    // --- FRONT (F-1 ... F-9) ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front03.jpg', note:'※縫い目またぎ注意' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front06.jpg', note:'※縫い目またぎ注意' },

    { side:'front', label:'左そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front07.jpg', note:'※インクジェット不可' },
    { side:'front', label:'右そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front08.jpg', note:'※インクジェット不可' },
  { 
  side:'front',
  label:'センター ラージサイズ W34×H40',
  img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_front09.jpg',
  allowedMethods:['inkjet'],
  note:'※インクジェットのみ'
},


    // --- BACK (B-1 ... B-9) ---
    { side:'back', label:'フード ワンポイント W10×H7', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/zip_hoodie_cotton_back09.jpg' },
  ]
},



/* =========================
   スウェット コットン（画像テキスト準拠）
========================= */
sweat_cotton: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front06.jpg' },

    { side:'front', label:'左そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front07.jpg', note:'※インクジェット不可' },
    { side:'front', label:'右そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front08.jpg' , note:'※インクジェット不可' },
    { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/sweat_cotton_back09.jpg' },
  ]
},


/* =========================
   プルオーバーパーカー コットン（画像テキスト準拠）
========================= */
pullover_hoodie_cotton: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front06.jpg' },

    { side:'front', label:'左そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front07.jpg', note:'※インクジェット不可' },
    { side:'front', label:'右そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front08.jpg' , note:'※インクジェット不可' },
    { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'フード ワンポイント W10×H7', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/pullover_hoodie_cotton_back09.jpg' },
  ]
},


/* =========================
   ポロシャツ（ポケット付き）
========================= */
polo_pocket: {
  items: [
    // --- FRONT ---
    { side:'front', label:'ポケット上 ワンポイント W10×H7', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front02.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front05.jpg' },
    { side:'front', label:'センター ラージサイズ W34×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front06.jpg' },

    { side:'front', label:'左そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front07.jpg' },
    { side:'front', label:'右そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front08.jpg' },
    { side:'front', label:'ポケット ワンポイント W7×H7', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back09.jpg' },
  ]
},

/* =========================
   ポロシャツ（ポケットなし）
========================= */
polo: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front02.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front05.jpg' },
    { side:'front', label:'センター ラージサイズ W34×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front06.jpg' },

    { side:'front', label:'左そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front07.jpg' },
    { side:'front', label:'右そで ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_front08.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back01.jpg' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back02.jpg' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back03.jpg' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back04.jpg' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back05.jpg' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back06.jpg' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back07.jpg' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back08.jpg' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/polo_pocket_back09.jpg' },
  ]
},


/* =========================
   ロングTシャツ DRY（画像テキスト準拠）
========================= */
longtee_dry: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front06.jpg' },

    { side:'front', label:'左そで ラージプリント W14×H38', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front07.jpg', note:'※インクジェット不可' },
    { side:'front', label:'右そで ラージプリント W14×H38', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front08.jpg' , note:'※インクジェット不可' },
    { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_dry_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back01.jpg?v=2' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back02.jpg?v=2' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back03.jpg?v=2' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back04.jpg?v=2' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back05.jpg?v=2' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back06.jpg?v=2' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back07.jpg?v=2' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back08.jpg?v=2' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back09.jpg?v=2' },
  ]
},


/* =========================
   ロングTシャツ コットン（画像テキスト準拠）
========================= */
longtee_cotton: {
  items: [
    // --- FRONT ---
    { side:'front', label:'左胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front01.jpg' },
    { side:'front', label:'右胸 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front02.jpg' },
    { side:'front', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front03.jpg' },

    { side:'front', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front04.jpg' },
    { side:'front', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front05.jpg' },
    { side:'front', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front06.jpg' },

    { side:'front', label:'左そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front07.jpg' , note:'※インクジェット不可' },
    { side:'front', label:'右そで ラージプリント W8×H34', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front08.jpg' , note:'※インクジェット不可' },
    { side:'front', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_front09.jpg' },

    // --- BACK ---
    { side:'back', label:'センター首元 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back01.jpg?v=2' },
    { side:'back', label:'右裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back02.jpg?v=2' },
    { side:'back', label:'左裾 ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back03.jpg?v=2' },

    { side:'back', label:'横長・上 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back04.jpg?v=2' },
    { side:'back', label:'横長・中 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back05.jpg?v=2' },
    { side:'back', label:'横長・下 レギュラー W34×H16', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back06.jpg?v=2' },

    { side:'back', label:'センター レギュラー縦 W20×H27', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back07.jpg?v=2' },
    { side:'back', label:'センター レギュラー横 W27×H20', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back08.jpg?v=2' },
    { side:'back', label:'センター ラージサイズ W34×H40', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/longtee_cotton_back09.jpg?v=2' },
  ]
},

/* =========================
   トートバッグ（1460-01 等）
   ※サイズごとに使えるセンター位置が違うため note で案内
========================= */
tote: {
  items: [
    // --- FRONT ---（センターは1枚だけ。サイズごとの最大印刷範囲を注記で案内。料金はどのサイズも中サイズ）
    { side:'front', label:'ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tote_wp.webp?v=1790480950' },
    { side:'front', label:'センター レギュラー', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tote_center_v.webp?v=1790480950', note:'※サイズごとの範囲は下の表をご確認ください' },

    // --- BACK ---
    { side:'back', label:'ワンポイント W10×H10', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tote_wp.webp?v=1790480950' },
    { side:'back', label:'センター レギュラー', img:'https://cdn.shopify.com/s/files/1/0906/4556/1623/files/tote_center_v.webp?v=1790480950', note:'※サイズごとの範囲は下の表をご確認ください' },
  ],
  /* 加工位置カードの下（カードの外）に表示する、サイズ別の最大印刷範囲 */
  sizeTable: {
    title: 'センターの最大印刷範囲（サイズ別）',
    sizes: { S:'W20×H13', M:'W20×H27', L:'W20×H27', W:'W27×H20' },
    note:  '※料金はどのサイズも同じです（中サイズ）'
  }
}
};







/* ★追加：トート等、サイズで印刷範囲が変わる位置の「サイズ別の印刷範囲」を返す（例：M W20×H27／W W27×H20） */
function getSizeAreaText(p){
  const profile = PLACEMENT_PROFILES[(PLACEMENT_PROFILE_KEY || '').trim()];
  if (!profile || !profile.sizeArea || !p) return '';
  const item = (profile.items || []).find(it => it.side === p.side && it.label === p.label);
  if (!item || !item.sizes) return '';
  const own   = (item.label.match(/W\s*\d+\s*[×xX]\s*H\s*\d+/) || [''])[0];
  const order = Object.keys(profile.sizeArea);
  const chosen = [...new Set(Object.values(cartSelections).map(s => String(s.size)))]
    .sort((a, b) => order.indexOf(a) - order.indexOf(b));
  if (!chosen.length) return '';
  return chosen
    .map(sz => `${sz} ${item.sizes.includes(sz) ? own : (profile.sizeArea[sz] || own)}`)
    .join('／');
}

const METHOD_OPTIONS = [
  {
    v: '',
    t: '選択してください',
    d: ''
  },

  {
    v: 'consult',
    t: '担当と相談して決定',
    d: 'WEB注文に不安な方やサンプル制作など、担当と相談が可能です。',
    notice: '※印刷代はご注文後に確定し、別途ご請求となります。'
  },

  {
    v: 'factory',
    t: '工場のプロにお任せ',
    d: 'デザインとボディの相性を見て,最適な印刷方法を工場側で決定させて頂きます。',
    notice: '※印刷代はご注文後に確定し、別途ご請求となります。'
  },

  {
    v: 'dtf',
    t: 'DTFプリント',
    d: '写真やグラデーションも美しく再現できるプリント。ポリエステルなどにも対応できるプリント方法です。'
  },

  {
    v: 'inkjet',
    t: 'インクジェットプリント',
    d: 'コットン素材に対応で自然な風合いに仕上がるプリント方法です。'
  },

  {
    v: 'silk_1',
    t: '【1色】シルクスクリーン印刷',
    d: '定番なプリント方法です。コストを抑えたい方や様々なシーンで利用いただけます。'
  },

  {
    v: 'silk_2',
    t: '【2色】シルクスクリーン印刷',
    d: '1色よりもデザインの幅が広がります。ロゴやシンプルなデザインに向いています。'
  },

  {
    v: 'silk_3',
    t: '【3色】シルクスクリーン印刷',
    d: '3色のデザインを再現する際にご利用いただけます。仕上がりの再現度を重視したい方におすすめです。'
  },
  // ✅ 追加：刺繍（今は disabled）
  {
    v:'embroidery',
    t:'刺繍（準備中）',
    d:'現在準備中のため選択できません。',
    disabled: !ENABLE_EMBROIDERY
  },
];
// method code → 表示名
function getMethodLabel(v){
  const opt = METHOD_OPTIONS.find(o => o.v === v);
  return opt?.t || v || '';
}


window.methodLabel = (v) => {
  if (!v) return '';
  const hit = (window.METHOD_OPTIONS || METHOD_OPTIONS || []).find(o => o.v === v);
  if (hit && hit.t) return hit.t;

  const fallback = {
    consult: '担当と相談して決定',
    factory: '工場のプロにお任せ',
    dtf: 'DTFプリント',
    inkjet: 'インクジェットプリント',
    silk_1: '【1色】シルクスクリーン印刷',
    silk_2: '【2色】シルクスクリーン印刷',
    silk_3: '【3色】シルクスクリーン印刷',
    silk: 'シルクスクリーン印刷',
    embroidery: '刺繍'
  };
  return fallback[v] || v;
};






/* インク色（必要なら増やしてOK） */
/* インク色（添付パレット相当） */
const INKS = [
  { key:'black',        name:'ブラック',         css:'#000000' },
  { key:'white',        name:'ホワイト',         css:'#ffffff' },
  { key:'steelgray',    name:'スチールグレー',   css:'#808489' },
  { key:'offwhite',     name:'オフホワイト',     css:'#f5f1e8' },

  { key:'lemonyellow',  name:'レモンイエロー',   css:'#ffeb00' },
  { key:'trueyellow',   name:'トゥルーイエロー', css:'#ffc400' },
  { key:'oldgold',      name:'オールドゴールド', css:'#b08d00' },

  { key:'brown',        name:'ブラウン',         css:'#5a3a1a' },
  { key:'orange',       name:'オレンジ',         css:'#ff7a00' },
  { key:'brightorange', name:'ブライトオレンジ', css:'#ff4d00' },

  { key:'superred',     name:'スーパーレッド',   css:'#e10600' },
  { key:'brightred',    name:'ブライトレッド',   css:'#ff0000' },
  { key:'crimson',      name:'クリムゾン',       css:'#8b0000' },

  { key:'rhodamine',    name:'ローダミンレッド', css:'#ff2f92' },
  { key:'fuchsia',      name:'フューシャ',       css:'#d100a6' },
  { key:'violet',       name:'バイオレット',     css:'#6a3fa0' },

  { key:'navy',         name:'ネイビー',         css:'#001f5b' },
  { key:'lightroyal',   name:'ライトロイヤル',   css:'#1f4fbf' },
  { key:'trueblue',     name:'トゥルーブルー',   css:'#005bbb' },
  { key:'lightblue',    name:'ライトブルー',     css:'#4aa3ff' },
  { key:'aqua',         name:'アクア',           css:'#00c2c7' },

  { key:'lightdgreen',  name:'ライトDグリーン',  css:'#00a651' },
  { key:'freshgreen',   name:'フレッシュグリーン', css:'#00cc44' },
  { key:'forestgreen',  name:'フォレストグリーン', css:'#0b4f1a' },

  { key:'neonyellow',   name:'蛍光イエロー',     css:'#d7ff00' },
  { key:'neonorange',   name:'蛍光オレンジ',     css:'#ff5a00' },
  { key:'neonpink',     name:'蛍光ピンク',       css:'#ff2fbf' },
  { key:'neongreen',    name:'蛍光グリーン',     css:'#39ff14' },
  /* 2026-10-22：蛍光ブルー・メタリックシリーズを追加（メーカーのスタンダードインク） */
  { key:'neonblue',        name:'蛍光ブルー',         css:'#00c8f0' },
  { key:'metallicgold',    name:'メタリックゴールド', css:'#a99a55' },
  { key:'metallicsilver',  name:'メタリックシルバー', css:'#9c9c9c' },
  { key:'metallicpurple',  name:'メタリックパープル', css:'#5b418c' },
  { key:'metallicroyal',   name:'メタリックロイヤル', css:'#4a70b2' },
  { key:'metallicgreen',   name:'メタリックグリーン', css:'#3a9172' },
  { key:'metallicred',     name:'メタリックレッド',   css:'#a84b5c' },
];
// インク key → 日本語名 変換マップ
const INK_NAME_MAP = INKS.reduce((acc, c) => {
  acc[c.key] = c.name;
  return acc;
}, {});

function syncHidden(){
  plcSelectedInput.value = JSON.stringify(placements);
}
function buildPlacementBoxesByProfile(){
  const gridFront = document.getElementById('pm-grid-front');
  const gridBack  = document.getElementById('pm-grid-back');
  if (!gridFront || !gridBack) return;

  const key = (PLACEMENT_PROFILE_KEY || '').trim();
  const profile = PLACEMENT_PROFILES[key];

  if (!profile || !profile.items?.length){
    gridFront.innerHTML = `
      <div style="font-weight:900;color:#666;line-height:1.6;">
        加工位置の設定がありません（placement_profile 未設定）
      </div>
    `;
    gridBack.innerHTML = '';
    return;
  }

 const renderItems = (items) => items.map(item => {
  const inkjetDisabled = !!item.inkjetDisabled || (item.note || '').includes('インクジェット不可');

return `
  <button type="button"
    class="pm-box"
    data-side="${item.side}"
    data-label="${item.label}"
    data-sizes="${(item.sizes || []).join(',')}"
    data-group="${item.group || ''}"
    data-inkjet-disabled="${inkjetDisabled ? '1' : '0'}"
    data-allowed-methods='${item.allowedMethods ? JSON.stringify(item.allowedMethods) : ""}'>
    <div class="pm-box__img">
      <img src="${item.img}" alt="">
    </div>
    <div class="pm-box__cap">
      ${item.side === 'front' ? '前面' : '背面'}<br>${item.label}
      ${item.note ? `<div class="pm-box__note">${item.note}</div>` : ``}
    </div>
  </button>
`;

}).join('');


  const frontItems = profile.items.filter(x => x.side === 'front');
  const backItems  = profile.items.filter(x => x.side === 'back');

  gridFront.innerHTML = frontItems.length
    ? renderItems(frontItems)
    : `<div style="font-weight:900;color:#777;">前面の加工位置がありません</div>`;

  gridBack.innerHTML = backItems.length
    ? renderItems(backItems)
    : `<div style="font-weight:900;color:#777;">背面の加工位置がありません</div>`;
  /* ★追加：sizeTable があれば、カードの外にサイズ別の最大印刷範囲を表示 */
  renderProfileSizeTable(profile);
}

/* ★追加：加工位置の下（カードの外）に、サイズ別の最大印刷範囲の表を出す（トート等） */
function renderProfileSizeTable(profile){
  const foot = document.querySelector('#modal-placement .pm-footnote');
  if (!foot) return;
  let box = document.getElementById('pm-size-table');
  if (!profile || !profile.sizeTable){
    if (box) box.remove();
    return;
  }
  if (!box){
    box = document.createElement('div');
    box.id = 'pm-size-table';
    box.className = 'pm-size-table';
    foot.parentNode.insertBefore(box, foot);
  }
  const t = profile.sizeTable;
  const sizes = Object.keys(t.sizes || {});
  box.innerHTML = `
    <p class="pm-size-table__title">${t.title || ''}</p>
    <table class="pm-size-table__table">
      <thead><tr>${sizes.map(s => `<th>${s}</th>`).join('')}</tr></thead>
      <tbody><tr>${sizes.map(s => `<td>${t.sizes[s]}</td>`).join('')}</tr></tbody>
    </table>
    ${t.note ? `<p class="pm-size-table__note">${t.note}</p>` : ''}
  `;
}


/* 右側カードを描画 */
function renderRight(){
  syncChosyoku();   /* ★追加：調色オプションの表示・選択肢を更新 */
  if (typeof window.__renderUploadRows === 'function') window.__renderUploadRows();   /* ★追加：入稿欄を印刷箇所に合わせる */
  if (!pmSelectedWrap) return;

  if (placements.length === 0){
    pmSelectedWrap.innerHTML = `
      <div class="pm-card">
        <div style="font-weight:900;color:#666;">未選択</div>
        <div style="margin-top:6px;font-size:12px;font-weight:800;color:#777;line-height:1.6;">
          左側から加工位置を選択してください（最大${MAX_PLACES}箇所）
        </div>
      </div>
    `;
    document.getElementById('print_method_input').value = '';
    document.getElementById('plc_front_area').value = '';
    document.getElementById('plc_back_area').value  = '';
    syncHidden();
    if (typeof updateSummary === 'function') updateSummary();
    return;
  }

  const inkOptions = ['<option value="">選択</option>']
    .concat(INKS.map(i => `<option value="${i.key}">${i.name}</option>`))
    .join('');

pmSelectedWrap.innerHTML = placements.map((p, idx) => {

  // ★ inkjet限定の箇所は、必ず inkjet を入れる（空でも強制）
  const isInkjetOnly = (p.allowedMethods && p.allowedMethods.length === 1 && p.allowedMethods[0] === 'inkjet');
  if (isInkjetOnly && p.method !== 'inkjet') p.method = 'inkjet';

  const methodOpt = METHOD_OPTIONS.map(o => {
    const allowedByPlacement =
      !p.allowedMethods || p.allowedMethods.length === 0 || p.allowedMethods.includes(o.v);

    // ★ inkjet only のときは、プロファイル理由で inkjet を無効化しない
    const disabledByProfile   = (o.v === 'inkjet' && !isInkjetOnly && isInkjetDisabledByProfile());
    const disabledByPlacement = (o.v === 'inkjet' && !!p.inkjetDisabled);

    const isDisabled = !!o.disabled || disabledByProfile || disabledByPlacement || !allowedByPlacement;

    return `<option value="${o.v}"
      ${p.method===o.v ? 'selected' : ''}
      ${isDisabled ? 'disabled' : ''}>${o.t}</option>`;
  }).join('');





  // ★ インクジェット限定の箇所なのに別方法が入ってたら強制修正
  if (
    p.allowedMethods &&
    p.allowedMethods.length === 1 &&
    p.method &&
    !p.allowedMethods.includes(p.method)
  ) {
    p.method = p.allowedMethods[0]; // → inkjet に強制
  }


  /* ★追加：大判を選べない箇所は解除 */
  if (!isLargeEligible(p)) p.big = false;

const inkCount = silkInkCount(p.method);     // silk_1/2/3 → 1/2/3、silk以外→0
const inksDisabled = inkCount === 0;

// 既存inksを「必要色数」に丸める（silk以外は空）
normalizeInksByMethod(p);









// --- renderRight 内：inkSelectsHtml を作っているブロックを丸ごと差し替え ---

const getInkHex = (k) => (INKS.find(i => i.key === k)?.css || '#fff');
const getInkName = (k) => (INKS.find(i => i.key === k)?.name || '選択');

const inkSelectsHtml = [0,1,2].map((pos) => {
  const enabled = (!inksDisabled && pos < inkCount);
  const cur = enabled ? (p.inks?.[pos] || '') : '';
  const chipHex = getInkHex(cur);
  const isWhite = cur === 'white';

  // hidden select（既存 change ハンドラをそのまま使うため data-inksel-idx を維持）
  const hiddenSelect = `
    <select class="pm-select ink-hidden"
            data-inksel-idx="${idx}"
            data-ink-pos="${pos}"
            hidden
            ${enabled ? '' : 'disabled aria-disabled="true"'}>
      <option value="">選択</option>
      ${INKS.map(i => {
        const sel = (i.key === cur) ? ' selected' : '';
        return `<option value="${i.key}"${sel}>${i.name}</option>`;
      }).join('')}
    </select>
  `;

  // 擬似ドロップダウン
  const menu = `
    <div class="ink-dd__menu" role="listbox">
      ${INKS.map(i => `
        <button type="button"
                class="ink-dd__opt ${i.key===cur?'is-active':''}"
                role="option"
                aria-selected="${i.key===cur?'true':'false'}"
                data-inkdd-val="${i.key}">
          <span class="ink-dd__chip ${i.key==='white'?'is-white':''}" style="--c:${i.css};"></span>
          <span class="ink-dd__label">${i.name}</span>
        </button>
      `).join('')}
    </div>
  `;

  return `
    <div class="ink-dd ${enabled ? '' : 'is-disabled'}"
         data-inkdd-idx="${idx}"
         data-ink-pos="${pos}">
      ${hiddenSelect}
      <button type="button"
              class="ink-dd__btn"
              aria-haspopup="listbox"
              aria-expanded="false"
              ${enabled ? '' : 'disabled'}>
        <span class="ink-dd__left">
          <span class="ink-dd__chip ${isWhite?'is-white':''}" style="--c:${chipHex};"></span>
          <span class="ink-dd__label">${cur ? getInkName(cur) : '選択'}</span>
        </span>
        <span class="ink-dd__chev" aria-hidden="true">▾</span>
      </button>
      ${menu}
    </div>
  `;
}).join('');






    const inks0 = p.inks?.[0] || '';
    const inks1 = p.inks?.[1] || '';
    const inks2 = p.inks?.[2] || '';

    return `
      <div class="pm-card" data-idx="${idx}">
        <div class="pm-card__head">
          <div class="pm-card__badge">${idx+1}箇所目</div>
          <button type="button" class="pm-card__remove" data-remove="${idx}">削除</button>
        </div>

        <div class="pm-card__grid">
          <div class="pm-card__thumb">
            ${p.img ? `<img src="${p.img}" alt="">` : ''}
          </div>

          <div>
            <div style="font-weight:900;color:#333;line-height:1.4;">
              ${p.side === 'front' ? '【前面】' : '【後面】'} ${p.label}
            </div>
            ${getSizeAreaText(p) ? `<div class="pm-card__sizearea">印刷範囲：${getSizeAreaText(p)}</div>` : ''}

<div class="pm-row">
  <div class="pm-label">プリント方法</div>

  <!-- hidden select（値の保持＆既存ロジック互換） -->
  <select class="pm-select pm-method-hidden" data-method-idx="${idx}" hidden>
    ${methodOpt}
  </select>

  <!-- 疑似ドロップダウンUI -->
  <div class="pm-dd" data-dd-idx="${idx}">
    <button type="button" class="pm-dd__btn" aria-haspopup="listbox" aria-expanded="false">
      <span class="pm-dd__left">
       <span class="pm-dd__icon" aria-hidden="true">
  ${p.method && METHOD_IMAGES[p.method] ? `<img src="${METHOD_IMAGES[p.method]}" alt="">` : ``}
</span>

      </span>
      <span class="pm-dd__text">
        ${METHOD_OPTIONS.find(o=>o.v===p.method)?.t || '選択してください'}
      </span>
      <span class="pm-dd__chev" aria-hidden="true">▾</span>
    </button>

<div class="pm-dd__menu" role="listbox">
  ${METHOD_OPTIONS.map(o => {
    // ★ tshirt_dry のときだけ inkjet を無効化（描画用）
const allowedByPlacement =
  !p.allowedMethods || p.allowedMethods.length === 0 || p.allowedMethods.includes(o.v);

const disabledByProfile   = (o.v === 'inkjet' && isInkjetDisabledByProfile());
const disabledByPlacement = (o.v === 'inkjet' && !!p.inkjetDisabled);

const disabledByRule      = disabledByProfile || disabledByPlacement || !allowedByPlacement;
const isDisabled          = !!o.disabled || disabledByRule;




    return `
      <button type="button"
        class="pm-dd__opt ${p.method===o.v?'is-active':''} ${isDisabled?'is-disabled':''}"
        role="option"
        data-dd-val="${o.v}"
        ${isDisabled ? 'disabled aria-disabled="true"' : ''}
        aria-selected="${p.method===o.v?'true':'false'}">
        <span class="pm-dd__opticon" aria-hidden="true">
          ${o.v && METHOD_IMAGES[o.v] ? `<img src="${METHOD_IMAGES[o.v]}" alt="">` : ``}
        </span>
        <span class="pm-dd__text">
          <span class="pm-dd__title">${o.t}</span>
          ${o.d ? `<span class="pm-dd__desc">${o.d}</span>` : ``}
          ${o.notice ? `<span class="pm-dd__notice">${o.notice}</span>` : ``}
         ${disabledByProfile ? `<span class="pm-dd__notice">${TF.NO_INKJET === true ? '※この商品はメーカー非推奨のため、インクジェット不可' : '※ドライ素材はインクジェット不可'}</span>` : ``}
${disabledByPlacement ? `<span class="pm-dd__notice">※この箇所はインクジェット不可</span>` : ``}

        </span>
      </button>
    `;
  }).join('')}
  <!-- ★★★ ここに入れる（map の外 / join の直後）★★★ -->
  ${p.allowedMethods && p.allowedMethods.length === 1 && p.allowedMethods[0] === 'inkjet'
    ? `<span class="pm-dd__notice">※この箇所はインクジェットのみ</span>`
    : ``}

</div>

  </div>
</div>


<div class="pm-row">
  <div class="pm-label">インクカラー</div>

  <div style="display:flex; gap:8px; align-items:center;">
    ${inkSelectsHtml}
  </div>

${inksDisabled ? `
  <div style="grid-column:2 / -1; margin-top:6px; font-size:12px; font-weight:800; color:#999; line-height:1.5;">
    ※ シルクスクリーン選択時のみ指定できます
  </div>
` : ``}
</div>

${isLargeEligible(p) ? `
<div class="pm-row pm-row--large">
  <div class="pm-label">大判</div>
  <label style="display:flex;align-items:flex-start;gap:8px;cursor:pointer;font-weight:800;font-size:14px;line-height:1.5;color:#333;">
    <input type="checkbox" data-large-idx="${idx}" ${p.big ? 'checked' : ''} style="width:20px;height:20px;margin:2px 0 0;flex-shrink:0;accent-color:#00b8b8;">
    <span>大判にする（最大W41×H52cm）<br>
      <span style="font-weight:700;font-size:12px;color:#666;">${
        /* 2026-10-22：選んでいる印刷方法の料金だけを出す */
        isSilk(p.method)
          ? `特大版の版代${SILK_PLATE_XL_YEN.toLocaleString('ja-JP')}円・印刷代2割増`
          : (p.method === 'dtf' || p.method === 'inkjet')
            ? `1枚につき＋${LARGE_FEE_YEN.under20.toLocaleString('ja-JP')}円（20枚以上は＋${LARGE_FEE_YEN.over20.toLocaleString('ja-JP')}円）`
            : '料金が上がります（プリント方法を選ぶと表示）'
      }</span>
    </span>
  </label>
</div>` : ``}

${isSilk(p.method) ? silkSettingsHtml(p, idx) : ``}

          </div>
        </div>
      </div>
    `;
  }).join('');

  // 互換用hidden（旧仕様の参照落ち回避）
  const firstFront = placements.find(p=>p.side==='front');
  const firstBack  = placements.find(p=>p.side==='back');
  document.getElementById('plc_front_area').value = firstFront?.areaKey || '';
  document.getElementById('plc_back_area').value  = firstBack?.areaKey  || '';
  document.getElementById('print_method_input').value = placements[0]?.method || '';

  syncHidden();
  if (typeof updateSummary === 'function') updateSummary();
}


function bindPlacementBoxEvents(){
  pmBoxes = Array.from(document.querySelectorAll('#modal-placement .pm-box'));

  pmBoxes.forEach(btn=>{
    const label = btn.dataset.label || btn.textContent || '';
    btn.dataset.area = detectAreaKey(label);

    btn.addEventListener('click', ()=>{
      const side   = btn.dataset.side;
      const label2 = btn.dataset.label;
      const areaKey= btn.dataset.area;

      const foundIndex = placements.findIndex(p => p.side===side && p.label===label2);
      if (foundIndex >= 0){
        placements.splice(foundIndex, 1);
        btn.classList.remove('is-selected');
        renderRight();
        return;
      }

      /* ★追加：同じ面の同じグループ（例：トートのセンター）は1つだけ。別のものを押したら前の選択を外す */
      const grp = btn.dataset.group || '';
      if (grp){
        pmBoxes.forEach(other => {
          if (other === btn || other.dataset.side !== side || other.dataset.group !== grp) return;
          const oi = placements.findIndex(p => p.side === side && p.label === other.dataset.label);
          if (oi >= 0){
            placements.splice(oi, 1);
            other.classList.remove('is-selected');
          }
        });
      }

      if (placements.length >= MAX_PLACES){
        alert(`印刷箇所は最大${MAX_PLACES}箇所まで選択できます`);
        return;
      }

      const imgEl = btn.querySelector('img');
      const imgSrc = imgEl ? imgEl.src : '';
const allowedMethods = btn.dataset.allowedMethods ? JSON.parse(btn.dataset.allowedMethods) : [];

placements.push({
  id: `${side}_${areaKey}_${Date.now()}`,
  side,
  label: label2,
  areaKey,
  img: imgSrc,
  method: (allowedMethods.length === 1 ? allowedMethods[0] : ''), // ★インクジェット限定なら初期から inkjet
  inks: [],
  inkjetDisabled: (btn.dataset.inkjetDisabled === '1'),
  allowedMethods, // ★追加
});


      btn.classList.add('is-selected');
      renderRight();
    });
  });
}


/* 右：削除 / 方法変更 / インク選択 */
pmSelectedWrap?.addEventListener('click', (e)=>{
  /* 2026-10-22：シルクのオプション（特殊インク・リピート） */
  const so = e.target.closest('[data-sopt-idx]');
  if (so){
    const i = Number(so.dataset.soptIdx);
    if (!placements[i]) return;
    const k = so.dataset.soptKey, v = so.dataset.soptVal;
    if (k === 'repeat'){ placements[i].repeat = (v === '1'); placements[i].sharedPlate = (v === 'shared'); }   /* 2026-10-26：shared＝ほかと同じ版 */
    else if (k === 'specialInk') placements[i].specialInk = v;
    else if (k === 'inkChange') placements[i].inkChange = (v === '1');
    renderRight();
    return;
  }

  /* 2026-10-22：版の分け方 */
  const sp = e.target.closest('[data-split-idx]');
  if (sp){
    const i = Number(sp.dataset.splitIdx);
    if (!placements[i]) return;
    placements[i].plateSplit = sp.dataset.splitVal;
    renderRight();
    return;
  }

  // 削除
  const rm = e.target.closest('[data-remove]');
  if (rm){
    const idx = Number(rm.dataset.remove);
    const removed = placements[idx];
    placements.splice(idx,1);

    // 左の選択状態も戻す
    pmBoxes.forEach(b=>{
      if (b.dataset.side===removed.side && b.dataset.label===removed.label){
        b.classList.remove('is-selected');
      }
    });
    renderRight();
    return;
  }


});

/* 2026-10-22：リピートの注文番号（入力のたびに保持。画面は描き直さない） */
pmSelectedWrap?.addEventListener('input', (e)=>{
  const tq = e.target.closest('[data-tier-qty]');
  if (tq){
    const i = Number(tq.dataset.tierQty);
    if (placements[i]) placements[i].tierQty = Math.max(0, parseInt(tq.value, 10) || 0);
    if (typeof updateSummary === 'function') updateSummary();
    return;
  }
  const no = e.target.closest('[data-repeat-no]');
  if (no){
    const i = Number(no.dataset.repeatNo);
    if (placements[i]) placements[i].repeatOrderNo = no.value.trim();
    if (typeof updateSummary === 'function') updateSummary();
  }
});

pmSelectedWrap?.addEventListener('change', (e)=>{
  /* 2026-10-22：本体の色ごとのインク */
  const ib = e.target.closest('[data-inkbody-idx]');
  if (ib){
    const i = Number(ib.dataset.inkbodyIdx);
    if (!placements[i]) return;
    placements[i].inkByBody = placements[i].inkByBody || {};
    placements[i].inkByBody[ib.dataset.inkbodyColor] = ib.value || ('?' + ib.dataset.inkbodyColor);
    const box = document.querySelector(`[data-inkchange-list="${i}"]`);
    if (box) box.innerHTML = inkChangeListHtml(placements[i], i);
    if (typeof updateSummary === 'function') updateSummary();
    return;
  }
  /* 2026-10-22：リピートでインクの色を変える */
  const ink = e.target.closest('[data-repeat-ink]');
  if (ink){
    const i = Number(ink.dataset.repeatInk);
    if (!placements[i]) return;
    placements[i].repeatInkChange = !!ink.checked;
    if (typeof updateSummary === 'function') updateSummary();
    return;
  }
  /* ★追加：大判チェック */
  const selLarge = e.target.closest('[data-large-idx]');
  if (selLarge){
    const idx = Number(selLarge.dataset.largeIdx);
    if (!placements[idx]) return;
    placements[idx].big = !!selLarge.checked && isLargeEligible(placements[idx]);
    renderRight();
    return;
  }

  // プリント方法
  const selMethod = e.target.closest('[data-method-idx]');
  if (selMethod){
    const idx = Number(selMethod.dataset.methodIdx);
    if (!placements[idx]) return;

placements[idx].method = selMethod.value;

// ✅ 色数に合わせて inks を整形（シルク以外は空）
normalizeInksByMethod(placements[idx]);

renderRight();
return;

  }

  // インクカラー（ドロップダウン）
  const selInk = e.target.closest('[data-inksel-idx]');
  if (selInk){
      if (selInk.disabled) return; // ★追加：無効は無視
    const idx = Number(selInk.dataset.inkselIdx);
    const pos = Number(selInk.dataset.inkPos);
    if (!placements[idx]) return;
 if (!isSilk(placements[idx].method)) return;


    const v = selInk.value || '';
    const inks = (placements[idx].inks || []).slice(0,3);
    inks[pos] = v;

    // 空は除去しつつ、順番は維持
    const cleaned = [inks[0], inks[1], inks[2]].filter(Boolean);

    // 同じ色の重複は排除（最初に出たものを優先）
    const uniq = [];
    cleaned.forEach(k => { if (!uniq.includes(k)) uniq.push(k); });

    placements[idx].inks = uniq.slice(0,3);
syncHidden();
renderRight();
window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();

  }
});


buildPlacementBoxesByProfile();
bindPlacementBoxEvents();
renderRight();
/* ★追加：上限の注記を MAX_PLACES に合わせる */
(function(){
  const fn = document.querySelector('#modal-placement .pm-footnote');
  if (fn) fn.innerHTML = `※ 印刷箇所は最大 <b>${MAX_PLACES}箇所</b> まで選択できます。`;
})();

/* ★追加：選択中のサイズに合う加工位置だけ表示（data-sizes がある項目のみ対象） */
function filterPlacementBySizes(){
  const chosen = new Set(Object.values(cartSelections).map(s => String(s.size)));
  let removed = false;
  document.querySelectorAll('#modal-placement .pm-box').forEach(btn => {
    const sizes = btn.dataset.sizes ? btn.dataset.sizes.split(',') : [];
    const show  = !sizes.length || !chosen.size || sizes.some(s => chosen.has(s));
    btn.style.display = show ? '' : 'none';
    if (!show){
      const idx = placements.findIndex(p => p.side === btn.dataset.side && p.label === btn.dataset.label);
      if (idx >= 0){
        placements.splice(idx, 1);
        btn.classList.remove('is-selected');
        removed = true;
      }
    }
  });
  renderRight();
}
const _plcModalForSize = document.getElementById('modal-placement');
if (_plcModalForSize){
  new MutationObserver(() => {
    if (_plcModalForSize.getAttribute('aria-hidden') === 'false') filterPlacementBySizes();
  }).observe(_plcModalForSize, { attributes:true, attributeFilter:['aria-hidden'] });
}

/* =========================
   Parent accordion: preorder header opens whole flow
========================= */
function setupPreorderAccordion(){
  const root = document.getElementById('tshirt-order-flow');
  if (!root) return;

  const header = root.querySelector('.tshirt-config__header');
  const body   = root.querySelector('#preorder-body');
  if (!header || !body) return;

  const openToAuto = () => {
    // 一旦ピクセルで開く（アニメ用）
    body.style.height = body.scrollHeight + 'px';
    // アニメが終わったら auto にして「伸びても切れない」状態にする
    const onEnd = (e) => {
      if (e.propertyName !== 'height') return;
      body.removeEventListener('transitionend', onEnd);
      if (root.classList.contains('is-open')){
        body.style.height = 'auto';
      }
    };
    body.addEventListener('transitionend', onEnd);
  };

  const closeToZero = () => {
    // auto のままだと閉じアニメできないので、現在高→0 にする
    body.style.height = body.scrollHeight + 'px';
    // 次フレームで 0
    requestAnimationFrame(() => {
      body.style.height = '0px';
    });
  };

  const setOpen = (open) => {
    if (open){
      root.classList.add('is-open');
      header.setAttribute('aria-expanded','true');
      openToAuto();
    } else {
      root.classList.remove('is-open');
      header.setAttribute('aria-expanded','false');
      closeToZero();
    }
  };

  // 初期は閉じる（開きたいなら true）
  setOpen(true);

  header.addEventListener('click', () => {
    setOpen(!root.classList.contains('is-open'));
  });

  header.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' '){
      e.preventDefault();
      setOpen(!root.classList.contains('is-open'));
    }
  });

  // 外から呼べる「高さ再計算」：開いてる時だけ
  window.__recalcPreorderAccordionHeight = function(){
    if (!root.classList.contains('is-open')) return;

    // いったん auto を解除して測り直してから、また auto に戻す
    body.style.height = body.scrollHeight + 'px';
    requestAnimationFrame(() => {
      body.style.height = 'auto';
    });
  };
}


setupPreorderAccordion();




// ===== ink pseudo dropdown events =====
document.addEventListener('click', (e) => {
  // open/close ink dropdown
  const inkBtn = e.target.closest('.ink-dd__btn');
  if (inkBtn){
    const dd = inkBtn.closest('.ink-dd');
    if (!dd || dd.classList.contains('is-disabled')) return;

    const isOpen = dd.classList.contains('is-open');
    // 他の ink-dd も pm-dd も閉じる
    document.querySelectorAll('.ink-dd.is-open').forEach(x => x.classList.remove('is-open'));
    document.querySelectorAll('.pm-dd.is-open').forEach(x => x.classList.remove('is-open'));

    dd.classList.toggle('is-open', !isOpen);
    inkBtn.setAttribute('aria-expanded', (!isOpen).toString());
    return;
  }

  // select ink option
  const inkOpt = e.target.closest('.ink-dd__opt');
  if (inkOpt){
    const dd = inkOpt.closest('.ink-dd');
    if (!dd || dd.classList.contains('is-disabled')) return;

    const idx = Number(dd.getAttribute('data-inkdd-idx'));
    const pos = Number(dd.getAttribute('data-ink-pos'));
    const val = inkOpt.getAttribute('data-inkdd-val') || '';

    // hidden select に値をセット → 既存の change ハンドラ（data-inksel-idx）を流用
    const hiddenSel = dd.querySelector('select.ink-hidden[data-inksel-idx="'+idx+'"][data-ink-pos="'+pos+'"]');
    if (hiddenSel){
      hiddenSel.value = val;
      hiddenSel.dispatchEvent(new Event('change', { bubbles:true }));
    }

    // 閉じる
    dd.classList.remove('is-open');
    return;
  }

  // 外クリックで閉じる（ink-dd）
  if (!e.target.closest('.ink-dd')){
    document.querySelectorAll('.ink-dd.is-open').forEach(x => x.classList.remove('is-open'));
  }
});
// ===== pm pseudo dropdown events（プリント方法） =====
document.addEventListener('click', (e) => {
  // open/close method dropdown
  const pmBtn = e.target.closest('.pm-dd__btn');
  if (pmBtn){
    const dd = pmBtn.closest('.pm-dd');
    if (!dd) return;

    const isOpen = dd.classList.contains('is-open');

    // 他のドロップダウンは閉じる
    document.querySelectorAll('.pm-dd.is-open').forEach(x => x.classList.remove('is-open'));
    document.querySelectorAll('.ink-dd.is-open').forEach(x => x.classList.remove('is-open'));

    dd.classList.toggle('is-open', !isOpen);
    pmBtn.setAttribute('aria-expanded', (!isOpen).toString());
    return;
  }

  // select method option
  const opt = e.target.closest('.pm-dd__opt');
  if (opt){
    // disabled は無視
    if (opt.classList.contains('is-disabled') || opt.hasAttribute('disabled')) return;

    const dd = opt.closest('.pm-dd');
    if (!dd) return;

    const idx = Number(dd.getAttribute('data-dd-idx'));
    const val = opt.getAttribute('data-dd-val') || '';

if (val === 'inkjet') {
  const idx = Number(dd.getAttribute('data-dd-idx'));
  const p = placements[idx];

  if (isInkjetDisabledByProfile()) {
    alert('ドライ素材ではインクジェットプリントは選択できません。');
    return;
  }
  if (p && p.inkjetDisabled) {
    alert('この箇所（そで）はインクジェットプリントは選択できません。');
    return;
  }
}






    // 同じ行にある hidden select を更新 → 既存 change ハンドラに流す
    const row = dd.closest('.pm-row');
    const hiddenSel = row?.querySelector(`select.pm-method-hidden[data-method-idx="${idx}"]`);
    if (hiddenSel){
      hiddenSel.value = val;
      hiddenSel.dispatchEvent(new Event('change', { bubbles:true }));
    }

    dd.classList.remove('is-open');
    return;
  }

  // 外クリックで閉じる（pm-dd）
  if (!e.target.closest('.pm-dd')){
    document.querySelectorAll('.pm-dd.is-open').forEach(x => x.classList.remove('is-open'));
  }
});




/* ────────────── 追記ここまで ────────────── */
/* ▼追加：位置指定 2択カード（auto/specify） */
(function(){
  const wrap = document.getElementById('pos-choice');
  const input = document.getElementById('pos_choice_input');
  if(!wrap || !input) return;

  const detailWrap  = document.getElementById('pos-detail-wrap');
  const detailInput = document.getElementById('pos_detail_input');

  /* ★追加：specify のときだけ指定内容の入力欄を出す。autoに戻したら値もクリア */
  function syncDetail(){
    const show = input.value === 'specify';
    if (detailWrap) detailWrap.style.display = show ? 'block' : 'none';
    if (!show && detailInput){
      detailInput.value = '';
      detailInput.classList.remove('is-error');
    }
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  }

  const btns = wrap.querySelectorAll('.pos-choice__btn');
  btns.forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btns.forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');
      input.value = btn.dataset.value; // "auto" or "specify"
      syncDetail();
      if (typeof updateSummary === 'function') updateSummary();
    });
  });

  /* ★追加：入力のたびにサマリー・未選択リストを更新 */
  detailInput?.addEventListener('input', ()=>{
    if (detailInput.value.trim()) detailInput.classList.remove('is-error');
    if (typeof updateSummary === 'function') updateSummary();
  });

  syncDetail();
})();
/* ▲追加ここまで */

/* ▼追加：調色オプション（色数プルダウン・色番号入力） */
(function(){
  const sel  = document.getElementById('chosyoku_count_select');
  const code = document.getElementById('chosyoku_code_input');
  if (!sel) return;

  sel.addEventListener('change', ()=>{
    syncChosyoku();
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
    if (typeof updateSummary === 'function') updateSummary();
    checkAllStepsAndClearError();
  });

  code?.addEventListener('input', ()=>{
    if (code.value.trim()) code.classList.remove('is-error');
    if (typeof updateSummary === 'function') updateSummary();
    checkAllStepsAndClearError();
  });
})();
/* ▲追加ここまで */






    /* --- 要素キャッシュ --- */
    const palette     = document.querySelector('[data-color-palette]');
    const colorModal  = document.getElementById('modal-color');
    const sizeModal   = document.getElementById('modal-size');
    const sizeRows    = sizeModal.querySelector('[data-size-rows]');
    const modalTitle  = sizeModal.querySelector('[data-size-modal-title]');
    const bulkBtn     = document.getElementById('bulk-add-btn');

   /* ---------- パレット描画 ---------- */
    const colors = [...new Set(variants.map(v => v.options[COLOR_IDX]))];
    const isSingleSize = Array.isArray(SIZE_LIST) && SIZE_LIST.length === 1;
    const singleSize = isSingleSize ? SIZE_LIST[0] : '';

    if (isSingleSize){
      // 単一サイズ：カラーごとに数量入力欄を表示
palette.innerHTML = colors.map(col => {
        const v = variants.find(v => v.options[COLOR_IDX]===col && v.featured_image);
        const rawSrc = v?.featured_image?.src || '';
        const src = rawSrc.replace(/(\.(jpe?g|png|webp|gif))(\?|$)/i, '_260x$1$3');
        const vid = getVariantIdByColor(col);   // ★変更
        const key = `${vid}_${singleSize}`;
        const curQty = cartSelections[key]?.qty || 0;
        return `
          <div class="color-swatch--single" data-color="${col}" data-variant="${vid}">
            <img src="${src}" loading="lazy" decoding="async" alt="${col}">
            <span>${col}</span>
            <input type="number" min="0" step="1" value="${curQty}" class="color-qty-input">
          </div>`;
      }).join('');

      // 数量変更ハンドラ
      palette.addEventListener('input', e => {
        if (!e.target.matches('.color-qty-input')) return;
        const wrap = e.target.closest('.color-swatch--single');
        if (!wrap) return;
        const color = wrap.dataset.color;
        const vid = wrap.dataset.variant;
        const qty = parseInt(e.target.value, 10) || 0;
        const key = `${vid}_${singleSize}`;
        if (qty > 0){
          cartSelections[key] = { variantId: +vid, size: singleSize, qty };
        } else {
          delete cartSelections[key];
        }
        if (typeof updateSummary === 'function') updateSummary();
      });
    } else {
      // 通常：カラー選択ボタンのみ（サイズモーダルで枚数入力）
      palette.innerHTML = colors.map(col => {
        const v   = variants.find(v => v.options[COLOR_IDX]===col && v.featured_image);
        const rawSrc = v?.featured_image?.src || '';
        const src = rawSrc.replace(/(\.(jpe?g|png|webp|gif))(\?|$)/i, '_260x$1$3');
        return `
          <button type="button" class="color-swatch" data-color="${col}">
            <img src="${src}" loading="lazy" decoding="async" alt="${col}"><span>${col}</span>
          </button>`;
      }).join('');
    }

    /* ---------- 2026-11-02：商品ページの「カラー一覧」（説明文の下） ----------
       ・STEP2 と同じ画像・カラー名に、メーカー在庫（custom.stock）の状態を付けて並べる
       ・押すと、そのカラーのサイズごとの在庫を出す。「このカラーで枚数を入れる」で STEP2 の入力を開く */
    (function initColorList(){
      try {
        if (!colors.length) return;
        /* 2026-11-02：テーマのスニペット snippets/odp-color-list.liquid がHTMLで出していれば、それに在庫と動きを足す（SEO用に見出し・カラー名は最初からHTMLにある） */
        const ssrBox = document.querySelector('#odp-colorlist[data-ssr]');
        if (document.getElementById('odp-colorlist') && !ssrBox) return;
        const ptitle = (document.querySelector('.product-page-info__title')?.textContent || '').split('｜')[0].replace(/\s+/g, ' ').trim();
        const ssrTitle = ssrBox ? (ssrBox.querySelector('h2')?.textContent || '').trim() : (ptitle ? `${ptitle}のカラー一覧（全${colors.length}色）` : '');
        /* 置き場所：「商品詳細」の見出しの上（幅いっぱい）。ない商品は説明文の下 */
        const specHead = ssrBox ? null : document.querySelector('.op-spec__inner > .op-spec__heading');
        const anchor = specHead
                    || document.querySelector('.unique-submit-heading')?.closest('.product-page-info__custom-liquid')
                    || document.querySelector('.product-page-info__variants');
        const info = document.querySelector('.product-page-info');
        if (!ssrBox && !anchor && !info) return;
        const wide = !!specHead || !!ssrBox;
        const esc = (t) => String(t || '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
        const imgOf = (col) => {
          const v = variants.find(v => v.options[COLOR_IDX] === col && v.featured_image);
          return (v?.featured_image?.src || '').replace(/(\.(jpe?g|png|webp|gif))(\?|$)/i, '_160x$1$3');
        };
        const sizesOf = () => (Array.isArray(SIZE_LIST) && SIZE_LIST.length) ? SIZE_LIST : [''];
        const sizeSt = (col, sz) => {
          if (SIZE_OPT_IDX >= 0 && !getVariantIdByColorSize(col, sz)) return { status: 'none' };
          return getSizeStock(col, sz);
        };
        /* カラーの在庫のまとめ：ok（在庫あり）／part（一部サイズ入荷待ち）／wait（入荷待ち）／end（販売終了）／unknown */
        const colorSum = (col) => {
          const st = sizesOf().map(sz => sizeSt(col, sz)).filter(x => x.status !== 'none');
          if (!st.length || st.every(x => x.status === 'unknown')) return 'unknown';
          const live = st.filter(x => x.status !== 'discontinued');
          if (!live.length) return 'end';
          const ok = live.filter(x => x.status === 'ok' || x.status === 'low').length;
          if (!ok) return 'wait';
          return ok < live.length ? 'part' : 'ok';
        };
        const SUM_LABEL = { ok: '在庫あり', part: '一部入荷待ち', wait: '入荷待ち', end: '販売終了', unknown: '' };
        const SIZE_LABEL = { ok: '在庫あり', low: '残りわずか', soldout: '入荷待ち', discontinued: '販売終了', unknown: '－', none: '取扱いなし' };
        const sums = {}; colors.forEach(c => { sums[c] = colorSum(c); });
        const FIRST = 12;
        const isSp = () => !!(window.matchMedia && window.matchMedia('(max-width:749px)').matches);
        /* PC の幅いっぱいの欄では全色を出す。スマホと狭い欄は最初の12色だけ */
        let showAll = colors.length <= FIRST || (wide && !isSp()), openCol = '';

        const box = ssrBox || document.createElement('div');
        box.id = 'odp-colorlist';
        box.className = 'odp-cl' + (wide ? ' -wide' : '');
        const css = document.createElement('style');   /* スニペットにも同じCSSがある（どちらか片方でも同じ見た目） */
        css.textContent = `
          .odp-cl{margin:18px 0;padding:16px;border:2px solid #cfeeee;border-radius:12px;background:#fff;font-family:'Noto Sans JP',sans-serif;color:#222;}
          .odp-cl *{box-sizing:border-box;}
          .odp-cl__head{display:flex;justify-content:space-between;align-items:baseline;gap:8px;margin:0 0 10px;}
          .odp-cl__title{margin:0;font-size:18px;font-weight:900;}
          .odp-cl__count{font-size:14px;font-weight:700;color:#666;}
          .odp-cl__grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(84px,1fr));gap:8px;}
          .odp-cl__c{display:flex;flex-direction:column;align-items:center;gap:3px;padding:6px 4px 7px;border:2px solid #e3e3e3;border-radius:10px;background:#fff;font-family:inherit;cursor:pointer;text-align:center;}
          .odp-cl__c:hover{border-color:#00b8b8;}
          .odp-cl__c.-on{border-color:#00b8b8;background:#f2fdfd;}
          .odp-cl__c.-end{opacity:.45;}
          .odp-cl__c img{width:64px;height:64px;object-fit:cover;border-radius:6px;}
          .odp-cl__name{display:block;width:100%;font-size:14px;font-weight:700;line-height:1.4;white-space:nowrap;overflow:hidden;text-overflow:clip;color:#222;}
          .odp-cl__b{display:inline-block;padding:1px 6px;border-radius:4px;font-size:12px;font-weight:800;line-height:1.5;}
          .odp-cl__b.-ok{background:#e3f6ee;color:#1d6b4a;}
          .odp-cl__b.-low,.odp-cl__b.-part{background:#fff3d6;color:#8a5a00;}
          .odp-cl__b.-wait,.odp-cl__b.-soldout{background:#eee;color:#555;}
          .odp-cl__b.-end,.odp-cl__b.-discontinued,.odp-cl__b.-none{background:#f5f5f5;color:#999;}
          .odp-cl__more{display:block;width:100%;margin:10px 0 0;padding:10px;border:2px dashed #00b8b8;border-radius:10px;background:#fff;color:#00636b;font-family:inherit;font-size:16px;font-weight:800;cursor:pointer;}
          .odp-cl__detail{margin:12px 0 0;padding:12px 14px;border:2px solid #00b8b8;border-radius:10px;background:#f2fdfd;}
          .odp-cl__dtitle{margin:0 0 8px;font-size:17px;font-weight:900;}
          .odp-cl__sizes{display:grid;grid-template-columns:repeat(auto-fill,minmax(104px,1fr));gap:6px;margin:0;padding:0;}
          .odp-cl__size{display:flex;flex-direction:column;align-items:center;gap:3px;padding:8px 4px;border:1px solid #cfeeee;border-radius:8px;background:#fff;}
          .odp-cl__size b{font-size:16px;font-weight:800;}
          .odp-cl__eta{font-size:12px;font-weight:700;color:#555;white-space:nowrap;}
          .odp-cl__go{display:block;width:100%;margin:12px 0 0;padding:12px;border:0;border-radius:10px;background:#ea4a3f;color:#fff;font-family:inherit;font-size:17px;font-weight:900;cursor:pointer;}
          .odp-cl__note{margin:8px 0 0;font-size:13px;color:#666;line-height:1.6;}
          .odp-cl.-wide{margin:0 0 36px;padding:0;border:0;background:none;}
          .odp-cl.-wide .odp-cl__grid{grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:10px;}
          .odp-cl.-wide .odp-cl__c img{width:88px;height:88px;}
          /* 在庫の枠は一覧の横幅いっぱい（スニペットの max-width:760px より強くする） */
          .odp-cl.-wide .odp-cl__grid > .odp-cl__detail,.odp-cl__grid > .odp-cl__detail{grid-column:1/-1;max-width:none;margin:2px 0 6px;}
          .odp-cl__lead{margin:0 0 12px;font-size:15px;color:#555;}
          .odp-cl__b{white-space:nowrap;}
          @media (max-width:749px){ .odp-cl{padding:12px;} .odp-cl.-wide{padding:0;} .odp-cl__grid,.odp-cl.-wide .odp-cl__grid{grid-template-columns:repeat(2,minmax(0,1fr));gap:8px;} .odp-cl__c img,.odp-cl.-wide .odp-cl__c img{width:72px;height:72px;} .odp-cl__sizes{grid-template-columns:repeat(3,minmax(0,1fr));} }
        `;
        document.head.appendChild(css);

        const render = () => {
          const list = showAll ? colors : colors.slice(0, FIRST);
          let h = wide
            ? `<h2 class="op-spec__heading">${esc(ssrTitle || 'カラー一覧（全' + colors.length + '色）')}</h2><p class="odp-cl__lead">カラーを押すと、サイズごとの在庫が出ます。</p>`
            : `<div class="odp-cl__head"><p class="odp-cl__title">カラー一覧</p><span class="odp-cl__count">全${colors.length}色</span></div>`;
          h += '<div class="odp-cl__grid">' + list.map(col => {
            const sm = sums[col];
            return `<button type="button" class="odp-cl__c${openCol === col ? ' -on' : ''}${sm === 'end' ? ' -end' : ''}" data-cl="${esc(col)}">
                <img src="${esc(imgOf(col))}" alt="${esc(col)}" loading="lazy" decoding="async">
                <span class="odp-cl__name" title="${esc(col)}">${esc(col)}</span>
                ${SUM_LABEL[sm] ? `<span class="odp-cl__b -${sm}">${SUM_LABEL[sm]}</span>` : ''}
              </button>`;
          }).join('');
          /* 2026-11-02：押したカラーの在庫は、そのカラーの行のすぐ下に出す（一覧の一番下だと見えないため。placeDetail() で動かす） */
          let d = '';
          if (openCol){
            const sizes = sizesOf().filter(Boolean);
            d += `<div class="odp-cl__detail"><p class="odp-cl__dtitle">【${esc(openCol)}】の在庫</p>`;
            if (sizes.length){
              d += '<div class="odp-cl__sizes">' + sizes.map(sz => {
                const st = sizeSt(openCol, sz);
                /* 入荷予定日は下の行に分けて出す（バッジと重ならないように） */
                const m = (st.status === 'soldout' && st.eta) ? String(st.eta).match(/(\d{4})\/(\d{1,2})\/(\d{1,2})/) : null;
                const eta = (st.status === 'soldout' && st.eta) ? `<span class="odp-cl__eta">${m ? Number(m[2]) + '/' + Number(m[3]) : esc(st.eta)}入荷予定</span>` : '';
                return `<div class="odp-cl__size"><b>${esc(sz)}</b><span class="odp-cl__b -${st.status}">${SIZE_LABEL[st.status] || ''}</span>${eta}</div>`;
              }).join('') + '</div>';
            }
            d += `<button type="button" class="odp-cl__go" data-cl-go="${esc(openCol)}">このカラーで枚数を入れる</button>
                  <p class="odp-cl__note">※メーカーの在庫です${(STOCK_DATA && STOCK_DATA.u) ? `（${esc(String(STOCK_DATA.u).replace(/^(\d{4})-(\d{2})-(\d{2}).*$/, (m, y, mo, d) => Number(mo) + '/' + Number(d)))}時点）` : ''}。ご注文後に確保しますので、欠品のときは担当よりご連絡します。</p></div>`;
          }
          h += d + '</div>';
          if (!showAll) h += `<button type="button" class="odp-cl__more" data-cl-more="1">すべてのカラーを見る（全${colors.length}色）</button>`;
          box.innerHTML = h;
          fitNames();
          placeDetail();
        };
        /* 在庫の枠を、押したカラーと同じ行の最後のカラーの後ろに動かす（行の数は画面の幅で変わるので、位置で調べる） */
        const placeDetail = () => {
          const det = box.querySelector('.odp-cl__grid > .odp-cl__detail');
          const on = box.querySelector('.odp-cl__c.-on');
          if (!det || !on) return;
          let last = on, n = on.nextElementSibling;
          while (n && n.classList.contains('odp-cl__c') && n.offsetTop === on.offsetTop){ last = n; n = n.nextElementSibling; }
          if (last.nextElementSibling !== det) last.after(det);
        };
        /* カラー名を1行に収める（はみ出す名前だけ、文字を少し小さくする。12pxまで） */
        const fitNames = () => {
          if (!box.isConnected) return;
          box.querySelectorAll('.odp-cl__name').forEach(el => {
            el.style.fontSize = '';
            let fs = parseFloat(getComputedStyle(el).fontSize) || 14;
            while (el.scrollWidth > el.clientWidth + 1 && fs > 12){ fs -= 0.5; el.style.fontSize = fs + 'px'; }
          });
        };
        let fitT = 0;
        window.addEventListener('resize', () => { clearTimeout(fitT); fitT = setTimeout(() => { fitNames(); placeDetail(); }, 150); });
        box.addEventListener('click', (e) => {
          const c = e.target.closest('[data-cl]');
          if (c){
            /* 上の行で開いていた在庫が閉じても、押したカラーが画面の同じ位置に残るようにする */
            const col = c.dataset.cl, top0 = c.getBoundingClientRect().top;
            openCol = (openCol === col) ? '' : col; render();
            const c2 = [...box.querySelectorAll('.odp-cl__c')].find(x => x.dataset.cl === col);
            if (c2){ const dy = c2.getBoundingClientRect().top - top0; if (dy) window.scrollBy(0, dy); }
            return;
          }
          if (e.target.closest('[data-cl-more]')){ showAll = true; render(); return; }
          const go = e.target.closest('[data-cl-go]');
          if (go){
            /* STEP2 のカラー選択を開いて、そのカラーのサイズ／枚数の入力を開く */
            const col = go.dataset.clGo;
            const step = document.getElementById('step-color-size');
            if (step) step.scrollIntoView({ behavior: 'smooth', block: 'start' });
            colorModal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
            if (!isSingleSize){
              const sw = [...palette.querySelectorAll('.color-swatch')].find(x => x.dataset.color === col);
              if (sw) sw.click();
            }
          }
        });
        if (!ssrBox){ if (anchor) anchor.parentNode.insertBefore(box, anchor); else info.appendChild(box); }
        render();   /* ページに入れてから描く（名前の幅を測るため） */
      } catch (err) { console.warn('color list', err); }
    })();

/* ---------- カラークリック ---------- */
// ① 🔻【クリック時】カラー→サイズ入力モーダルを開くハンドラ
palette.addEventListener('click', e=>{
  const sw = e.target.closest('.color-swatch');
  if(!sw) return;
  if (isSingleSize) return; // ★ 単一サイズ時はサイズモーダルを開かない

  currentColor = sw.dataset.color;
  modalTitle.textContent = `【${currentColor}】 サイズ／枚数を入力`;
  sizeModal.querySelector('.size-qty-wrap').style.display = 'block';

  /* カラーに紐づく代表バリアント ID（1つだけあれば OK） */
  const variantId = getVariantIdByColor(currentColor);   // ★変更

  /* 🔸 現在の入力を取得して初期値に反映 ---------------------------- */
  const currentMap = {};               // {サイズ: qty}
  Object.values(cartSelections).forEach(sel=>{
    if(colorOfVariant(sel.variantId) === currentColor){
      currentMap[sel.size] = sel.qty;  // 例）{M:10, L:2}
    }
  });

  /* 行を描画（在庫状態つき） ---------------------- */
  sizeRows.innerHTML = SIZE_LIST.map(sz=>{
    const qty = currentMap[sz] || 0;
    const rowVid    = getVariantIdByColorSize(currentColor, sz);
    const noVariant = (SIZE_OPT_IDX >= 0 && !rowVid);   // 例：配色カラーのWサイズ
    /* ★追加：サイズで価格が変わる商品（トート等）は、サイズの下に本体単価を表示 */
    const rowVar    = (SIZE_OPT_IDX >= 0 && rowVid) ? variants.find(v => v.id == rowVid) : null;
    const priceHtml = rowVar ? `<span class="size-unit-price">¥${(rowVar.price / 100).toLocaleString()}</span>` : '';
    const st  = noVariant ? { status: 'discontinued' } : getSizeStock(currentColor, sz);
    let badge='', disabled='', rowStyle='';
    if (st.status === 'discontinued'){
      badge = `<span class="stock-badge -end">${noVariant ? '取扱いなし' : '販売終了'}</span>`;
      disabled='disabled'; rowStyle='opacity:.45;';
    } else if (st.status === 'soldout'){
      const eta = fmtEta(st.eta);
      badge = eta ? `<span class="stock-badge -wait">入荷待ち（${eta}入荷予定）</span>`
                  : `<span class="stock-badge -wait">入荷待ち</span>`;
      disabled='disabled'; rowStyle='opacity:.55;';
    } else if (st.status === 'low'){
      badge = `<span class="stock-badge -low">残りわずか</span>`;
    } else if (st.status === 'ok'){
      badge = `<span class="stock-badge -ok">在庫あり</span>`;
    }
    return `
      <tr data-size="${sz}" data-variant="${rowVid || variantId}" data-stock-status="${st.status}" style="${rowStyle}">
        <td>${sz}${priceHtml}</td>
        <td><input type="number" min="0" step="1" value="${disabled?0:qty}" ${disabled}>${badge}</td>
      </tr>`;
  }).join('');

  /* モーダル切替 */
  colorModal.setAttribute('aria-hidden','true');
  sizeModal.setAttribute('aria-hidden','false');
  document.body.style.overflow = 'hidden';
});

    /* ---------- 数量入力監視 ---------- */
    sizeRows.addEventListener('input', e=>{
      if(e.target.tagName !== 'INPUT') return;

      const row   = e.target.closest('tr');
      const varId = row.dataset.variant;
      const size  = row.dataset.size;
      const status= row.dataset.stockStatus;
      let   qty   = parseInt(e.target.value,10) || 0;
      const key   = `${varId}_${size}`;

      /* 販売終了・在庫0は数量を受け付けない（保険） */
      if(qty > 0 && (status === 'discontinued' || status === 'soldout')){
        qty = 0; e.target.value = 0;
      }

      if(qty > 0){
        cartSelections[key] = { variantId: +varId, size, qty };
      }else{
        delete cartSelections[key];
      }
      refreshSwatch(currentColor);
    });

    /* ---------- サイズ入力「完了」 ---------- */
 document.getElementById('size-modal-finish')
   .addEventListener('click', ()=>{
     /* サイズ入力モーダルを閉じる */
    sizeModal.setAttribute('aria-hidden','true');

   /* カラー選択モーダルを再表示 */
     colorModal.setAttribute('aria-hidden','false');
     document.body.style.overflow = 'hidden';  /* ←モーダル中はスクロール禁止のまま */

     /* 全カラーの合計枚数バッジを再計算 */
    document.querySelectorAll('.color-swatch')
              .forEach(sw=>refreshSwatch(sw.dataset.color));
   });

    /* ===================================================================
       汎用モーダル開閉（元のまま）
       =================================================================== */
    document.body.addEventListener('click', e=>{
      if(e.target.matches('[data-modal-close], .tshirt-modal__overlay')){
        const m = e.target.closest('.tshirt-modal') ||
                  document.querySelector('.tshirt-modal[aria-hidden="false"]');
        if(m){ m.setAttribute('aria-hidden','true'); document.body.style.overflow=''; }
      }
    });
    document.querySelectorAll('[data-modal-target]').forEach(btn=>{
      btn.addEventListener('click', ()=>{
        const m = document.querySelector(btn.dataset.modalTarget);
        if(m){ m.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; }
      });
    });

    /* ---------- 注文タイプ切替 ---------- */
function toggleStepsDisabled(isPlain){
  const targets=['#step-print','#step-placement','#step-contact','#step-upload','#step-case']; // ★#step-bagging を除外
  targets.forEach(sel=>{
    const el=document.querySelector(sel);
    if(el) el.classList.toggle('is-disabled',isPlain);
  });

  /* モーダル呼び出しボタン */
  document.querySelectorAll('[data-modal-target]').forEach(btn=>{
    const st=btn.closest('.tshirt-step');
    st&&st.classList.contains('is-disabled')
      ? btn.setAttribute('disabled','disabled')
      : btn.removeAttribute('disabled');
  });

  /* 袋詰めオプションは無地購入でも使えるよう常に有効化 */
  document.querySelectorAll('#bagging-options .order-type__btn')
    .forEach(b=> b.removeAttribute('disabled'));
}








/* ---------- 注文タイプ切替 ---------- */
/* ---------- 注文タイプ切替 ---------- */
// ★★ 修正開始 ★★
/* STEP① のみを対象にする（袋詰めボタンとは分離） */
document
  .querySelectorAll('#step-order-type .order-type__btn')
  .forEach(btn=>{
    btn.addEventListener('click', ()=>{
      /* アクティブ切替 */
      btn.parentElement.querySelectorAll('.order-type__btn')
         .forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');

      /* hidden 更新 */
      document.getElementById('order_type_input').value = btn.dataset.value;

      /* 無地購入なら STEP3〜6 を無効化 */
      toggleStepsDisabled(btn.dataset.value === 'sample');

      updateSummary();                       // ← サマリーも即更新
    });
  });

/* 袋詰めオプション専用ハンドラ */
document
  .querySelectorAll('#bagging-options .order-type__btn')
  .forEach(btn=>{
    btn.addEventListener('click', ()=>{
      /* アクティブ切替 */
      btn.parentElement.querySelectorAll('.order-type__btn')
         .forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');

      /* hidden 更新（none / bag）*/
      document.getElementById('bagging_input').value = btn.dataset.value;

      updateSummary();                       // ← サマリー即更新
    });
  });
/* 印刷面（片面/両面）専用ハンドラ */
document
  .querySelectorAll('#print-sides-options .order-type__btn')
  .forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btn.parentElement.querySelectorAll('.order-type__btn')
         .forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');
      document.getElementById('print_sides_input').value = btn.dataset.value;

      /* ★追加：印刷面変更時、選択中カラーの variantId を新しい印刷面のものに付け替える */
      if (PRINT_OPT_IDX >= 0) {
        const newSide = btn.dataset.value;  // 'one' or 'both'
        const newSelections = {};
        Object.entries(cartSelections).forEach(([key, sel]) => {
          const color  = colorOfVariant(sel.variantId);
          const map    = VARIANT_BY_COLOR_PRINT[color];
          const newVid = map?.[newSide] || sel.variantId;
          const newKey = `${newVid}_${sel.size}`;
          newSelections[newKey] = { variantId: newVid, size: sel.size, qty: sel.qty };
        });
        Object.keys(cartSelections).forEach(k => delete cartSelections[k]);
        Object.assign(cartSelections, newSelections);

        /* 単一サイズ時のパレット data-variant も更新 */
        document.querySelectorAll('.color-swatch--single').forEach(sw => {
          const c = sw.dataset.color;
          const nv = VARIANT_BY_COLOR_PRINT[c]?.[newSide];
          if (nv) sw.dataset.variant = nv;
        });
      }

      updateSummary();
    });
  });






// ★★ 修正終了 ★★
/* 事例掲載（STEP7）専用ハンドラ */
/* データ作成依頼（STEP7）専用ハンドラ */
/* データ作成依頼（STEP7）専用ハンドラ：selectプルダウン */
document.getElementById('design_request_select')
  ?.addEventListener('change', (e) => {
    document.getElementById('design_request_input').value = e.target.value;
    // 選択されたら背景色を変える
    e.target.classList.toggle('is-selected', !!e.target.value);
    updateSummary();
  });



  
document
  .querySelectorAll('#case-consent .order-type__btn')
  .forEach(btn=>{
    btn.addEventListener('click', ()=>{
      /* アクティブ切替 */
      btn.parentElement
         .querySelectorAll('.order-type__btn')
         .forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');

      /* hidden 更新（ok / ng）*/
      document.getElementById('case_consent_input').value = btn.dataset.value;

      updateSummary();   // 注文内容確認を即更新
    });
  });











  if (TF.ENABLE_EXPRESS) {
  /* 出荷スピード（通常 / お急ぎ便）の切り替え */
  (function(){
    const shippingBtns  = document.querySelectorAll('#shipping-options .order-type__btn');
    const shippingInput = document.getElementById('shipping_input');
    if (!shippingBtns.length || !shippingInput) return;

    shippingBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        /* アクティブ切替 */
        btn.parentElement.querySelectorAll('.order-type__btn')
          .forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        /* hidden 更新（normal / express）*/
        shippingInput.value = btn.dataset.value;

        updateSummary();    // サマリー即更新
      });
    });
  })();
  } /* ENABLE_EXPRESS */

/* ページ初期表示は “印刷あり”＝有効 */
toggleStepsDisabled(false);

/* ---------- ステップアイコンスクロール ---------- */
document.querySelectorAll('.btn-step').forEach(btn=>{
  btn.addEventListener('click',()=>{
    const idx = +btn.dataset.step - 1;
const ids = ['order-type','color-size','placement','upload','contact','bagging','case'];


    document.getElementById(`step-${ids[idx]}`)?.scrollIntoView({behavior:'smooth'});
  });
});

/* =========================
   STEP4 入稿：印刷箇所ごとのアップロード欄
   ・「プリント方法と加工位置を選択」で選んだ印刷箇所の数だけ欄を出す（＋まとめ・その他 1欄）
   ・加工位置を選ばない商品（step-placement 非表示）は従来どおり ファイル01〜03
   ・欄の描画は下の renderUploadRows
   ========================= */
const panelUpload = document.getElementById('submitPanelUpload');
const fileRowsEl  = document.getElementById('fileRows');
const statusArea3 = document.getElementById('uploadStatus3');

/* 旧マークアップ（共通ドロップ枠・ローダー・hidden）がテーマ側に残っていても動くように片付ける */
['dropArea3', 'uploadLoader3', 'uploadedFileUrl1', 'uploadedFileUrl2', 'uploadedFileUrl3']
  .forEach(id => document.getElementById(id)?.remove());

function getSubmitType(){
  return 'upload';
}
/* =========================
   STEP5 連絡方法（メール/LINE）
   ========================= */
(function(){
  const wrap = document.getElementById('contactMethod');
  const hidden = document.getElementById('contact_method_input');
  if(!wrap || !hidden) return;

  const cards = wrap.querySelectorAll('.contact-card');
  const radios = wrap.querySelectorAll('input[name="contact_method"]');

  /* ★追加：LINEアカウント名入力欄 */
  const lineWrap  = document.getElementById('line-account-wrap');
  const lineInput = document.getElementById('line_account_input');

  function sync(){
    const checked = wrap.querySelector('input[name="contact_method"]:checked');
    const v = checked?.value || 'email';
    hidden.value = v;

    cards.forEach(card=>{
      const r = card.querySelector('input[name="contact_method"]');
      card.classList.toggle('is-active', r?.checked);
    });

    /* ★追加：LINEを選んだときだけアカウント名入力を表示。メールに戻したら値もクリア */
    const showLine = !!checked && v === 'line' && !SKIP_PROOF_IMAGE;
    if (lineWrap) lineWrap.style.display = showLine ? 'block' : 'none';
    if (!showLine && lineInput) lineInput.value = '';

    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
    if (typeof updateSummary === 'function') updateSummary();
  }

  radios.forEach(r=> r.addEventListener('change', sync));
  /* ★追加：入力のたびにサマリー・未選択リストを更新 */
  lineInput?.addEventListener('input', () => {
    if (typeof updateSummary === 'function') updateSummary();
  });
  sync();
})();

/* ▼追加：事例掲載の可否（ok/ng） */
(function(){
  const wrap  = document.getElementById('case-consent');
  const input = document.getElementById('case_consent_input');
  if(!wrap || !input) return;

  const btns = wrap.querySelectorAll('.case-consent__btn');
  btns.forEach(btn=>{
    btn.addEventListener('click', ()=>{
      btns.forEach(b=>b.classList.remove('is-active'));
      btn.classList.add('is-active');
      input.value = btn.dataset.value; // "ok" or "ng"
      if (typeof updateSummary === 'function') updateSummary();
    });
  });
})();
/* ▲追加ここまで */











function setPanels(){
  if (panelUpload) panelUpload.style.display = '';
  if (typeof updateSummary === 'function') updateSummary();
}

setPanels();

/* AI / PSD / PDF / ZIP 以外を弾く（既存ルール踏襲） */
function isAllowedFile(file){
  const name = (file?.name || '').toLowerCase();
  const allowedExt = ['.ai', '.psd', '.pdf', '.zip', '.png', '.jpg', '.jpeg'];
  return allowedExt.some(ext => name.endsWith(ext));
}

/* ===== 画像データ入稿時の確認モーダル ===== */
/* PNG / JPEG かどうか（AI・PSD・PDF・ZIP は対象外） */
function isImageFile(file){
  const name = (file?.name || '').toLowerCase();
  return ['.png', '.jpg', '.jpeg'].some(ext => name.endsWith(ext));
}

/* 1ページ内で1回だけ出す（3枠すべてで出さない） */
let __imgCheckShown = false;

function openImgCheckModal(){
  const m = document.getElementById('imgcheck-modal');
  if (!m) return;
  if (__imgCheckShown) return;
  __imgCheckShown = true;

  /* ★親要素のtransform等でfixedが効かなくなるため、body直下へ移動 */
  if (m.parentElement !== document.body) document.body.appendChild(m);

  m.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeImgCheckModal(){
  const m = document.getElementById('imgcheck-modal');
  if (!m) return;
  m.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* 閉じる：オーバーレイ / 確認しましたボタン */
document.getElementById('imgcheck-modal')
  ?.addEventListener('click', (e) => {
    if (e.target.closest('[data-imgcheck-close]')) closeImgCheckModal();
  });

/* Escキーでも閉じる */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  const m = document.getElementById('imgcheck-modal');
  if (m && m.getAttribute('aria-hidden') === 'false') closeImgCheckModal();
});

async function uploadFileToServer(file){
  const UPLOAD_API = 'https://goods-upload.vercel.app';
  const SHOP_DOMAIN = 'onday.jp';

  const r1 = await fetch(`${UPLOAD_API}/api/get-upload-url`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ shop: SHOP_DOMAIN, filename: file.name, size: file.size })
  });
  if (!r1.ok) throw new Error(`get-upload-url failed (${r1.status}) ${await r1.text()}`);
  const sig = await r1.json();

  const r2 = await fetch(sig.upload_url, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/octet-stream' },
    body: file
  });
  if (!r2.ok) throw new Error(`upload failed (${r2.status}) ${await r2.text()}`);

  const r3 = await fetch(`${UPLOAD_API}/api/uploaded`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: sig.id })
  });
  if (!r3.ok) throw new Error(`notify failed (${r3.status}) ${await r3.text()}`);

  return `${UPLOAD_API}/api/file/${sig.id}`;
}

/* ===== アップロード欄の描画（印刷箇所が変わるたびに renderRight から呼ばれる） ===== */
const UPL_ACCEPT = '.ai,.psd,.pdf,.zip,.png,.jpg,.jpeg';
let __uplLastHtml = null;

function setUploadStatus(text, isError){
  if (!statusArea3) return;
  statusArea3.classList.toggle('error', !!isError);
  statusArea3.textContent = text || '';
}

function renderUploadRows(){
  if (!fileRowsEl) return;

  const slots  = getUploadSlots();
  const usePlc = uplUsePlacements();
  const hasPlc = usePlc && Array.isArray(placements) && placements.length > 0;

  let html = '';
  if (usePlc){
    html += hasPlc
      ? '<p class="upl-guide">印刷箇所ごとに、印刷するデータをアップロードしてください。</p>'
      : '<p class="upl-guide -empty">「プリント方法と加工位置を選択」で印刷箇所を選ぶと、箇所ごとのアップロード欄がここに表示されます。</p>';
  }

  html += slots.map(s => {
    const f       = uploadedFiles[s.key];
    const loading = uploadingKeys.has(s.key);
    const isAll   = s.key === UPLOAD_ALL_KEY;
    const cls = ['upl-row', f ? 'is-done' : '', loading ? 'is-uploading' : '', isAll ? '-all' : '']
      .filter(Boolean).join(' ');

    const fileHtml = loading
      ? '<span class="upl-row__spinner" aria-hidden="true"></span>アップロード中…'
      : f
        ? `<a href="${uplEsc(f.url)}" target="_blank" rel="noopener" title="${uplEsc(f.name)}">${uplEsc(f.name)}</a>`
        : 'ファイル未選択';

    const titleHtml = s.title
      ? `<span class="upl-row__title"><span class="upl-row__place">${uplEsc(s.title)}</span></span>`
      : '';

    /* ★変更：位置の画像は見出しの左へ。見出し＝画像｜何箇所目＋位置、中身＝ファイル名（1行）とボタン */
    return `
      <div class="${cls}" data-upl-key="${uplEsc(s.key)}">
        <div class="upl-row__head">
          ${s.img ? `<div class="upl-row__headthumb"><img src="${uplEsc(s.img)}" alt=""></div>` : ''}
          <div class="upl-row__headtext">
            <span class="upl-row__badge">${uplEsc(s.badge)}</span>
            ${titleHtml}
          </div>
        </div>
        <div class="upl-row__body">
          <div class="upl-row__main">
                    <div class="upl-row__file">${(f && !loading && f.designNo) ? `<span class="upl-row__design">${uplEsc(designLabel(f.designNo))}</span>` : ''}${fileHtml}</div>
            <div class="upl-row__actions">
              <button type="button" class="upl-row__pick" data-upl-pick ${loading ? 'disabled' : ''}>${f ? 'ファイルを変更' : 'ファイルを選択'}</button>
              ${(f && !loading) ? '<button type="button" class="upl-row__clear" data-upl-clear>削除</button>' : ''}
            </div>
            ${(() => {
              /* ★追加：このブラウザで前にアップロードしたデータから選ぶ（今の欄に入っているもの以外） */
              if (loading || isAll) return '';   /* ★変更：まとめ・その他の欄には出さない */
              const lib = uplLibLoad().filter(x => !f || x.url !== f.url);
              if (!lib.length) return '';
              const open = uplLibOpen.has(s.key);
              return `
              ${open ? `
              <div class="upl-lib">
                <div class="upl-lib__head">
                  <span class="upl-lib__headtext">前にアップロードしたデータ</span>
                  <button type="button" class="upl-lib__close" data-upl-lib>閉じる ×</button>
                </div>
                <p class="upl-lib__title">同じデータを使う場合はここから選んでください（再アップロード不要・同じデザイン番号が付きます）</p>
                ${lib.map(x => `
                  <button type="button" class="upl-lib__item" data-upl-libpick="${uplEsc(x.url)}">
                    <span class="upl-lib__no">${uplEsc(designLabel(x.no))}</span>
                    <span class="upl-lib__name">${uplEsc(x.name || '')}</span>
                    <span class="upl-lib__date">${uplEsc(uplFmtDate(x.ts))}</span>
                  </button>`).join('')}
              </div>` : `
              <button type="button" class="upl-row__lib" data-upl-lib>前にアップロードしたデータから選ぶ ▼</button>`}`;
            })()}
          </div>
        </div>
        <input type="file" accept="${UPL_ACCEPT}" data-upl-input hidden>
      </div>`;
  }).join('');

  if (html === __uplLastHtml) return;   // 変化がなければ描き直さない
  __uplLastHtml = html;
  fileRowsEl.innerHTML = html;
  window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
}
window.__renderUploadRows = renderUploadRows;

/* 指定した欄（key）にファイルをアップロード */
async function handleFile(key, file){
  if (!file || !key) return;
  if (uploadingKeys.has(key)) return;

  const slot  = getUploadSlots().find(s => s.key === key);
  const label = slot ? uplSlotLabel(slot) : '';
  const head  = label ? `${label}：` : '';

  if (!isAllowedFile(file)){
    setUploadStatus(`${head}AI / PSD / PDF / ZIP / PNG / JPEG 以外のファイルはアップロードできません`, true);
    return;
  }
  if (file.size > 50*1024*1024){
    setUploadStatus(`${head}50MB を超えるファイルはアップロードできません`, true);
    return;
  }

  setUploadStatus('', false);
  uploadingKeys.add(key);
  renderUploadRows();

  try{
    /* ★追加：中身の指紋を取り、前にアップロードした同じデータがあればアップロードを省略して同じ番号を使う */
    const hash = await uplFileHash(file);
    const same = uplLibFindByHash(hash);
    if (same){
      uplLibAdd(same.url, same.name, hash);
      uploadedFiles[key] = { url: same.url, name: file.name, designNo: same.no };
      setUploadStatus(`✅ ${head}${file.name} は前にアップロードしたデータと同じ内容のため、${designLabel(same.no)}として登録しました`, false);
    } else {
      const url = await uploadFileToServer(file);
      if (!url) throw new Error('url empty');

      uploadedFiles[key] = { url, name: file.name, designNo: uplLibAdd(url, file.name, hash) };
      setUploadStatus(`✅ ${head}${file.name} をアップロードしました`, false);
    }

    /* 画像（PNG/JPEG）を入稿した場合のみ、確認モーダルを表示 */
    if (isImageFile(file)) openImgCheckModal();
  }catch(err){
    console.error(err);
    setUploadStatus(`${head}アップロードに失敗しました。もう一度お試しください`, true);
  }finally{
    uploadingKeys.delete(key);
    renderUploadRows();
    if (typeof updateSummary === 'function') updateSummary();
  }
}

/* 欄のボタン：ファイルを選択／変更・削除 */
fileRowsEl?.addEventListener('click', e => {
  const row = e.target.closest('.upl-row');
  if (!row) return;
  const key = row.dataset.uplKey;

  if (e.target.closest('[data-upl-pick]')){
    row.querySelector('[data-upl-input]')?.click();
    return;
  }
  /* ★追加：前のデータから選ぶ（開閉） */
  if (e.target.closest('[data-upl-lib]')){
    if (uplLibOpen.has(key)) uplLibOpen.delete(key); else uplLibOpen.add(key);
    renderUploadRows();
    return;
  }
  /* ★追加：前のデータを選んだ → 同じURL・同じデザイン番号で入れる */
  const pick = e.target.closest('[data-upl-libpick]');
  if (pick){
    const hit = uplLibLoad().find(x => x.url === pick.dataset.uplLibpick);
    if (hit){
      uploadedFiles[key] = { url: hit.url, name: hit.name || '', designNo: hit.no, reused: true };
      uplLibOpen.delete(key);
      setUploadStatus(`✅ ${uplSlotLabel(getUploadSlots().find(s => s.key === key) || { badge: '' })}：${designLabel(hit.no)}（${hit.name || ''}）を使います`, false);
      renderUploadRows();
      if (typeof updateSummary === 'function') updateSummary();
    }
    return;
  }
  if (e.target.closest('[data-upl-clear]')){
    delete uploadedFiles[key];
    setUploadStatus('', false);
    renderUploadRows();
    if (typeof updateSummary === 'function') updateSummary();
  }
});

/* ファイル選択 */
fileRowsEl?.addEventListener('change', e => {
  const inp = e.target.closest('[data-upl-input]');
  if (!inp) return;
  const row  = inp.closest('.upl-row');
  const file = inp.files?.[0];
  inp.value = '';   // 同じファイルを再選択できるように
  if (row && file) handleFile(row.dataset.uplKey, file);
});

/* ドラッグ＆ドロップ：落とした欄に入れる */
const uploadStepEl = document.getElementById('step-upload');
const uplClearDragover = () =>
  fileRowsEl?.querySelectorAll('.upl-row.is-dragover').forEach(r => r.classList.remove('is-dragover'));
const uplRowOf = (e) => (e.target instanceof Element) ? e.target.closest('.upl-row') : null;

uploadStepEl?.addEventListener('dragover', e => {
  e.preventDefault();   // 欄の外に落としても、ブラウザがファイルを開いてページが切り替わらないようにする
  const row = uplRowOf(e);
  fileRowsEl?.querySelectorAll('.upl-row.is-dragover').forEach(r => { if (r !== row) r.classList.remove('is-dragover'); });
  if (row && !row.classList.contains('is-uploading')) row.classList.add('is-dragover');
});
uploadStepEl?.addEventListener('dragleave', e => {
  if (!uploadStepEl.contains(e.relatedTarget)) uplClearDragover();
});
uploadStepEl?.addEventListener('drop', e => {
  e.preventDefault();
  uplClearDragover();

  const files = e.dataTransfer?.files;
  if (!files || !files.length) return;

  const row = uplRowOf(e);
  if (!row){
    setUploadStatus('アップロードする欄（印刷箇所）の中にドロップしてください', true);
    return;
  }
  if (files.length > 1){
    setUploadStatus('1つの欄に入れられるのは1ファイルです。複数ある場合はZIPにまとめてください', true);
    return;
  }
  handleFile(row.dataset.uplKey, files[0]);
});

renderUploadRows();




    /* ===================================================================
       ★追加：入稿データの未アップロード確認（カートに入れる前）
       ・必須にはしない（後からメール・LINEで送るお客様もいるため）
       ・「まとめ・その他」にデータがあれば、全箇所そろっている扱い
       =================================================================== */
    let uplSkipConfirmed = false;
    let uplSkipReason    = '';   /* 'skip'＝データなしで進んだ（再注文 or 後から送付） */

    function getMissingUploads(){
      if (uploadedFiles[UPLOAD_ALL_KEY]) return [];
      const slots = getUploadSlots().filter(s => s.key !== UPLOAD_ALL_KEY);
      if (!uplUsePlacements()){
        return slots.some(s => uploadedFiles[s.key]) ? [] : ['入稿データ'];
      }
      return slots
        .filter(s => !uploadedFiles[s.key])
        .map(s => s.badge + (s.title ? `（${s.title}）` : ''));
    }

    function openUploadConfirm(missing){
      let m = document.getElementById('upl-confirm');
      if (!m){
        m = document.createElement('div');
        m.id = 'upl-confirm';
        m.setAttribute('style', 'position:fixed;inset:0;z-index:2147483647;display:flex;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.5);');
        document.body.appendChild(m);
        m.addEventListener('click', (e) => {
          if (e.target === m || e.target.closest('[data-upl-confirm-upload]')){
            m.style.display = 'none';
            document.body.style.overflow = '';
            document.getElementById('step-upload')?.scrollIntoView({ behavior:'smooth', block:'center' });
            return;
          }
          const skipBtn = e.target.closest('[data-upl-confirm-skip]');
          if (skipBtn){
            m.style.display = 'none';
            document.body.style.overflow = '';
            uplSkipConfirmed = true;
            uplSkipReason = skipBtn.getAttribute('data-upl-confirm-skip') || 'skip';
            bulkBtn.click();
          }
        });
      }
      const esc = (t) => String(t).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
      m.innerHTML = `
        <div role="dialog" aria-modal="true" aria-labelledby="upl-confirm-title" style="width:100%;max-width:520px;max-height:calc(100vh - 32px);overflow:auto;background:#fff;border-radius:12px;padding:24px 20px;font-family:'Noto Sans JP',sans-serif;color:#222;box-shadow:0 10px 30px rgba(0,0,0,.2);">
          <p id="upl-confirm-title" style="margin:0 0 10px;font-size:20px;font-weight:900;color:#b9361d;">入稿データがまだアップロードされていません</p>
          <p style="margin:0 0 6px;font-size:16px;font-weight:700;line-height:1.7;">データが未アップロードの箇所：</p>
          <div style="margin:0 0 14px;">
            ${missing.map(t => `<div style="margin:0 0 4px;padding:0;font-size:16px;line-height:1.6;">・${esc(t)}</div>`).join('')}
          </div>
          <p style="margin:0 0 18px;font-size:15px;line-height:1.7;color:#555;">データが揃っていないと、完成イメージの作成・製作に進めません。<br>再注文で前回と同じデータを使う場合や、後からメール・LINEでデータを送る場合は、このままカートに入れて大丈夫です。</p>
          <button type="button" data-upl-confirm-upload style="display:flex;align-items:center;justify-content:center;width:100%;height:56px;margin:0 0 10px;border:0;border-radius:12px;background:#00b8b8;color:#fff;font-family:inherit;font-size:17px;font-weight:900;cursor:pointer;">データをアップロードする</button>
          <button type="button" data-upl-confirm-skip="skip" style="display:flex;flex-direction:column;align-items:center;justify-content:center;width:100%;min-height:60px;padding:6px 10px;border:2px solid #bbb;border-radius:12px;background:#fff;color:#444;font-family:inherit;font-size:16px;font-weight:700;line-height:1.4;cursor:pointer;">このままカートに入れる<span style="font-size:14px;font-weight:500;color:#666;">（再注文で前回と同じデータ／後からメール・LINEで送る）</span></button>
        </div>`;
      m.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    }

    /* ===================================================================
       まとめてカート投入
       =================================================================== */
bulkBtn.addEventListener('click', async () => {

  /* ===== 必須バリデーション ===== */
  let errMsg = document.getElementById('cart-error-msg');
  if (!errMsg){
    errMsg = document.createElement('div');
    errMsg.id = 'cart-error-msg';
    bulkBtn.parentElement.insertBefore(errMsg, bulkBtn);
  }
  errMsg.style.display = 'none';

  /* ★在庫ゲート：販売終了/在庫0が混じっていたら中止 */
  const badStock = [];
  Object.values(cartSelections).forEach(({variantId,size,qty})=>{
    if(qty<=0) return;
    const color = colorOfVariant(variantId);
    const st = getSizeStock(color, size);
    if(st.status === 'discontinued'){ badStock.push(`${color} ${size}：販売終了`); }
    else if(st.status === 'soldout'){ badStock.push(`${color} ${size}：入荷待ち`); }
  });
  if(badStock.length){
    errMsg.innerHTML = '次の商品は現在ご注文いただけません：<br>' + badStock.join('<br>');
    errMsg.style.display = 'block';
     errMsg.scrollIntoView({behavior:'smooth', block:'center'});
    return;
  }

  /* ★追加：入稿データのアップロード中はカートに入れない（そのまま進むとファイルが注文に付かないため） */
  if (uploadingKeys.size){
    errMsg.textContent = '入稿データをアップロード中です。完了してからカートに入れてください。';
    errMsg.style.display = 'block';
    document.getElementById('step-upload')?.scrollIntoView({ behavior:'smooth', block:'center' });
    return;
  }

const orderType = document.getElementById('order_type_input').value;
  const totalQtyCheck = Object.values(cartSelections).reduce((t,i) => t + i.qty, 0);
  const missingSteps = [];

  if (!orderType) missingSteps.push({ id:'step-order-type', label:'ご注文タイプ' });
  if (totalQtyCheck <= 0) missingSteps.push({ id:'step-color-size', label:'カラー / サイズ / 枚数' });

  if (orderType === 'print') {
    if (!isHiddenStep('step-print-sides') && !document.getElementById('print_sides_input')?.value) {
      missingSteps.push({ id:'step-print-sides', label:'印刷面' });
    }
    if (!isHiddenStep('step-placement')) {
      if (!placements.length) {
        missingSteps.push({ id:'step-placement', label:'加工位置' });
      } else if (placements.some(p => !p.method)) {
        missingSteps.push({ id:'step-placement', label:'プリント方法（未選択の箇所があります）' });
      }
      /* ★追加：印刷位置を自分で決める場合は指定内容が必須 */
      const _posDetailEl = document.getElementById('pos_detail_input');
      if (!isPosDetailDone()) {
        missingSteps.push({ id:'step-placement', label:'印刷位置の指定内容' });
        if (_posDetailEl) _posDetailEl.classList.add('is-error');
      } else if (_posDetailEl) {
        _posDetailEl.classList.remove('is-error');
      }
      /* ★追加：調色する場合は色番号が必須 */
      const _chosyokuEl = document.getElementById('chosyoku_code_input');
      if (!isChosyokuDone()) {
        missingSteps.push({ id:'step-placement', label:'調色する色番号' });
        if (_chosyokuEl) _chosyokuEl.classList.add('is-error');
      } else if (_chosyokuEl) {
        _chosyokuEl.classList.remove('is-error');
      }
    }
if (!SKIP_PROOF_IMAGE && !document.querySelector('#contactMethod input[name="contact_method"]:checked')) {
      missingSteps.push({ id:'step-contact', label:'完成イメージの連絡方法' });
    } else if (!isContactStepDone()) {
      /* ★追加：LINE選択なのにアカウント名が空 */
      missingSteps.push({ id:'step-contact', label:'LINEのアカウント名' });
    }
    if (!isHiddenStep('step-bagging') && !document.getElementById('bagging_input')?.value) {
      missingSteps.push({ id:'step-bagging', label:'袋詰めオプション' });
    }
    if (!document.getElementById('design_request_input')?.value) {
      missingSteps.push({ id:'step-design-request', label:'データ作成の依頼有無' });
    }
    if (!document.getElementById('case_consent_input')?.value) {
      missingSteps.push({ id:'step-case', label:'事例紹介への掲載可否' });
    }
  }

  document.querySelectorAll('.tshirt-step.is-error').forEach(el => el.classList.remove('is-error'));

  if (missingSteps.length) {
    const text = '次の項目が未選択です：' + missingSteps.map(m => m.label).join('、');
    errMsg.textContent = text;
    errMsg.style.display = 'block';
    var fe = document.getElementById('floating-error-msg');
    if (fe) { fe.textContent = text; fe.style.display = 'block'; }

    missingSteps.forEach(m => document.getElementById(m.id)?.classList.add('is-error'));
    document.getElementById(missingSteps[0].id)?.scrollIntoView({ behavior:'smooth', block:'center' });
    return;
  }
  /* ===== バリデーションここまで ===== */

  /* ★追加：入稿データが未アップロードなら確認を出す（「このままカートへ」を選んだときだけ先に進む） */
  const _uplSkip = uplSkipConfirmed;
  const _uplReason = _uplSkip ? uplSkipReason : '';   /* 注文情報の「入稿方法」に残す */
  uplSkipConfirmed = false;
  uplSkipReason = '';
  if (orderType === 'print' && !isHiddenStep('step-upload') && !_uplSkip && !uplReceivedByStaff()){   /* ★受け取り済みなら確認を出さない */
    const _missingUploads = getMissingUploads();
    if (_missingUploads.length){
      openUploadConfirm(_missingUploads);
      return;
    }
  }





    const u1 = document.getElementById('uploadedFileUrl1')?.value || '';
const u2 = document.getElementById('uploadedFileUrl2')?.value || '';
const u3 = document.getElementById('uploadedFileUrl3')?.value || '';






const printMethodValue = document.getElementById('print_method_input')?.value || '';
 const printMethodLabel = printMethodValue
                           ? (PRINT_LABEL[printMethodValue] || printMethodValue)
                           : '';                                         // 例）"インクジェット"

  const mainSide        = document.getElementById('plc_main_input').value; // front / back / both
  const printSizeLabel  = getPrintSizeLabel(mainSide);     
  // --- 追加：全体の印刷方法を未設定の箇所へ反映 ---
if (orderType === 'print') {
  const globalMethod = document.getElementById('print_method_input')?.value || '';

  if (globalMethod && Array.isArray(placements)) {
    placements.forEach(p => {
      if (p && !p.method) p.method = globalMethod; // 未設定だけ補完（全部に反映したいなら !p.method を外す）
      normalizeInksByMethod(p);                    // シルク色数の整形も一応
    });
    syncHidden?.();
  }
}

  
  
                  // 例）"フロント: WP / バック: 28×40cm以内"
  /* ---------- (1) Tシャツ本体 ---------- */
const items = Object.values(cartSelections).map(({ variantId, size, qty }) => {
  /* 基本のプロパティ */
  const props = {
    '選択サイズ': size,
  };





// ▼追加：印刷箇所（前面/背面）をカートpropertiesへ
// ▼差し替え：印刷方法・印刷箇所（箇所ごとに別propertiesで入れる）
if (Array.isArray(placements) && placements.length) {
  placements
    .filter(p => p && (p.areaKey || p.area || p.area_id || p.label) && p.method)
    .slice(0, MAX_PLACES)
    .forEach((p, i) => {
      const sideRaw = String(p.side || p.mainSide || '');
      const sideLabel =
        sideRaw === 'front' ? '前面' :
        sideRaw === 'back'  ? '背面' :
        sideRaw || '—';

      const areaText =
        (p.areaText || p.areaLabel || p.label || p.areaName || p.areaKey || p.area || p.area_id || '')
          .toString()
          .trim();

const methodCode = String(p.method || '').trim(); // consult / factory / dtf ...

const methodText = (window.methodLabel)
  ? window.methodLabel(methodCode)
  : methodCode;

const bigText = (p.big && isLargeEligible(p)) ? '【大判】' : '';   /* ★追加：大判 */
props[`印刷方法・印刷箇所（${i+1}箇所目）`] = `${sideLabel}／${areaText}${bigText}／${methodText}`;
const _saText = getSizeAreaText(p);
if (_saText) props[`印刷範囲（${i+1}箇所目）`] = _saText;
props[`_op_method_${i+1}`] = methodCode;

    });
}

// ▲差し替えここまで


function silkInkCount(method){
  const m = String(method || '');
  const mm = m.match(/^silk_(\d)$/);
  if (mm) return Number(mm[1]);
  if (m === 'silk') return 1;
  return 0;
}

function formatInkList(p){
  const n = silkInkCount(p.method);
  if (n <= 0) return ''; // シルク以外は出さない

  const inks = Array.isArray(p.inks) ? p.inks : [];
  const used = inks.slice(0, n).filter(Boolean);

  // シルクなのに未選択なら事故防止で明示
  if (!used.length) return '／インク：未選択';

return `／インク：${used.map(k => INK_NAME_MAP[k] || k).join('・')}`;

}







/* ▼追加：位置指定（auto/specify）をpropertiesへ（無地購入では付与しない） */
if (orderType !== 'sample') {
  const posChoice = document.getElementById('pos_choice_input')?.value || 'auto';
  props['位置指定'] = (posChoice === 'specify') ? '位置の指定をする' : '位置の調整はおまかせ';
  /* ★追加：指定内容を注文情報に残す */
  if (posChoice === 'specify') {
    const posDetail = (document.getElementById('pos_detail_input')?.value || '').trim();
    if (posDetail) props['印刷位置の指定内容'] = posDetail;
  }
}
/* ▲追加ここまで */

/* ▼追加：調色オプション（色数・色番号）をpropertiesへ */
const _cyCount = getChosyokuCount();
if (_cyCount > 0) {
  props['調色の色番号'] = getChosyokuCode();
}
/* ▲追加ここまで */

/* ▼ 追加：入稿方法 & アップロードURL最大3つ（無地購入では付与しない） */
if (orderType !== 'sample') {
props['入稿方法'] = 'アップロード入稿';
  if (!SKIP_PROOF_IMAGE) {
    const contactMethod = document.getElementById('contact_method_input')?.value || 'email';
    props['完成イメージ連絡'] = (contactMethod === 'line') ? 'LINE' : 'メール';
    /* ★追加：LINEのときはアカウント名も注文情報に残す */
    if (contactMethod === 'line') {
      const lineAcc = (document.getElementById('line_account_input')?.value || '').trim();
      props['LINEアカウント名'] = lineAcc || '未入力';
    }
  }

  /* ★変更：入稿データURLは印刷箇所ごとの項目名で入れる
     例）入稿データURL_01（前面／左胸 ワンポイント W10×H10）／入稿データURL_まとめ・その他 */
  Object.assign(props, getUploadProps());
  /* ★追加：未アップロードのまま進んだ理由を残す（スタッフ確認用） */
  if (_uplReason) props['入稿方法'] = 'データ未アップロード（再注文で前回と同じデータ／後からメール・LINEで送付）';
  /* ★追加：お客様用URLで担当者が「受け取り済み」にしたもの */
  if (uplReceivedByStaff()) props['入稿方法'] = '入稿データ受け取り済み（メール・LINE）';
}
/* ▲ 追加ここまで */




   props['袋詰め'] = document.getElementById('bagging_input').value === 'bag' ? 'あり' : 'なし';
/* 2026-10-26：担当者からのメモ（料金がなくても、本体の商品の行に入れる） */
if (STAFF_FEES && STAFF_FEES.memo) props['担当者からのメモ'] = STAFF_FEES.memo;
/* 2026-10-26：別の商品と同じ版で印刷する箇所 */
(Array.isArray(placements) ? placements : []).slice(0, MAX_PLACES).forEach((pp, i) => {
  if (pp && isSilk(pp.method) && pp.sharedPlate) props[`版（${i + 1}箇所目）`] = sharedPlateText(pp, totalQtyCheck);
});
if (orderType !== 'sample') {
  const _drVal = document.getElementById('design_request_input').value;
  props['データ作成依頼'] =
    _drVal === 'no'   ? 'なし' :
    _drVal === '1100' ? 'あり（¥1,100）' :
    _drVal === '3300' ? 'あり（¥3,300）' :
    _drVal === '5500' ? 'あり（¥5,500）' :
    'なし';
}


   /* ★ここを追加：備考欄の入力があれば付与 */
const notes = document.getElementById('notes_input')?.value.trim();
if (notes) props['備考'] = notes;
/* ▼2026-10-27：画面に出していた出荷予定日（目安）を注文に残す */
{ const _ship = (document.getElementById('delivery-date')?.textContent || '').trim();
  if (_ship && _ship !== '－' && _ship !== '計算中…') props[(STAFF_FEES && STAFF_FEES.ship) ? '出荷予定日（担当者指定）' : '出荷予定日（目安）'] = _ship;   /* 2026-11-02 */
  const _mode = document.getElementById('delivery_mode_input')?.value || '';
  const _wish = document.getElementById('wish_date_input');
  if (_mode === 'date' && _wish && _wish.value && (!_wish.min || _wish.value >= _wish.min)) props['お届け希望日'] = formatJaDate(shipParse(_wish.value));
  else if (_mode === 'none') props['お届け希望日'] = '指定なし（最短で発送）'; }
/* ▼追加：事例掲載の可否をpropertiesへ（無地購入では付与しない） */
if (orderType !== 'sample') {
  const caseConsent = document.getElementById('case_consent_input')?.value || 'ok';
  props['事例掲載'] = (caseConsent === 'ok') ? '掲載OK' : '掲載NG';
}
/* ▲追加ここまで */
/* ▼追加：自動お見積りページから来た注文（見積り番号。カート・決済画面には出ない） */
{ let _qid = ''; try{ _qid = sessionStorage.getItem('odp_quote_qid:' + location.pathname) || ''; }catch(e){} if (_qid) props['_op_自動見積りから'] = _qid; }
/* ▼追加：担当者が作ったお客様用URLからの注文（スタッフ確認用。_op_ で始まる項目はカート・決済画面に出ず、管理画面の注文には残る） */
if (window.__odpLinkInfo) props['_op_担当者作成URL'] = window.__odpLinkInfo.memo || 'あり';
/* 2026-10-27：どのお客様用URLからの注文か（担当者の一覧で「注文済み」を出すため） */
if (window.__odpLinkInfo && window.__odpLinkInfo.h) props['_op_お客様用URL'] = window.__odpLinkInfo.h;
/* 2026-10-27：同じ商品を別のデザインで注文するとき（工場で見分けられるように） */
if (window.__odpLinkInfo && window.__odpLinkInfo.design) props['デザイン'] = `デザイン${window.__odpLinkInfo.design}`;
/* ▼追加：印刷面（片面/両面）（無地購入では付与しない） */
if (orderType !== 'sample' && !isHiddenStep('step-print-sides')) {
  const _ps = document.getElementById('print_sides_input')?.value || '';
  props['印刷面'] = _ps === 'both' ? '両面印刷' : '片面印刷';
}
/* ▲追加ここまで */


    /* ★★ ここから追加：出荷スピード ★★ */
    const shippingInputEl2 = document.getElementById('shipping_input');
    if (shippingInputEl2) {
      props['出荷スピード'] =
        shippingInputEl2.value === 'express' ? 'お急ぎ便' : '通常出荷';
    }
    /* ★★ 追加ここまで ★★ */



  /* 印刷ありのときだけ印刷サイズを付与 ----------------------- */
  if (orderType === 'print' && printSizeLabel){
    props['印刷サイズ'] = printSizeLabel;      // ★ ここが今回の追加 ★
    if (printMethodLabel) props['印刷方法']   = printMethodLabel;   // ★ 追加行
  }

  /* 無地購入の場合だけ追加 ----------------------------- */
  if (orderType === 'sample') {
    props['注文タイプ'] = '無地購入';   // ←好きなキー名／表示文で OK
  }
// ★★ ここに追加 ★★
placements.forEach((p, i) => {
  const n = silkInkCount(p.method);
  if (n > 0){
    const inks = (Array.isArray(p.inks) ? p.inks : [])
      .slice(0, n)
      .filter(Boolean)
      .map(k => INK_NAME_MAP[k] || k); // ★ key → name

    props[`インクカラー（${i+1}箇所目）`] =
      inks.length ? inks.join('・') : '未選択';
    /* 2026-10-22：インクの色替え：この本体の色のインクを書く */
    if (p.inkChange && canInkChange(p)) {
      const bodyInk = inkNameOf(inkOfBody(p, colorOfVariant(variantId)));
      if (bodyInk) props[`インクカラー（${i+1}箇所目）`] = bodyInk + '（商品の色でインクを分ける）';
    }
  }
});

// ★★ ここまで ★★

  return {
    id:        variantId,
    quantity:  qty,
    properties: props
  };
});

  /* ---------- (2) 追加料金 SKU ---------- */
  const surchargeMap = {};
  Object.values(cartSelections).forEach(({ size, qty }) => {
    const sid = getSurchargeVariantId(size);
    if (sid) surchargeMap[sid] = (surchargeMap[sid] || 0) + qty;
  });
  Object.entries(surchargeMap).forEach(([id, qty]) => {
    items.push({ id: Number(id), quantity: qty });
  });

 /* ---------- (3) プリント方法 × 面（箇所ごとに別バリアントで投入） ---------- */
const totalQty = Object.values(cartSelections).reduce((t, i) => t + i.qty, 0);

/* ✅ 無地購入（sample）は合計10枚以上必須 */
if (orderType === 'sample' && totalQty < 10) {
  alert('無地購入は合計10枚以上からカートに入れられます。');
  return; // bulkBtn click の中なのでOK
}


/* 印刷ありのときだけ印刷バリデーション & SKU 追加 */
let printMethod = '';
let pmRaw = '';
let pm = '';

if (orderType === 'print' && !isHiddenStep('step-placement')) {
  printMethod = document.getElementById('print_method_input')?.value || '';
  pmRaw = printMethod;        // silk_1/2/3 を保持
  pm    = baseMethod(pmRaw);  // omakase/dtf/inkjet/silk に正規化

  if (!printMethod) {
    alert('印刷方法を選択してください');
    return;
  }

  /* 2026-10-26：シルクの10枚未満はサンプル・少量として受ける（10枚以上の制限はなくした） */
  /* 2026-10-22：版を分けたときは1版10枚以上 */
  const plateNgList = [];
  (Array.isArray(placements) ? placements : []).slice(0, MAX_PLACES).forEach((p, i) => {
    if (p && isSilk(p.method) && !p.repeat && !p.sharedPlate) plateShortGroups(p).forEach(g => plateNgList.push(`${i + 1}箇所目の${g.sizes.join('・')}の版が${g.qty}枚`));
  });
  /* 2026-10-22：リピートは前回の注文番号が必須 */
  const repeatNoMissing = (Array.isArray(placements) ? placements : []).slice(0, MAX_PLACES)
    .map((p, i) => (p && isSilk(p.method) && p.repeat && !String(p.repeatOrderNo || '').trim()) ? `${i + 1}箇所目` : '')
    .filter(Boolean);
  /* 2026-10-22：インクの色替えは、本体の色ごとのインクが全部選ばれていること */
  const inkBodyMissing = (Array.isArray(placements) ? placements : []).slice(0, MAX_PLACES)
    .map((p, i) => (p && p.inkChange && canInkChange(p) && bodyColorQtyList().some(x => !inkOfBody(p, x.c))) ? `${i + 1}箇所目` : '')
    .filter(Boolean);
  if (inkBodyMissing.length) {
    alert('「商品の色でインクを分ける」で、インクを選んでいない商品の色があります。\n\n' + inkBodyMissing.join('、'));
    return;
  }
  if (repeatNoMissing.length) {
    alert('リピート（前回の版を使う）の場合は、前回の注文番号を入力してください。\n\n' + repeatNoMissing.join('、'));
    return;
  }
  if (plateNgList.length) {
    alert('シルクスクリーンは1版10枚以上必要です。\n\n' + plateNgList.join('\n') + '\n\n版の分け方を「全サイズ共通（1版）」にするか、枚数を見直してください。');
    return;
  }
/* ===== バリデーション：シルクなのに色が未選択はNG ===== */
if (orderType === 'print'){
  for (let idx = 0; idx < MAX_PLACES; idx++){
    const p = placements?.[idx];
    if (!p) continue;

    if (isSilkMethod(p.method)){
      const colors = getSilkColorCount(placements, idx);

      if (colors < 1){
        alert(`シルクスクリーン（${idx+1}箇所目）のインクカラーを1色以上選択してください`);
        return;
      }

      // 保険：対応表にIDが無い時（登録漏れ）
      const vid = getSilkVariantIdByPlacement(placements, idx);
      if (!vid){
        alert(`シルクスクリーン（${idx+1}箇所目）で、${colors}色の料金商品が未設定です（variantId未登録）`);
        return;
      }
    }
  }
}

  // 有効な箇所だけ（最大4）
const validPlacements = (Array.isArray(placements) ? placements : [])
  .filter(p => p && p.method && baseMethod(p.method) && (p.areaKey || p.area))
  .slice(0, MAX_PLACES)
  .map(p => ({
    side: (p.side || 'front'),
    areaKey: (p.areaKey || p.area || '').trim(),
    method: p.method, // ← ★追加（箇所ごとの method を保持）
    big: !!p.big && isLargeEligible(p)   // ★追加：大判
  }));


  if (!validPlacements.length) {
    alert('印刷箇所を選択してください');
    return;
  }

/* ★追加：バリアントID未登録の加工代・版代を集める */
 const missingFees = [];

 validPlacements.forEach((p, idx) => {
  const placeNo = idx + 1;
  const side    = p.side;
  const areaKey = p.areaKey;

const pmRawPlace = p.method || '';
  const pmPlace    = baseMethod(pmRawPlace); // ← ★箇所ごと

// ✅ 相談系（consult/factory）は加工代を計算せず、別途お見積り扱いにする
  if (pmPlace === 'consult' || pmPlace === 'factory') {
    return;
  }

// ✅ シルク版代（箇所ごと）
  if (pmPlace === 'silk') {
    /* ★変更：大判のときは特大版の版代 */
    const pid = p.big ? SILK_PLATE_XL_VARIANT : SILK_PLATE_VARIANTS?.[areaKey];
    const colorCount = getSilkColorCount(placements, placeNo - 1);

    /* 2026-10-22：シルクのオプション（セットアップ代・版の清掃代・特殊インク） */
    silkOptionLines(placements[placeNo - 1] || p, placeNo - 1, totalQty).forEach(ln => {
      items.push({ id: Number(ln.variant), quantity: ln.qty, properties: ln.props });
    });
    const sp0 = placements[placeNo - 1] || p;
    if (sp0.repeat || sp0.sharedPlate) {
      /* リピート・ほかと同じ版は版代なし（大判加算は印刷代なので下で入れる） */
      if (p.big) {
        const addVidR = SILK_LARGE_ADD_VARIANTS?.[colorCount]?.[silkLargeBand(silkEffQty(sp0, totalQty))];
        if (addVidR) items.push({ id: Number(addVidR), quantity: totalQty, properties: { '大判加算': `${placeNo}箇所目` } });
      }
      return;
    }
    if (!pid) {
      missingFees.push(`${placeNo}箇所目：シルクスクリーンの版代（${areaKey}）`);
    } else if (colorCount > 0) {
      /* 2026-10-22：版代は「サイズ分けの数 × 色数」。版の分け方も残す */
      const srcPlace = placements[placeNo - 1] || p;
      const nGroups = plateCountOf(srcPlace);
      items.push({
        id: Number(pid),
        quantity: colorCount * nGroups,
        properties: Object.assign(
          { '版代': `${placeNo}箇所目${p.big ? '（特大版）' : ''}`, '色数': `${colorCount}色` },
          nGroups > 1 ? { '版の分け方': plateSplitText(srcPlace), '版の数': `${colorCount * nGroups}版（サイズ分け${nGroups} × ${colorCount}色）` } : {}
        )
      });
      /* ★追加：大判加算（印刷代の2割増ぶん） */
      if (p.big) {
        const addVid = SILK_LARGE_ADD_VARIANTS?.[colorCount]?.[silkLargeBand(totalQty < 10 ? 10 : totalQty)];   /* 2026-10-26：10枚未満は10〜19枚の区分 */
        if (!addVid) {
          missingFees.push(`${placeNo}箇所目：シルクスクリーンの大判加算`);
        } else {
          items.push({
            id: Number(addVid),
            quantity: totalQty,
            properties: { '大判加算': `${placeNo}箇所目` }
          });
        }
      }
    }
    return; // ← ★シルクはここで終了（加工代は下の別ループで入れてる）
  }
// ✅ 印刷代（加工代）
let feeVid = null;

// ★修正：DTF も 2-3箇所目は EXTRA_PRINT_VARIANTS を使う
if (pmPlace === 'dtf') {
  if (placeNo === 1) {
    feeVid = PRINT_VARIANTS?.dtf?.[side]?.[areaKey] || null;
  } else {
    feeVid = EXTRA_PRINT_VARIANTS?.dtf?.[areaKey]?.[placeNo] || null;
  }
}
// inkjet/omakase：1箇所目はPRINT_VARIANTS、2-3箇所目はEXTRA_PRINT_VARIANTS
else if (placeNo === 1) {
  feeVid = PRINT_VARIANTS?.[pmPlace]?.[side]?.[areaKey] || null;
} else {
  feeVid = EXTRA_PRINT_VARIANTS?.[pmPlace]?.[areaKey]?.[placeNo] || null;
}


if (!feeVid) {
    console.warn('[print fee] variant missing:', { pmPlace, side, areaKey, placeNo });
    missingFees.push(`${placeNo}箇所目：${window.methodLabel(pmRawPlace)}の加工代（${areaKey}）`);
    return;
  }

  items.push({ id: Number(feeVid), quantity: totalQty });

  /* ★追加：大判追加料金（DTF・インクジェット） */
  if (p.big && (pmPlace === 'dtf' || pmPlace === 'inkjet')) {
    items.push({
      id: Number(LARGE_FEE_VARIANTS[largeFeeKey(totalQty)]),
      quantity: totalQty,
      properties: { '大判': `${placeNo}箇所目` }
    });
  }
});

/* ★追加：加工代・版代のバリアントID未登録があればカート投入を中止（請求漏れ防止） */
if (missingFees.length) {
  alert(
    '以下の加工代が未設定のため、このお見積りではカートに入れられません。\n\n'
    + missingFees.join('\n')
    + '\n\nお手数ですが、お問い合わせよりご相談ください。'
  );
  return;
}


}
/* ---------- ここまで ---------- */




/* ★ お急ぎ便が選ばれている場合は追加料金商品を 1 個追加 ★ */
const shippingInputElForCart = document.getElementById('shipping_input');
if (shippingInputElForCart && shippingInputElForCart.value === 'express') {
  items.push({
    id:       EXPRESS_FEE_VARIANT,
    quantity: 1
  });
}
  // ── ここから追加 ──
  // (4) 袋詰めオプション「あり」のとき、個包装商品を同数だけ追加
const bagging = document.getElementById('bagging_input').value;  // 'none' or 'bag'
if (bagging === 'bag') {
  items.push({
    id:       BAGGING_VARIANT,
    quantity: totalQty
  });
}
// (5) データ作成依頼：選択された金額の商品を1つ追加（無地購入では課金しない）
  const designRequest = document.getElementById('design_request_input').value;
  const drPriceKey = parseInt(designRequest, 10);
  if (orderType !== 'sample' && [1100, 3300, 5500].includes(drPriceKey)) {
    items.push({
      id:       DESIGN_REQUEST_VARIANTS[drPriceKey],
      quantity: 1
    });
  }




/* ===== シルクの「箇所×色数」商品を items に追加 =====
   - 1箇所目=idx0 / 2箇所目=idx1 / 3箇所目=idx2
   - 価格が「1注文あたり」なら quantity: 1 のままでOK
*/
/* ===== シルクの「箇所×色数」商品を items に追加（本体枚数と同数） ===== */
/* ★無地購入(sample)では placements が残っていても課金しない */
if (orderType === 'print') {
  for (let idx = 0; idx < MAX_PLACES; idx++){
    const vid = getSilkVariantIdByPlacement(placements, idx);
    if (vid){
      items.push({
        id: Number(vid),
        quantity: totalQty, // ★本体の数量と同じ枚数にする
        properties: Object.assign({
          _op_kind: 'silkscreen_fee',
          _op_place_index: String(idx + 1),
          _op_colors: String(getSilkColorCount(placements, idx)),
        }, (placements[idx] && placements[idx].inkChange && canInkChange(placements[idx]))
          ? { 'インクの分け方（商品の色ごと）': inkChangeText(placements[idx]) } : {})
        /* 2026-10-26：別の商品と同じ版のときも、印刷代の商品には何も足さない（同じ内容の行どうしがカートで1行にまとまり、枚数が合計される）。
           「別の商品と同じ版」は本体の商品の項目に残す */
      });
    }
  }

  /* ★追加：調色料（1色あたり）を色数ぶん追加 */
  const chosyokuCount = getChosyokuCount();
  if (chosyokuCount > 0){
    items.push({
      id: CHOSYOKU_VARIANT,
      quantity: chosyokuCount,
      properties: {
        '色番号': getChosyokuCode()
      }
    });
  }

  /* 2026-10-22：担当者が自動お見積りで入れた追加料金 */
  staffFeeLines().forEach((ln, i) => {
    const props = { '追加料金': ln.design ? 'データ作成費（担当者のお見積りより）' : ln.express ? '特急料金（担当者のお見積りより）' : '担当者のお見積りより' };
    /* 2026-10-26：メモは料金の行ではなく、本体の商品の行に入れる（気づきやすいように） */
    items.push({ id: Number(ln.variant), quantity: ln.qty, properties: props });
  });
}







 /* ---------- (5) カート投入 ---------- */
    /* ★ローダーを即表示（カート遷移までのタイムラグ対策） */
    const cartLoadingOverlay = document.getElementById('cart-loading-overlay');
    if (cartLoadingOverlay) {
      cartLoadingOverlay.classList.add('is-active');
      cartLoadingOverlay.setAttribute('aria-hidden', 'false');
    }

    try {
    const res = await fetch('/cart/add.js', {
      method : 'POST',
      headers: { 'Content-Type': 'application/json' },
      body   : JSON.stringify({ items })
    });
    

    /* 成功ならカートへリダイレクト ---------------------------- */
/* 成功ならカートへリダイレクト ---------------------------- */
if (res.ok) {
  // ★ここで備考欄を cart note に保存する
  /* 2026-11-04：注文のメモ（cart note）は、いまカートにある商品の「担当者からのメモ」「備考」だけで作り直す
     （前は今のメモに足していたので、カートから消した商品や前の注文の備考がメモに残ることがあった）
     ※カートのページ（snippets/cart.liquid）でも、開いたとき・商品を消したときに同じやり方で作り直す */
  try {
    const cart = await (await fetch('/cart.js', { cache: 'no-store' })).json();
    const parts = [];
    (cart.items || []).forEach(it => {
      const pr = it.properties || {};
      const m = String(pr['担当者からのメモ'] || '').trim();
      const n = String(pr['備考'] || '').trim();
      if (m) parts.push('【担当者からのメモ】\n' + m);
      if (n) parts.push(n);
    });
    const note = [...new Set(parts)].join('\n\n');
    if ((cart.note || '') !== note){
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });
    }
  } catch(e) {
    console.warn('cart note 更新失敗', e);
  }

  window.__tfDraftClear && window.__tfDraftClear();   /* ★追加：カートに入ったら途中保存を消す */
  try{ sessionStorage.removeItem('odp_quote_qid:' + location.pathname); }catch(e){}   /* ★追加：見積りの印も消す */
  /* ★追加：お客様用URL（複数商品）のときは、カートではなく次の商品を開く */
  const nextLink = window.__odpLinkNext && window.__odpLinkNext();
  if (nextLink){
    window.location.href = nextLink;
    /* 2026-10-27：次も同じ商品（別のデザイン）のときは、URLが同じで開き直さないので読み込み直す */
    if (nextLink.split('#')[0] === location.pathname) window.location.reload();
    return;
  }
  window.location.href = '/cart';
  return;  // ★成功時はローダーを出したまま遷移（消さない）
}

    /* 失敗時：Shopify からのメッセージを取り出して表示 -------- */
    if (cartLoadingOverlay) {
      cartLoadingOverlay.classList.remove('is-active');
      cartLoadingOverlay.setAttribute('aria-hidden', 'true');
    }
    let msg = `カート追加に失敗しました（${res.status}）`;
    try {
      const data = await res.json();               // {"status":422,"message":...}
      msg = data.description || data.message || msg;
    } catch (_) {
      /* JSON でなければ無視して既定メッセージを採用 */
    }
    alert(msg);

  } catch (err) {
    if (cartLoadingOverlay) {
      cartLoadingOverlay.classList.remove('is-active');
      cartLoadingOverlay.setAttribute('aria-hidden', 'true');
    }
    console.error(err);
    alert('通信エラーが発生しました。時間をおいて再度お試しください。');
  }
});






/* ==== ▼ 出荷予定日（2026-10-27：納品予定日から変更） ▼ ===================== */
/*
  ※ この下の変数は var（updateSummary がこの行より先に呼ばれることがあるため。let/const だとエラーになる）
  出荷予定日は、工場の混み具合から自動で計算する API（rafees-congestion /api/capacity）で出す。
  ・印刷方法ごとに「工程数＝枚数×その方法の印刷箇所数」を出して API に聞き、いちばん遅い日を使う
  ・表示は「11/2（月）〜11/5（木）ごろ」の幅（正式な出荷予定日は決済・デザイン確認後にメールで案内）
  ・ご注文から完成イメージのOKまで CONFIRM_DAYS 営業日かかる見込みで、その分後ろにずらして出す（API に ?confirm= で渡す）
  ・休業日は土日・祝日（下の一覧）＋営業日カレンダーの臨時休業日。API 側でも同じ考え方で計算している
  ・API が読めないときは下の SHIP_RULE（営業日数の表）で計算する
  日数の表を変えるときは、API（api/capacity.js の TIERS）と下の SHIP_RULE の両方を変える。
*/
var CAPACITY_URL = 'https://rafees-congestion.vercel.app/api/capacity';
var SHIP_RULE = {
  di:   [ { max: 10, days: [4, 6] }, { max: 99, days: [5, 8] }, { max: Infinity, days: [7, 10] } ],
  silk: [ { max: 99, days: [7, 10] }, { max: Infinity, days: [9, 12] } ],
};
/* 祝日（土日と重なる日は省略）。snippets/ondp-business-calendar.liquid・API と同じ一覧 */
var SHIP_JP_HOLIDAYS = {
  2026: '01-01,01-12,02-11,02-23,03-20,04-29,05-04,05-05,05-06,07-20,08-11,09-21,09-22,09-23,10-12,11-03,11-23',
  2027: '01-01,01-11,02-11,02-23,03-22,04-29,05-03,05-04,05-05,07-19,08-11,09-20,09-23,10-11,11-03,11-23',
  2028: '01-10,02-11,02-23,03-20,05-03,05-04,05-05,07-17,08-11,09-18,09-22,10-09,11-03,11-23',
  2029: '01-01,01-08,02-12,02-23,03-20,04-30,05-03,05-04,07-16,09-17,09-24,10-08,11-23',
  2030: '01-01,01-14,02-11,03-20,04-29,05-03,05-06,07-15,08-12,09-16,09-23,10-14,11-04',
};
var SHIP_HOLIDAYS = Object.keys(SHIP_JP_HOLIDAYS).reduce(function (a, y) {
  return a.concat(SHIP_JP_HOLIDAYS[y].split(',').map(function (md) { return y + '-' + md; }));
}, []);
/* 営業日カレンダー（管理画面のメタオブジェクト）。liquid が window.ONDP_SHIP_CAL に入れる
   off＝臨時休業日（事務）／on＝臨時営業日（事務）／factoryOff＝工場の休業日 */
function shipCal(){ const c = window.ONDP_SHIP_CAL || {}; return { off: c.off || [], on: c.on || [], factoryOff: c.factoryOff || [] }; }
var shipQuoteCache = {};
/* ご注文から完成イメージのOKまでの見込み（営業日）。出荷予定日はこの日数だけ後ろにずらして出す */
var CONFIRM_DAYS = 2;
/* お客様用URLで「完成イメージ確認済み」にした注文は足さない（担当者がURLを作るときにチェック） */
function confirmDays(){ return (window.__odpLinkInfo && window.__odpLinkInfo.confirmed) ? 0 : CONFIRM_DAYS; }
function shipShift(r){
  const n = confirmDays();
  if (!r || !n) return r;
  return { from: addBusinessDays(r.from, n, 'office'), to: addBusinessDays(r.to, n, 'office'), busy: r.busy };
}

function shipYmd(d){
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}

/* 土日・祝日を除いて営業日を加算
   mode 'office'＝事務の営業日（臨時休業日を休み・臨時営業日を営業日）／それ以外＝工場の営業日（工場の休業日を休み） */
function addBusinessDays(baseDate, days, mode){
  if (!days || days <= 0) return null;
  const d = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  let remain = days;
  while (remain > 0){
    d.setDate(d.getDate() + 1);
    const w = d.getDay(); // 0:日, 6:土
    const ymd = shipYmd(d);
    const cal = shipCal();
    const weekday = w !== 0 && w !== 6 && SHIP_HOLIDAYS.indexOf(ymd) < 0;
    const work = mode === 'office'
      ? (cal.on.indexOf(ymd) >= 0 || (weekday && cal.off.indexOf(ymd) < 0))
      : (weekday && cal.factoryOff.indexOf(ymd) < 0);
    if (work){
      remain--;
    }
  }
  return d;
}

/* 日本語フォーマット M/D（曜） */
function formatJaDate(date){
  if (!date) return '－';
  const youbi = '日月火水木金土'[date.getDay()];
  return `${date.getMonth() + 1}/${date.getDate()}（${youbi}）`;
}
function shipParse(ymd){
  const p = String(ymd || '').split('-').map(Number);
  return p.length === 3 ? new Date(p[0], p[1] - 1, p[2]) : null;
}

/* 印刷箇所の数（無地購入・未選択は1として扱う） */
function getPlaceCountForDelivery(){
  const isSample = document.getElementById('order_type_input')?.value === 'sample';
  if (isSample) return 1;
  const n = (Array.isArray(placements) ? placements : []).filter(Boolean).slice(0, MAX_PLACES).length;
  return Math.max(1, n);
}

/* 印刷方法ごとの工程数 { dtf: 20, ij: 10, silk: 30 }（API の method 名に合わせる） */
function shipWorkByMethod(totalQty){
  const isSample = document.getElementById('order_type_input')?.value === 'sample';
  const work = {};
  if (isSample){ work.dtf = totalQty; return work; }       // 無地購入は DTF の少量と同じ扱い
  const list = (Array.isArray(placements) ? placements : []).filter(Boolean).slice(0, MAX_PLACES);
  list.forEach((p) => {
    const m = baseMethod(p.method);
    const key = m === 'silk' ? 'silk' : (m === 'inkjet' ? 'ij' : 'dtf'); // おまかせ・相談・未選択は DTF として見る
    work[key] = (work[key] || 0) + totalQty;
  });
  if (!Object.keys(work).length) work.dtf = totalQty;
  return work;
}

/* API が読めないときの計算（営業日数の表） */
function shipFallback(method, kotei){
  const rows = SHIP_RULE[method === 'silk' ? 'silk' : 'di'];
  const r = rows.find((x) => kotei <= x.max) || rows[rows.length - 1];
  const today = new Date();
  /* 完成イメージのOKの日（事務の営業日で数える）の翌日から、制作日数を工場の営業日で数える */
  const n = confirmDays();
  const ok = n ? addBusinessDays(today, n, 'office') : today;
  return { from: addBusinessDays(ok, r.days[0]), to: addBusinessDays(ok, r.days[1]), busy: false };
}

async function shipQuote(method, kotei){
  const cd = confirmDays();
  const key = method + ':' + kotei + ':' + cd;
  if (shipQuoteCache[key]) return shipQuoteCache[key];
  const url = `${CAPACITY_URL}?method=${encodeURIComponent(method)}&kotei=${kotei}&jobs=1&confirm=${cd}`;
  shipQuoteCache[key] = fetch(url)
    .then((r) => r.json())
    .then((data) => {
      const q = data && data.quote;
      if (!q || !q.ship) throw new Error('no quote');
      const r = { from: shipParse(q.ship.from), to: shipParse(q.ship.to), busy: q.status === 'busy' };
      // 古い API（?confirm= を知らない）のときは、ここでずらす
      return (q.confirmDays || 0) === cd ? r : shipShift(r);
    })
    .catch(() => { delete shipQuoteCache[key]; return shipFallback(method, kotei); });
  return shipQuoteCache[key];
}

/* お届け希望日（STEP「お届け日の指定」）：選べる最初の日＝出荷予定日の遅い方の翌日（北海道・沖縄は2日後） */
var WISH_MIN_DAYS = 1;
function wishAddDays(d, n){ return new Date(d.getFullYear(), d.getMonth(), d.getDate() + n); }
function wishRangeText(min){
  return `${formatJaDate(min)}以降を選べます（北海道・沖縄は${formatJaDate(wishAddDays(min, 1))}以降）`;
}
/* メッセージを言葉の切れ目で改行させる（「。」の後と「（北海道」の前で区切って、かたまりごとに改行） */
function setWishMsg(msg, text){
  if (!msg) return;
  const parts = String(text || '').split(/(?<=。)|(?=（北海道)/).filter(Boolean);
  msg.innerHTML = parts.map((p) => `<span style="display:inline-block">${p.replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]))}</span>`).join('');
}
/* カレンダーで選ぶ（2026-10-27）：選べない日は灰色 */
var wishShip = { from: null, to: null };
var wishView = null;          // 表示中の月の1日
var WISH_MAX_DAYS = 90;       // 選べる最後の日（今日から）
function wishSame(a, b){ return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate(); }
function renderWishCal(){
  const box = document.getElementById('wish-cal');
  const input = document.getElementById('wish_date_input');
  if (!box || !input) return;
  const min = shipParse(input.min);
  if (input.disabled || !min){
    box.innerHTML = '<div class="wish-cal__empty">枚数と印刷方法を選ぶと、カレンダーが出ます</div>';
    return;
  }
  const today = new Date();
  const max = wishAddDays(new Date(today.getFullYear(), today.getMonth(), today.getDate()), WISH_MAX_DAYS);
  const sel = shipParse(input.value);
  if (!wishView) wishView = new Date(min.getFullYear(), min.getMonth(), 1);
  const first = new Date(wishView.getFullYear(), wishView.getMonth(), 1);
  const last = new Date(wishView.getFullYear(), wishView.getMonth() + 1, 0);
  const minMonth = new Date(Math.min(min.getTime(), (wishShip.from || min).getTime()));
  const canPrev = first > new Date(minMonth.getFullYear(), minMonth.getMonth(), 1);
  const canNext = last < max;
  let h = `<div class="wish-cal__head">
      <button type="button" class="wish-cal__nav" data-wish-nav="-1" ${canPrev ? '' : 'disabled'} aria-label="前の月">‹</button>
      <span>${first.getFullYear()}年${first.getMonth() + 1}月</span>
      <button type="button" class="wish-cal__nav" data-wish-nav="1" ${canNext ? '' : 'disabled'} aria-label="次の月">›</button>
    </div><div class="wish-cal__grid">`;
  ['日', '月', '火', '水', '木', '金', '土'].forEach((w, i) => {
    h += `<div class="wish-cal__w${i === 0 ? ' -sun' : i === 6 ? ' -sat' : ''}">${w}</div>`;
  });
  for (let i = 0; i < first.getDay(); i++) h += '<button type="button" class="wish-cal__d -empty" disabled></button>';
  for (let d = 1; d <= last.getDate(); d++){
    const day = new Date(first.getFullYear(), first.getMonth(), d);
    const ok = day >= min && day <= max;
    const cls = ['wish-cal__d'];
    if (day.getDay() === 0) cls.push('-sun');
    if (day.getDay() === 6) cls.push('-sat');
    if (wishSame(day, sel)) cls.push('-sel');
    h += `<button type="button" class="${cls.join(' ')}" data-wish-day="${shipYmd(day)}" ${ok ? '' : 'disabled'}>${d}</button>`;
  }
  h += `</div><div class="wish-cal__legend"><span><i class="l-ok"></i>選べる日</span><span><i class="l-ng"></i>選べない日</span></div>`;
  box.innerHTML = h;
}
document.addEventListener('click', (e) => {
  const t = e.target;
  if (!t || !t.closest) return;
  const nav = t.closest('[data-wish-nav]');
  if (nav && wishView){
    wishView = new Date(wishView.getFullYear(), wishView.getMonth() + Number(nav.dataset.wishNav), 1);
    renderWishCal();
    return;
  }
  const day = t.closest('[data-wish-day]');
  if (day && !day.disabled){
    const input = document.getElementById('wish_date_input');
    if (!input) return;
    input.value = day.dataset.wishDay;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }
});

function setWishRange(toDate, fromDate){
  const input = document.getElementById('wish_date_input');
  const msg = document.getElementById('wish-msg');
  if (!input) return;
  if (!toDate){
    input.disabled = true;
    input.value = '';
    input.removeAttribute('min');
    wishShip = { from: null, to: null };
    if (msg){ setWishMsg(msg, ''); msg.classList.remove('-error'); }
    renderWishCal();
    return;
  }
  let min = wishAddDays(toDate, WISH_MIN_DAYS);
  /* 2026-11-02：担当者がお届け日を決めたときは、その日も選べるようにする（出荷予定日より前でも） */
  const staffWish = staffDate('wish');
  if (staffWish && staffWish < min) min = staffWish;
  const minChanged = input.min !== shipYmd(min);
  input.min = shipYmd(min);
  input.disabled = false;
  wishShip = { from: fromDate || toDate, to: toDate };
  if (minChanged || !wishView) wishView = new Date(min.getFullYear(), min.getMonth(), 1);
  if (input.value && input.value < input.min){
    input.value = '';
    if (msg){ setWishMsg(msg, `出荷予定日が変わったので選び直してください。${wishRangeText(min)}`); msg.classList.add('-error'); }
    renderWishCal();
    return;
  }
  renderWishCal();
  // 「選べません」の表示は、選び直すまで残す
  if (msg && !input.value && !msg.classList.contains('-error')) setWishMsg(msg, wishRangeText(min));
}
function checkWishDate(){
  const input = document.getElementById('wish_date_input');
  const msg = document.getElementById('wish-msg');
  if (!input || !msg) return;
  const min = shipParse(input.min);
  if (input.value && input.min && input.value < input.min){
    input.value = '';
    setWishMsg(msg, `${formatJaDate(min)}より前は選べません。${wishRangeText(min)}`);
    msg.classList.add('-error');
    renderWishCal();
    return;
  }
  msg.classList.remove('-error');
  setWishMsg(msg, input.value ? `${formatJaDate(shipParse(input.value))}をご希望` : (min ? wishRangeText(min) : ''));
  renderWishCal();
}
/* 「指定なし／日付を指定する」の切り替え */
function setDeliveryMode(mode){
  const hid = document.getElementById('delivery_mode_input');
  const panel = document.getElementById('delivery-wish');
  if (hid) hid.value = mode || '';
  document.querySelectorAll('#delivery-options .order-type__btn').forEach((b) => {
    b.classList.toggle('is-active', b.dataset.value === mode);
  });
  if (panel) panel.hidden = (mode !== 'date');
  if (mode !== 'date'){
    const input = document.getElementById('wish_date_input');
    if (input) input.value = '';
  }
  checkWishDate();
}
document.addEventListener('click', (e) => {
  const btn = e.target && e.target.closest && e.target.closest('#delivery-options .order-type__btn');
  if (btn){ setDeliveryMode(btn.dataset.value); try { updateSummary(); } catch (err) {} }
});
document.addEventListener('change', (e) => {
  if (e.target && e.target.id === 'wish_date_input'){ checkWishDate(); try { updateSummary(); } catch (err) {} }
});

var shipSeq = 0;
/* 実際に DOM を更新する関数（出荷予定日を表示） */
async function updateDeliveryDates(totalQty, pm){
  const dateEl = document.getElementById('delivery-date');
  if (!dateEl) return;
  const busyEl = document.getElementById('delivery-busy');
  const seq = ++shipSeq;

  if (!totalQty || totalQty <= 0){
    dateEl.textContent = '－';
    if (busyEl) busyEl.hidden = true;
    setWishRange(null);
    return;
  }

  /* 2026-11-02：担当者が出荷予定日を決めたときは、自動計算の代わりにその日を出す */
  const staffShip = staffDate('ship');
  if (staffShip){
    dateEl.textContent = formatJaDate(staffShip);
    if (busyEl) busyEl.hidden = true;
    const cfNote0 = document.getElementById('delivery-confirm-note');
    if (cfNote0) cfNote0.hidden = true;   /* 担当者が決めた日なので、確認の日数の注意は出さない */
    setWishRange(staffShip, staffShip);
    return;
  }
  const work = shipWorkByMethod(Number(totalQty));
  dateEl.textContent = '計算中…';
  const results = await Promise.all(Object.keys(work).map((m) => shipQuote(m, work[m])));
  if (seq !== shipSeq) return; // 途中で内容が変わったら古い結果は捨てる

  // いちばん遅い方法に合わせる
  let pick = results[0];
  results.forEach((r) => { if (r.to && pick.to && r.to > pick.to) pick = r; });
  const busy = results.some((r) => r.busy);

  dateEl.textContent = (pick.from && pick.to) ? `${formatJaDate(pick.from)}〜${formatJaDate(pick.to)}ごろ` : '－';
  const cfNote = document.getElementById('delivery-confirm-note');
  if (cfNote) cfNote.hidden = !confirmDays();
  if (busyEl) busyEl.hidden = !busy;
  setWishRange(pick.to || null, pick.from || null);
}

/* ==== ▲ 出荷予定日ここまで ▲ ===================== */
/* ==== ▼ 印刷方法・印刷箇所 表示用ヘルパー ▼ ===================== */

function buildPrintPlacementText(placements){
  if (!Array.isArray(placements) || !placements.length) return '';

  const METHOD_LABEL = {
    dtf: 'DTFプリント',
    inkjet: 'インクジェット',
    silk: 'シルクスクリーン',
    omakase: 'おまかせ'
  };

  return placements
    .filter(p => p && p.method)
    .map((p, i) => {
      const method = METHOD_LABEL[baseMethod(p.method)] || p.method;
      const place  = p.label || p.areaLabel || p.posLabel || `箇所${i+1}`;
      const split  = (isSilk(p.method) && plateCountOf(p) > 1) ? `（版の分け方：${plateSplitText(p)}）` : '';
      return `${i+1}箇所目：${place}／${method}${split}`;
    })
    .join(' ｜ ');
}

/* ==== ▲ 印刷方法・印刷箇所 ヘルパーここまで ▲ ===================== */





/* --- バリアント価格を逐次キャッシュしながら取得 --- */
const priceCache = {}; // {variantId: price(整数/円)}
async function getVariantPrice(id){
  // ✅ 追加：null/undefined/0/NaN を弾く（/variants/null.js 防止）
  const vid = Number(id);
  if (!Number.isFinite(vid) || vid <= 0){
    return 0;
  }

  if (priceCache[vid] !== undefined) return priceCache[vid];

  /* 同一商品（=この T シャツ）のバリアントなら variants 配列に入っている */
  const sameProd = variants.find(v => v.id == vid);
  if (sameProd){
    priceCache[vid] = Number(sameProd.price) || 0;
    return priceCache[vid];
  }

  /* 別商品（印刷・追加料金・袋詰め等）は /variants/{id}.js で取れる */
  try{
    const res = await fetch(`/variants/${vid}.js`);
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = await res.json(); // {id:..., price:...}
    priceCache[vid] = Number(json.price) || 0;
    return priceCache[vid];
  }catch(e){
    priceCache[vid] = 0; // 取得失敗は 0 円扱い
    return 0;
  }
}

/* ===== 未選択ステップの判定 =====
   ・step-notes（備考欄）は任意入力なので対象外
   ・非表示ステップ（メタフィールド由来）と、無地購入時の印刷関連ステップは除外
   ・完了していないものだけを返す
*/
/* ★追加：STEP5（連絡方法）の完了判定
   LINEを選んだ場合はアカウント名の入力まで済んで初めて完了とみなす
   ※ #contact_method_input は未選択でも 'email' が入るので必ず :checked を見る */
/* ★追加：印刷位置「自分で決める」を選んだら指定内容の入力まで必須 */
function isPosDetailDone(){
  const choice = document.getElementById('pos_choice_input')?.value || 'auto';
  if (choice !== 'specify') return true;
  return !!(document.getElementById('pos_detail_input')?.value || '').trim();
}

function isContactStepDone(){
  if (SKIP_PROOF_IMAGE) return true;
  const checked = document.querySelector('#contactMethod input[name="contact_method"]:checked');
  if (!checked) return false;
  if (checked.value === 'line'){
    return !!(document.getElementById('line_account_input')?.value || '').trim();
  }
  return true;
}

function getPendingSteps(){
  const isSample = document.getElementById('order_type_input')?.value === 'sample';


  const PRINT_ONLY = ['step-print-sides','step-placement','step-upload','step-contact','step-design-request','step-case'];

  const defs = [
    { id:'step-order-type',     label:'ご注文タイプ',           done: () => !!document.getElementById('order_type_input')?.value },
    { id:'step-color-size',     label:'カラー / サイズ / 枚数', done: () => Object.values(cartSelections).reduce((t,i)=>t+i.qty,0) > 0 },
    { id:'step-print-sides',    label:'印刷面',                 done: () => !!document.getElementById('print_sides_input')?.value },
    { id:'step-placement',      label:'加工位置とプリント方法', done: () => Array.isArray(placements) && placements.length > 0 && placements.every(p => !!p.method) },
    { id:'step-placement',      label:'印刷位置の指定内容',     done: () => isPosDetailDone() },
    { id:'step-placement',      label:'調色する色番号',         done: () => isChosyokuDone() },
    /* ★contact_method_input は初期化時に必ず 'email' が入るのでラジオ実体を見る */
{ id:'step-contact',        label:'完成イメージの連絡方法（LINEの場合はアカウント名も必須）', done: () => isContactStepDone() },
    { id:'step-bagging',        label:'袋詰めオプション',       done: () => !!document.getElementById('bagging_input')?.value },
    { id:'step-design-request', label:'データ作成の依頼有無',   done: () => !!document.getElementById('design_request_input')?.value },
    { id:'step-case',           label:'事例紹介への掲載可否',   done: () => !!document.getElementById('case_consent_input')?.value },
    { id:'step-delivery',       label:'お届け希望日（日付を希望する場合は日付も）', done: () => {
        const m = document.getElementById('delivery_mode_input')?.value || '';
        return m === 'none' || (m === 'date' && !!document.getElementById('wish_date_input')?.value);
      } },
  ];

  return defs.filter(d => {
    if (isHiddenStep(d.id)) return false;
    if (isSample && PRINT_ONLY.includes(d.id)) return false;
    let ok = false;
    try { ok = !!d.done(); } catch(e){ ok = false; }
    return !ok;
  });
}

/* ===== 未選択ステップをサマリーの直前に表示 ===== */
function renderPendingSteps(){
  const el = document.getElementById('pending-steps');
  if (!el) return;

  /* ★最後のSTEP（備考欄）まで到達していなければ何も出さない
     ＝まだ入力途中の人に「未選択です」と警告しない */
  const lastStep = document.getElementById('step-notes');
  const reachedEnd = lastStep
    ? !lastStep.classList.contains('is-hidden')
    : true;   /* step-notes が無い構成なら従来どおり出す */

  if (!reachedEnd){
    el.innerHTML = '';
    el.style.display = 'none';
    return;
  }

  const pending = getPendingSteps();
  if (!pending.length){
    el.innerHTML = '';
    el.style.display = 'none';
    return;
  }

  el.innerHTML =
    '<p class="pending-steps__title">未選択の項目があります</p>' +
    '<ul class="pending-steps__list">' +
    pending.map(p => `<li><a href="#${p.id}" data-pending-jump="${p.id}">${p.label}</a></li>`).join('') +
    '</ul>';
  el.style.display = 'block';
}

/* 未選択項目をクリックしたら該当STEPへスクロール */
document.getElementById('pending-steps')?.addEventListener('click', (e) => {
  const a = e.target.closest('[data-pending-jump]');
  if (!a) return;
  e.preventDefault();
  document.getElementById(a.dataset.pendingJump)?.scrollIntoView({ behavior:'smooth', block:'center' });
});
/* ===== 各ステップに選択結果を表示 ===== */
function renderStepResults(){
  const elColor = document.getElementById('step-result-color');
  if (elColor){
    /* ★変更：選択内容を表（カラー／サイズ／枚数）で出し、その場で枚数変更・削除できるようにする */
    const sizeOrder = Array.isArray(SIZE_LIST) ? SIZE_LIST.map(String) : [];
    const rows = Object.entries(cartSelections)
      .map(([key, s]) => ({ key, color: colorOfVariant(s.variantId), size: String(s.size), qty: s.qty }))
      .filter(r => r.qty > 0)
      .sort((a, b) => (a.color === b.color)
        ? sizeOrder.indexOf(a.size) - sizeOrder.indexOf(b.size)
        : 0);
    const total = rows.reduce((t, r) => t + r.qty, 0);

    if (rows.length){
      /* 入力中（枚数欄にフォーカスがある間）は表を描き直さず、合計だけ更新する */
      const typing = elColor.contains(document.activeElement) && document.activeElement.matches('[data-sel-input]');
      if (typing){
        const tot = elColor.querySelector('.qty-table__total');
        if (tot) tot.textContent = `合計 ${total} 枚`;
      } else {
        elColor.innerHTML =
          '<table class="qty-table">' +
            '<thead><tr><th>カラー</th><th>サイズ</th><th>枚数</th><th></th></tr></thead>' +
            '<tbody>' +
            rows.map(r => `
              <tr data-sel-key="${uplEsc(r.key)}">
                <td class="qty-table__color">${uplEsc(r.color)}</td>
                <td class="qty-table__size">${uplEsc(r.size)}</td>
                <td class="qty-table__qty">
                  <input type="number" class="qty-table__input" min="0" step="1" inputmode="numeric" value="${r.qty}" data-sel-input aria-label="${uplEsc(r.color)} ${uplEsc(r.size)} の枚数">
                </td>
                <td class="qty-table__del"><button type="button" class="qty-table__remove" data-sel-remove>削除</button></td>
              </tr>`).join('') +
            '</tbody>' +
          '</table>' +
          `<div class="qty-table__total">合計 ${total} 枚</div>`;
      }
      elColor.style.display = 'block';
    } else {
      elColor.innerHTML = '';
      elColor.style.display = 'none';
    }
  }

  const elPlc = document.getElementById('step-result-placement');
  if (elPlc){
    if (Array.isArray(placements) && placements.length){
      /* ★変更：選んだ印刷箇所を位置の画像つきで表示 */
      elPlc.innerHTML = placements.map((p,i)=>{
        const m = (typeof window.methodLabel === 'function' ? window.methodLabel(p.method) : p.method) || '<b style="color:#d32f2f;">方法が未選択</b>';
        return `
          <div class="plc-result">
            ${p.img ? `<div class="plc-result__thumb"><img src="${uplEsc(p.img)}" alt=""></div>` : ''}
            <div class="plc-result__text">
              <span class="plc-result__badge">${i+1}箇所目</span>
              <span class="plc-result__place">${p.side==='front'?'前面':'背面'}／${uplEsc(p.label)}</span>
              <span class="plc-result__method">${m}</span>
            </div>
          </div>`;
      }).join('');
      elPlc.style.display = 'block';
    } else {
      elPlc.style.display = 'none';
    }
  }
}

/* ===== ★追加：STEP2 の表で枚数変更・削除 ===== */
(function(){
  const el = document.getElementById('step-result-color');
  if (!el) return;

  /* 枚数を反映（0以下は削除）。モーダル側（パレットのバッジ／単一サイズの入力欄）も合わせる */
  function applyQty(key, qty){
    const sel = cartSelections[key];
    if (!sel) return;
    const color = colorOfVariant(sel.variantId);
    if (qty > 0){
      sel.qty = qty;
    } else {
      delete cartSelections[key];
    }
    refreshSwatch(color);
    const single = document.querySelector(`.color-swatch--single[data-variant="${sel.variantId}"] .color-qty-input`);
    if (single) single.value = qty > 0 ? qty : 0;
    if (typeof updateSummary === 'function') updateSummary();
  }

  el.addEventListener('click', e => {
    const tr = e.target.closest('tr[data-sel-key]');
    if (!tr) return;
    const key = tr.dataset.selKey;
    if (e.target.closest('[data-sel-remove]')){
      applyQty(key, 0);
    }
  });

  /* 入力中：1以上ならその場で反映（表は描き直さない） */
  el.addEventListener('input', e => {
    const inp = e.target.closest('[data-sel-input]');
    if (!inp) return;
    const key = inp.closest('tr[data-sel-key]')?.dataset.selKey;
    const qty = parseInt(inp.value, 10);
    if (!key || !(qty > 0)) return;
    applyQty(key, qty);
  });

  /* 入力を終えた：空や0なら削除、それ以外は表を描き直す */
  el.addEventListener('change', e => {
    const inp = e.target.closest('[data-sel-input]');
    if (!inp) return;
    const key = inp.closest('tr[data-sel-key]')?.dataset.selKey;
    if (!key) return;
    const qty = parseInt(inp.value, 10) || 0;
    inp.blur();
    applyQty(key, qty);
  });
})();

/* ---------- 注文内容サマリー描画 ---------- */
/* ===== 2026-10-22：シルクの版分け（自動お見積りページと同じ考え方） =====
   placement.plateSplit：'one'＝全サイズ共通（1版・初期値）／'auto'＝3サイズごと（おすすめ）
                         'custom'＝自動お見積りで自分で分けた（placement.plateGroupsFixed にサイズの組 [[...],[...]]）
   大人サイズは小さい順に3サイズごと、キッズサイズ（100〜160 などの数字）はまとめて1版 */
const PLATE_ADULT_ORDER = ['XS','SS','S','M','L','XL','LL','XXL','2L','3L','XXXL','3XL','4L','4XL','XXXXL','5L','5XL','6L','6XL','7L','7XL'];
function plateNormSize(s){ return String(s || '').normalize('NFKC').replace(/[\s\u3000]/g, '').toUpperCase(); }
function plateIsKids(s){ return /^\d{2,3}(CM)?$/.test(plateNormSize(s)); }
function plateSizeRank(s){
  const u = plateNormSize(s);
  if (plateIsKids(u)) return parseInt(u, 10);
  const i = PLATE_ADULT_ORDER.indexOf(u);
  return 1000 + (i >= 0 ? i : 99);
}
/* カートのサイズごとの枚数（全カラーの合計・小さい順） */
function plateSizeQtyList(){
  const m = {};
  Object.values(cartSelections || {}).forEach(sel => {
    const q = Number(sel && sel.qty) || 0;
    if (q > 0) m[sel.size] = (m[sel.size] || 0) + q;
  });
  return Object.keys(m).map(s => ({ s, q: m[s] })).sort((a, b) => plateSizeRank(a.s) - plateSizeRank(b.s));
}
/* 版ごとのサイズと枚数 [{ sizes:[...], qty }] */
function plateGroupsOf(p){
  const list = plateSizeQtyList();
  if (!list.length) return [];
  const mode = (p && p.plateSplit) || 'one';
  let groups = [];
  if (mode === 'auto'){
    const kids = list.filter(x => plateIsKids(x.s));
    const adults = list.filter(x => !plateIsKids(x.s));
    if (kids.length) groups.push(kids);
    for (let i = 0; i < adults.length; i += 3) groups.push(adults.slice(i, i + 3));
  } else if (mode === 'custom' && Array.isArray(p.plateGroupsFixed) && p.plateGroupsFixed.length){
    const at = {};
    p.plateGroupsFixed.forEach((g, gi) => (Array.isArray(g) ? g : []).forEach(sz => { at[plateNormSize(sz)] = gi; }));
    const tmp = p.plateGroupsFixed.map(() => []);
    list.forEach(x => {
      const gi = at[plateNormSize(x.s)];
      (gi >= 0 ? tmp[gi] : tmp[tmp.length - 1]).push(x);   /* 見積りに無いサイズは最後の版へ */
    });
    groups = tmp.filter(g => g.length);
  } else {
    groups = [list];
  }
  return groups.map(g => ({ sizes: g.map(x => x.s), qty: g.reduce((n, x) => n + x.q, 0) }));
}
function plateCountOf(p){ return Math.max(1, plateGroupsOf(p).length); }
function plateSplitText(p){
  const g = plateGroupsOf(p);
  if (g.length <= 1) return '全サイズ共通（1版）';
  return g.map(x => x.sizes.join('・') + '（' + x.qty + '枚）').join('／');
}
/* 10枚に足りない版 */
function plateShortGroups(p){
  const g = plateGroupsOf(p);
  /* 2026-10-26：合計10枚未満（サンプル・少量）は版を自由に分けてよい */
  const t = g.reduce((n, x) => n + x.qty, 0);
  if (t > 0 && t < 10) return [];
  return g.filter(x => x.qty < 10);
}
/* 2026-10-26：シルクのサンプル・少量（合計10枚未満） */
function isSilkSmallQty(qty){ return qty > 0 && qty < 10; }
/* 2026-10-26：別の商品と同じ版を使う箇所は、ほかの商品と合わせた合計枚数（tierQty）の単価にする */
/* 2026-10-27：お客様用URLのほかの商品・デザインで、同じ箇所の順番・同じ色数のシルクの枚数（カートで1行にまとまる分） */
function silkMergeQty(p){ try{ return window.__odpSilkMergeQty ? (Number(window.__odpSilkMergeQty(p)) || 0) : 0; }catch(e){ return 0; } }
function silkTierQty(p, qty){
  const t = (p && p.sharedPlate) ? (parseInt(p.tierQty, 10) || 0) : 0;
  const m = silkMergeQty(p);
  return Math.max(qty, t, m > 0 ? qty + m : 0);
}
/* 2026-10-26：「ほかと同じ版」の説明（別の商品と合わせた枚数があるときだけ枚数を出す） */
function sharedPlateText(p, qty){ const t = silkTierQty(p, qty); return 'ほかと同じ版（版代なし' + (t > qty ? `・印刷代は合計${t}枚の単価` : '') + '）'; }
function silkEffQty(p, qty){ const q = silkTierQty(p, qty); return q > 0 && q < 10 ? 10 : q; }
function odpIsStaff(){ try { return localStorage.getItem('odp_staff') === '1'; } catch (e) { return false; } }
/* 2026-10-22：インクの色替え（本体の色でインクを変える・1色のデザインのみ） */
function inkNameOf(k){ return (INKS.find(i => i.key === k) || {}).name || ''; }
/* カートの本体の色ごとの枚数（選んだ順） */
function bodyColorQtyList(){
  const m = {}, order = [];
  Object.values(cartSelections || {}).forEach(sel => {
    const q = Number(sel && sel.qty) || 0;
    if (q <= 0) return;
    const c = colorOfVariant(sel.variantId) || '－';
    if (!(c in m)) { m[c] = 0; order.push(c); }
    m[c] += q;
  });
  return order.map(c => ({ c, q: m[c] }));
}
/* 2026-10-22：「商品の色でインクを分ける」は、いったん出さない（true にすると戻る） */
var INK_CHANGE_ON = false;
function canInkChange(p){ return !!(INK_CHANGE_ON && p && isSilk(p.method) && silkInkCount(p.method) === 1); }
/* 本体の色のインク（未設定なら基本のインク＝選んだインク。'?' は「選んでください」） */
function inkOfBody(p, color){
  const k = p.inkByBody ? p.inkByBody[color] : undefined;
  if (typeof k === 'string' && k.charAt(0) === '?') return '';   /* '?〇' は「まだ選んでいない（〇番目のインク）」 */
  return k || (p.inks && p.inks[0]) || '';
}
/* インクごとのまとまり（枚数の多い順） [{ink, colors, qty}] */
function inkChangeGroups(p){
  if (!p || !p.inkChange || !canInkChange(p)) return [];
  const g = {};
  bodyColorQtyList().forEach(x => {
    const raw = p.inkByBody ? p.inkByBody[x.c] : undefined;
    /* インクが未選択でも、見積りで分けたまとまり（'?1' など）は別のインクとして数える */
    const k = inkOfBody(p, x.c) || ((typeof raw === 'string' && raw.charAt(0) === '?') ? raw : '__base');
    if (!g[k]) g[k] = { ink: k, colors: [], qty: 0 };
    g[k].colors.push(x.c);
    g[k].qty += x.q;
  });
  return Object.values(g).sort((a, b) => b.qty - a.qty);
}
/* 版の清掃代がかかるインク（基本以外で20枚以下） */
function inkChangeCleaningGroups(p){ return inkChangeGroups(p).slice(1).filter(x => x.qty <= 20); }
function inkChangeText(p){
  return inkChangeGroups(p).map(x => `${x.colors.join('・')}：${inkNameOf(x.ink) || '未選択'}（${x.qty}枚）`).join('／');
}
/* 本体の色ごとのインクを選ぶ欄 */
function inkChangeListHtml(p, idx){
  const list = bodyColorQtyList();
  if (!list.length) return 'カラーと枚数を選ぶと、商品の色ごとにインクを選べます。';
  return list.map(x => {
    const cur = inkOfBody(p, x.c);
    return `<div style="display:flex;align-items:center;gap:8px;padding:4px 0;border-bottom:1px dashed #e0eded;">
      <span style="flex:1;min-width:0;font-size:14px;font-weight:800;color:#333;">${x.c}（${x.q}枚）</span>
      <select data-inkbody-idx="${idx}" data-inkbody-color="${x.c.replace(/"/g, '&quot;')}"
        style="flex:0 0 170px;height:38px;padding:0 6px;font-size:14px;border:2px solid ${cur ? '#d5d5d5' : '#d93025'};border-radius:8px;background:#fff;">
        <option value="">インクを選ぶ</option>
        ${INKS.map(i => `<option value="${i.key}"${i.key === cur ? ' selected' : ''}>${i.name}</option>`).join('')}
      </select>
    </div>`;
  }).join('') + (() => {
    const ng = inkChangeCleaningGroups(p);
    return ng.length
      ? `<div style="margin-top:6px;font-size:13px;font-weight:800;color:#b9361d;">版の清掃代：${ng.length}回（${ng.map(x => `${inkNameOf(x.ink) || '未選択'} ${x.qty}枚`).join('、')}）× 1,100円</div>`
      : '';
  })();
}

/* 2026-10-22：シルクのオプション */
function isSilkRepeat(p){ return !!(p && isSilk(p.method) && p.repeat); }
/* この箇所の版の数（サイズ分け × 色数）。色が未選択なら【1色】〜【3色】の色数 */
function silkPlateNum(p, idx){
  const c = Number(getSilkColorCount(placements, idx)) || silkInkCount(p.method) || 0;
  return c * plateCountOf(p);
}
/* この箇所のシルクのオプション料金（円）の内訳 [{label, qty, unitYen, variant, props}] */
function silkOptionLines(p, idx, totalQty){
  const out = [];
  if (!p || !isSilk(p.method)) return out;
  const no = idx + 1;
  const plates = silkPlateNum(p, idx);
  if (p.repeat){
    if (totalQty <= 10 && plates > 0) out.push({ label: `${no}箇所目：リピートのセットアップ代（${plates}版）`, qty: plates, variant: SILK_SETUP_VARIANT,
      props: { 'セットアップ代': `${no}箇所目`, '版の数': `${plates}版`, '前回の注文番号': p.repeatOrderNo || '' } });
    if (p.repeatInkChange && totalQty <= 20 && plates > 0) out.push({ label: `${no}箇所目：版の清掃代（${plates}版）`, qty: plates, variant: SILK_CLEANING_VARIANT,
      props: { '版の清掃代': `${no}箇所目`, '版の数': `${plates}版` } });
  }
  /* インクの色替え：基本以外のインクが20枚以下なら、色ごとに版の清掃代 */
  const icg = inkChangeCleaningGroups(p);
  if (icg.length) out.push({ label: `${no}箇所目：版の清掃代（商品の色でインクを分ける・${icg.length}回）`, qty: icg.length, variant: SILK_CLEANING_VARIANT,
    props: { '版の清掃代': `${no}箇所目（商品の色でインクを分ける）`, 'インクの分け方': inkChangeText(p) } });
  if (SILK_SPECIAL_NAMES[p.specialInk] && totalQty > 0) out.push({ label: `${no}箇所目：特殊インク（${SILK_SPECIAL_NAMES[p.specialInk]}）${totalQty}枚`, qty: totalQty, variant: SILK_SPECIAL_VARIANT,
    props: { '特殊インク': `${no}箇所目：${SILK_SPECIAL_NAMES[p.specialInk]}` } });
  return out;
}

/* 2026-10-22：シルクのオプションの入力欄（印刷箇所のカード） */
function silkOptBtn(idx, key, val, cur, label){
  const on = cur === val;
  return `<button type="button" data-sopt-idx="${idx}" data-sopt-key="${key}" data-sopt-val="${val}"
    style="flex:1;min-width:90px;padding:8px 10px;border-radius:8px;cursor:pointer;font-family:inherit;font-size:14px;font-weight:900;line-height:1.35;
           border:2px solid ${on ? '#00b8b8' : '#d5d5d5'};background:${on ? '#00b8b8' : '#fff'};color:${on ? '#fff' : '#333'} !important;-webkit-text-fill-color:${on ? '#fff' : '#333'};">${label}</button>`;
}
/* 2026-10-22：シルクスクリーンの設定（版の分け方・特殊インク・版）をひとつの枠にまとめる
   各行：左に見出し、右にボタン。説明はボタンの下（右の列）に小さく */
function silkSettingsHtml(p, idx){
  const mode = p.plateSplit || 'one';
  const sp = p.specialInk || '';
  const rp = p.repeat ? '1' : (p.sharedPlate ? 'shared' : '');
  const esc = (t) => String(t || '').replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));
  const btn = (attrs, on, label, sub) => `
    <button type="button" ${attrs}
      style="flex:1;min-width:110px;padding:8px 10px;border-radius:8px;cursor:pointer;font-family:inherit;line-height:1.35;text-align:center;
             border:2px solid ${on ? '#00b8b8' : '#d5d5d5'};background:${on ? '#00b8b8' : '#fff'};">
      <span style="display:block;font-size:14px;font-weight:900;color:${on ? '#fff' : '#333'} !important;-webkit-text-fill-color:${on ? '#fff' : '#333'};">${label}</span>
      ${sub ? `<span style="display:block;font-size:12px;font-weight:700;color:${on ? '#fff' : '#666'} !important;-webkit-text-fill-color:${on ? '#fff' : '#666'};">${sub}</span>` : ''}
    </button>`;
  const help = (t) => `<div style="grid-column:2 / -1;margin-top:6px;font-size:12px;font-weight:700;color:#777;line-height:1.6;white-space:normal;">${t}</div>`;
  const row = (label, body, first) => `
  <div class="pm-row" style="${first ? '' : 'margin-top:10px;padding-top:10px;border-top:1px dashed #d8e8e8;'}">
    <div class="pm-label">${label}</div>
    ${body}
  </div>`;

  const splitNote = p.repeat
    ? '前回と同じ分け方の版を使います。'
    : mode === 'auto'
      ? '大人サイズは3サイズずつ、キッズサイズはまとめて1版。版代は版の数だけかかります（1版10枚以上）。'
      : mode === 'custom'
        ? '担当者がデザインに合わせて版を分けています。'
        : '小さいサイズに合わせて版を作るため、大きいサイズでは印刷が小さく見えます。';

  const splitRow = row('版の分け方', `
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      ${btn(`data-split-idx="${idx}" data-split-val="one"`, mode === 'one', '全サイズ共通', '1版')}
      ${btn(`data-split-idx="${idx}" data-split-val="auto"`, mode === 'auto', '3サイズごと', 'おすすめ')}
      ${(mode === 'custom' || (Array.isArray(p.plateGroupsFixed) && p.plateGroupsFixed.length)) ? btn(`data-split-idx="${idx}" data-split-val="custom"`, mode === 'custom', '担当者の分け方', '') : ''}
    </div>
    <div data-split-groups="${idx}" style="grid-column:2 / -1;margin-top:8px;padding:6px 10px;font-size:14px;font-weight:800;color:#333;line-height:1.7;background:#fff;border:1px solid #cfeeee;border-radius:8px;white-space:normal;">${plateGroupsHtml(p)}</div>
    ${help(splitNote)}`, true);

  const inkRow = row('特殊インク', `
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="specialInk" data-sopt-val=""`, sp === '', 'なし', '')}
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="specialInk" data-sopt-val="glow"`, sp === 'glow', '蓄光', '＋110円／枚')}
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="specialInk" data-sopt-val="crack"`, sp === 'crack', 'クラック', '＋110円／枚')}
    </div>
    ${help('発泡・スウェードは別途お見積りです。お問い合わせください。')}`);

  const ic = p.inkChange ? '1' : '';
  const inkChangeRow = canInkChange(p) ? row('商品の色でインクを分ける', `
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="inkChange" data-sopt-val=""`, ic === '', '分けない', '全部同じインク')}
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="inkChange" data-sopt-val="1"`, ic === '1', '分ける', '版は1つのまま')}
    </div>
    ${p.inkChange ? `<div data-inkchange-list="${idx}" style="grid-column:2 / -1;margin-top:8px;padding:6px 10px;background:#fff;border:1px solid #cfeeee;border-radius:8px;">${inkChangeListHtml(p, idx)}</div>` : ''}
    ${help(p.inkChange
      ? '商品の色ごとに、使うインクを選んでください。いちばん多いインク以外で20枚以下のインクには、1色ごとに版の清掃代1,100円がかかります。'
      : '1色のデザインを、商品の色によって別のインクで印刷できます（例：白・紺はオフホワイト、黒だけゴールド）。')}`)
    : '';   /* 2026-10-22：「商品の色でインクを分ける」はいったん出さない（INK_CHANGE_ON = false のときは行ごと出さない） */

  const repeatRow = row('版', `
    <div style="display:flex;gap:8px;flex-wrap:wrap;">
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="repeat" data-sopt-val=""`, rp === '', '新しく作る', '')}
      ${btn(`data-sopt-idx="${idx}" data-sopt-key="repeat" data-sopt-val="1"`, rp === '1', 'リピート', '前回の版を使う')}
      ${(odpIsStaff() || p.sharedPlate) ? btn(`data-sopt-idx="${idx}" data-sopt-key="repeat" data-sopt-val="shared"`, rp === 'shared', 'ほかと同じ版', odpIsStaff() ? '担当者用・版代なし' : '版代なし') : ''}
    </div>
    ${p.sharedPlate ? `
    ${odpIsStaff() ? `
    <div style="grid-column:2 / -1;margin-top:8px;">
      <label style="display:block;font-size:13px;font-weight:800;color:#333;margin-bottom:4px;">別の商品と同じ版のときだけ：印刷代の枚数（同じ版で刷る商品の合計。お客様用URLの保存のときに自動で数え直します）</label>
      <input type="number" min="0" inputmode="numeric" data-tier-qty="${idx}" value="${esc(p.tierQty || '')}" placeholder="同じ商品なら空欄"
        style="width:100%;max-width:160px;height:40px;padding:0 10px;font-size:16px;border:2px solid #d5d5d5;border-radius:8px;box-sizing:border-box;">
    </div>` : ((parseInt(p.tierQty, 10) || 0) > 0 ? `
    <div style="grid-column:2 / -1;margin-top:8px;font-size:14px;font-weight:800;color:#333;">印刷代は合計${esc(p.tierQty)}枚の単価です（同じ版で刷るほかの商品と合わせた枚数）</div>` : '')}
    ${help('この箇所は、ほかの印刷箇所（または一緒に注文する別の商品）と同じ版で印刷するので版代はかかりません。印刷代はふつうどおりかかります。' + (odpIsStaff() ? '<br>同じデザイン・同じ大きさ・同じ色のときだけ選んでください。別の商品と合わせるときは、印刷箇所の順番（1箇所目・2箇所目…）と色数をほかの商品と同じにしてください。' : ''))}` : p.repeat ? `
    <div style="grid-column:2 / -1;margin-top:8px;">
      <label style="display:block;font-size:13px;font-weight:800;color:#333;margin-bottom:4px;">前回の注文番号（必須）</label>
      <input type="text" data-repeat-no="${idx}" value="${esc(p.repeatOrderNo)}" placeholder="例：#1234"
        style="width:100%;max-width:240px;height:40px;padding:0 10px;font-size:16px;border:2px solid #d5d5d5;border-radius:8px;box-sizing:border-box;">
      <label style="display:flex;align-items:center;gap:8px;margin-top:8px;font-size:14px;font-weight:800;color:#333;cursor:pointer;">
        <input type="checkbox" data-repeat-ink="${idx}" ${p.repeatInkChange ? 'checked' : ''} style="width:20px;height:20px;accent-color:#00b8b8;">前回とインクの色を変える
      </label>
    </div>
    ${help('版代はかかりません。10枚以下はセットアップ代（1版1,100円）、色を変えて20枚以下は版の清掃代（1版1,100円）がかかります。版が残っているかは担当者が確認します。')}` : help('前回やサンプルと同じデザインなら「リピート」を選ぶと版代がかかりません（前回の注文番号にサンプルの注文番号を入れてください）。' + (isSilkSmallQty(Object.values(cartSelections || {}).reduce((n, x) => n + (Number(x && x.qty) || 0), 0)) ? '<br>10枚未満はサンプル・少量の料金です（印刷代は10枚の単価・版代は版の数だけ）。' : ''))}`);

  return `
<div style="margin-top:12px;padding:12px;border:1px solid #cfeeee;border-radius:10px;background:#f8fdfd;">
  <div style="margin:0 0 8px;font-size:14px;font-weight:900;color:#00838f;">シルクスクリーンの設定</div>
  <div style="margin:0 0 10px;font-size:14px;font-weight:800;color:#b9361d;line-height:1.6;">※シルクスクリーンは3色までの単色デザイン向けです。写真・グラデーション・4色以上のデザインはできません（DTFプリントかインクジェットプリントをお選びください）。</div>
  ${splitRow}
  ${inkRow}
  ${inkChangeRow}
  ${repeatRow}
</div>`;
}

/* 印刷箇所のカードに出す「どう分かれるか」 */
function plateGroupsHtml(p){
  const g = plateGroupsOf(p);
  if (!g.length) return 'サイズと枚数を選ぶと、版の分かれ方がここに出ます。';
  return g.map((x, i) => {
    const ng = x.qty < 10 && !(p && (p.repeat || p.sharedPlate)) && !isSilkSmallQty(g.reduce((n, y) => n + y.qty, 0));   /* リピート・合計10枚未満は10枚未満の版でもよい */
    return `<div style="${ng ? 'color:#d93025;' : ''}">版${i + 1}：${x.sizes.join('・')}（${x.qty}枚）${ng ? '　※10枚以上必要' : ''}</div>`;
  }).join('');
}
/* サイズ・枚数が変わったときに、カードの表示だけ更新する */
function refreshPlateGroupsView(){
  document.querySelectorAll('[data-split-groups]').forEach(el => {
    const p = placements[Number(el.getAttribute('data-split-groups'))];
    if (p) el.innerHTML = plateGroupsHtml(p);
  });
  /* 本体の色ごとのインク（カラーや枚数が変わったとき）。選んでいる最中は描き直さない */
  document.querySelectorAll('[data-inkchange-list]').forEach(el => {
    if (el.contains(document.activeElement)) return;
    const i = Number(el.getAttribute('data-inkchange-list'));
    if (placements[i]) el.innerHTML = inkChangeListHtml(placements[i], i);
  });
}

async function updateSummary(){
  try { refreshPlateGroupsView(); } catch (e) {}   /* 2026-10-22：版の分かれ方の表示 */
  renderStepResults();
  renderPendingSteps();
  const totalQty = Object.values(cartSelections).reduce((t,i)=>t+i.qty,0);
  const isSample = document.getElementById('order_type_input')?.value === 'sample'; // ★無地購入判定

  // ★先に作る（ここで pm を確定）
  const printMethod = document.getElementById('print_method_input')?.value || '';
  const pm = baseMethod(printMethod);

  // ★その後に呼ぶ
  updateDeliveryDates(totalQty, pm);


  const submitLabel = uplReceivedByStaff() ? '受け取り済み（メール・LINE）' : 'アップロード';

  if (totalQty === 0){
    summaryBox.style.display = 'block';
    summaryBox.innerHTML = `
      <div class="order-summary__title">ご注文内容確認</div>
      <div class="order-summary__row">
        <span class="order-summary__label">現在の選択状況:</span>
        まだサイズ・枚数が選択されていません。
      </div>
    `;
    return;
  }


  /* ② カラー×サイズごとの一覧 --------------------------- */
  const colorSizeMap = {};      // {color:{size:qty}}
  Object.values(cartSelections).forEach(({variantId,size,qty})=>{
    const color = colorOfVariant(variantId);
    colorSizeMap[color] = colorSizeMap[color] || {};
    colorSizeMap[color][size] = (colorSizeMap[color][size] || 0) + qty;
  });
  const colorLines = Object.entries(colorSizeMap).map(([col,sizes])=>{
    const sizeStr = Object.entries(sizes)
                   .map(([s,q])=>`${s}×${q}`)
                   .join(', ');
    return `【${col}】${sizeStr}`;
  }).join('<br>');

/* ③ 印刷方法・位置・袋詰め ----------------------------- */
const PRINT_LABEL = {
  consult: '担当と相談して決定',
  factory: '工場のプロにお任せ',

  dtf: 'DTFプリント',
  inkjet: 'インクジェットプリント',

  silk_1: '【1色】シルクスクリーン印刷',
  silk_2: '【2色】シルクスクリーン印刷',
  silk_3: '【3色】シルクスクリーン印刷',
  silk:   'シルクスクリーン印刷',

  embroidery: '刺繍'
};

/* v(code) → 日本語ラベル */
const methodLabel = (v) => {
  if (!v) return '';

  // ① METHOD_OPTIONS にあれば最優先（正式名称）
  const hit = (METHOD_OPTIONS || []).find(o => o.v === v);
  if (hit && hit.t) return hit.t;

  // ② なければフォールバック
  return PRINT_LABEL[v] || v;
};


  const printText   = printMethod ? `印刷方法：${PRINT_LABEL[printMethod]||printMethod}` : '印刷方法：未選択';

  // ★★ ここから追加 ★★
  const shippingInputEl = document.getElementById('shipping_input');
  let shippingLabel = '通常出荷';
  if (shippingInputEl) {
    shippingLabel = shippingInputEl.value === 'express' ? 'お急ぎ便' : '通常出荷';
  }
  // ★★ 追加ここまで ★★





  // ← ここを追加して mainSide を再定義
const mainSide = document.getElementById('plc_main_input').value;

// ▼ここから差し替え▼
// インク名を key → 表示名に変換（black → ブラック等）
const inkNameByKey = (k) => (INKS.find(x => x.key === k)?.name || '');

// ✅ 3箇所分の表示（シルクならインクカラーも表示）
const pmLines = Array.from({ length: MAX_PLACES }, (_, i) => i).map(i=>{
  const p = (placements || [])[i];
  if (!p) return '';   /* ★未選択の箇所は行ごと出さない */

  const placeText = `${p.side === 'front' ? '前面' : '背面'}：${p.label || ''}`.trim();
  const mText = methodLabel(p.method) || '未選択';

  // ★ シルク系なら inks を表示（silk_1/2/3 を含む）
  let inkText = '';
  if (isSilk(p.method)) {
    const names = (p.inks || [])
      .filter(Boolean)
      .map(inkNameByKey)
      .filter(Boolean);

    // 色数ぶん選ばれていない場合の表示も出すならこっち
    inkText = `／インク：${names.length ? names.join(' / ') : '未選択'}`;
  }

  const saText = getSizeAreaText(p);
  const isBig  = !!(p.big && isLargeEligible(p));   /* ★追加：大判 */

  /* ★変更（2026-10-21）：1箇所1行の表で出す（1行目：面と場所／2行目：サイズ・印刷方法・大判／シルクはインク） */
  const label  = String(p.label || '');
  const mSize  = label.match(/^(.*?)\s*(W\s*\d+\s*[×xX]\s*H\s*\d+)\s*$/);
  const name   = mSize ? mSize[1] : label;
  const size   = saText || (mSize ? mSize[2] : '');
  const inkLine = inkText ? inkText.replace(/^／/, '') : '';
  /* 表では印刷方法を短く出す（改行を減らすため） */
  const bm = baseMethod(p.method);
  const mShort = !p.method ? '未選択'
    : bm === 'dtf'    ? 'DTF'
    : bm === 'inkjet' ? 'インクジェット'
    : bm === 'silk'   ? `シルク${silkInkCount(p.method) ? silkInkCount(p.method) + '色' : ''}`
    : p.method === 'consult' ? '担当と相談'
    : p.method === 'factory' ? '工場におまかせ'
    : mText;
  return `<tr>` +
           `<td class="os-n">${i+1}</td>` +
           `<td>` +
             `<div class="os-place">${p.side === 'front' ? '前面' : '背面'} ${uplEsc(name)}</div>` +
             `<div class="os-sub">${size ? `${uplEsc(size)} ／ ` : ''}<span class="os-method${mShort === '未選択' ? ' -none' : ''}">${mShort}</span>${isBig ? '<span class="os-big">大判</span>' : ''}</div>` +
             (inkLine ? `<div class="os-sub">${inkLine}</div>` : '') +
           `</td>` +
         `</tr>`;
}).join('');


// ▲ここまで差し替え▲


  const bagging = document.getElementById('bagging_input').value==='bag' ? 'あり' : 'なし';
const posChoice = document.getElementById('pos_choice_input')?.value || 'auto';
let posLabel = (posChoice === 'specify') ? '位置の指定をする' : '位置の調整はおまかせ';
/* ★追加：指定内容は「位置指定」の下に別行で出す（未入力は赤字で警告） */
let posDetailRow = '';
if (posChoice === 'specify') {
  const posDetail = (document.getElementById('pos_detail_input')?.value || '').trim();
  const posDetailHtml = posDetail
    ? posDetail.replace(/</g,'&lt;').replace(/\n/g,'<br>')
    : '<b style="color:#d32f2f;">未入力</b>';
  posDetailRow =
    '<div class="order-summary__row -stack">' +
    '<span class="order-summary__label">印刷位置の指定内容:</span>' +
    '<div class="order-summary__value">' + posDetailHtml + '</div>' +
    '</div>';
}
const caseConsent = document.getElementById('case_consent_input')?.value || 'ok';
const caseLabel = (caseConsent === 'ok') ? '掲載OK' : '掲載NG';
const printSides = document.getElementById('print_sides_input')?.value || '';
const printSidesLabel = printSides === 'both' ? '両面' : printSides === 'one' ? '片面' : '未選択';
const designRequestVal2 = document.getElementById('design_request_input').value;
const designRequestLabel =
  designRequestVal2 === 'no'   ? 'なし' :
  designRequestVal2 === '1100' ? 'あり（¥1,100）' :
  designRequestVal2 === '3300' ? 'あり（¥3,300）' :
  designRequestVal2 === '5500' ? 'あり（¥5,500）' :
  '未選択';

/* ④ 金額計算 ------------------------------------------ */
  let subtotal = 0;
  let bodySubtotal   = 0;   /* ★内訳用：ボディ代（サイズ追加料金を含む） */
  let optionSubtotal = 0;   /* ★内訳用：オプション代（袋詰め・データ作成依頼・お急ぎ便等） */

  /* 4-a 本体 T シャツ */
  for (const sel of Object.values(cartSelections)){
    const price = variants.find(v=>v.id==sel.variantId)?.price || 0;
    subtotal     += price * sel.qty;
    bodySubtotal += price * sel.qty;
  }

  /* 4-b サイズ追加料金 SKU */
  for (const sel of Object.values(cartSelections)){
    const sid = getSurchargeVariantId(sel.size);
    if (sid){
      const price = await getVariantPrice(sid);
      subtotal     += price * sel.qty;
      bodySubtotal += price * sel.qty;
    }
  }

/* 4-c 印刷料金（複数箇所を合算） --------------------------- */
let printingSubtotal = 0;
const silkMergeNotes = [];   /* 2026-10-27：ほかの商品・デザインと合わせた枚数の単価にした箇所 */
let needsQuote = false;
let printFeeLater = false;

const validPlacements = (Array.isArray(placements) ? placements : [])
  .filter(p => p && p.method && (p.areaKey || p.area))
  .slice(0, MAX_PLACES);

for (const p of validPlacements){
const areaKey = (p.areaKey || p.area || '').trim();
  const pmPlaceRaw = String(p.method || '');
  const pmPlace = baseMethod(pmPlaceRaw); // dtf/inkjet/silk/omakase

  if (!areaKey || !pmPlace) continue;

   // ✅ 相談系（consult/factory）は印刷代のみ後日確定
  if (pmPlace === 'consult' || pmPlace === 'factory') { printFeeLater = true; continue; }

  /* ★追加：カート投入用バリアントIDが無い組み合わせは「別途お見積り」に倒す
     （料金表には値があるがIDが未登録＝サマリーとカートが不一致になるのを防ぐ） */
  const placeNoForCheck = validPlacements.indexOf(p) + 1;
  if (pmPlace === 'silk') {
    if (!SILK_PLATE_VARIANTS?.[areaKey]) { needsQuote = true; continue; }
  } else if (placeNoForCheck === 1) {
    if (!PRINT_VARIANTS?.[pmPlace]?.[p.side || 'front']?.[areaKey]) { needsQuote = true; continue; }
  } else {
    if (!EXTRA_PRINT_VARIANTS?.[pmPlace]?.[areaKey]?.[placeNoForCheck]) { needsQuote = true; continue; }
  }

  // シルクの加工代（単価×枚数×色数）も料金表で出すならここ
// シルクの加工代（表どおり：1色/2色/3色の「合計単価」×枚数）
if (pmPlace === 'silk') {
  const idx = validPlacements.indexOf(p);
  /* 2026-10-22：インクの色を選ぶ前でも、選んだ色数（【1色】〜【3色】）で金額を出す */
  const colors = Number(getSilkColorCount(placements, idx)) || silkInkCount(p.method) || 0;

  // シルク単価（円/枚）：色数ごとの合計単価（10-19: 1色500 / 2色950 / 3色1400 …）
  const getSilkUnit = (qty, colors) => {
    colors = Number(colors) || 0;
    if (colors <= 0) return null;

    const band =
      qty >= 100 ? '100' :
      qty >= 50  ? '50'  :
      qty >= 40  ? '40'  :
      qty >= 30  ? '30'  :
      qty >= 20  ? '20'  :
      qty >= 10  ? '10'  : null;

    if (!band) return null;

    /* 2026-10-21：表は SILK_UNIT_TABLE（料金データで上書きされる）を使う */
    return SILK_UNIT_TABLE[band]?.[colors] ?? null;
  };

  /* 2026-10-22：リピートは10枚未満でも、10〜19枚の単価で印刷代を出す
     2026-10-26：リピートでなくても、10枚未満（サンプル・少量）は10〜19枚の単価 */
  const unit = getSilkUnit(silkEffQty(p, totalQty), colors);
  { const mq = silkMergeQty(p); if (mq > 0 && totalQty > 0) silkMergeNotes.push(`${(Array.isArray(placements) ? placements.indexOf(p) : -1) + 1}箇所目：合計${totalQty + mq}枚の単価`); }   /* 2026-10-27 */
  if (unit == null) {
    needsQuote = true;
  } else {
    // unit は「1枚あたりの合計単価」なので、×枚数でOK
    printingSubtotal += unit * totalQty;
    /* ★追加：大判加算（印刷代の2割増ぶん） */
    if (p.big && isLargeEligible(p)) {
      printingSubtotal += (SILK_LARGE_ADD_YEN?.[colors]?.[silkLargeBand(silkEffQty(p, totalQty))] || 0) * totalQty;
    }
  }
  continue;
}


  // インクジェットだけ「色ごと枚数」で計算したいならここ
  /* ★追加：大判追加料金（DTF・インクジェット） */
  if (p.big && isLargeEligible(p) && (pmPlace === 'dtf' || pmPlace === 'inkjet')) {
    printingSubtotal += LARGE_FEE_YEN[largeFeeKey(totalQty)] * totalQty;
  }

  if (pmPlace === 'inkjet'){
    // 今の仕様：全体枚数 totalQty でいいなら unit*totalQty でOK
    // 色別に単価が変わらない前提なら totalQty で十分
    const unit = getPrintUnitPrice('inkjet', areaKey, totalQty);
    if (unit === null) needsQuote = true;
    else printingSubtotal += unit * totalQty;
    continue;
  }

  // dtf / omakase
  const unit = getPrintUnitPrice(pmPlace, areaKey, totalQty);
  if (unit === null) needsQuote = true;
  else printingSubtotal += unit * totalQty;
}

subtotal += printingSubtotal * 100;
















/* 4-c-2   白インク追加料金（インクジェットのみ） -------- */
if (printMethod === 'inkjet') {
  // ❌ 間違った実装を削除し、▼のコードに置き換え
  const nonWhiteQty = Object.entries(colorSizeMap)
    .filter(([color]) => color !== WHITE_COLOR_NAME)          // ← color がキー
    .reduce((sum, [,sizeMap]) =>
              sum + Object.values(sizeMap).reduce((a,b)=>a+b,0),
            0);

if (nonWhiteQty > 0) {
    const whiteInkPrice = await getVariantPrice(INKJET_WHITE_INK_VARIANT);
    subtotal       += whiteInkPrice * nonWhiteQty;   // 税込価格をそのまま加算
    optionSubtotal += whiteInkPrice * nonWhiteQty;
  }
}

/* ------------------------------------------------------- */

/* ★ お急ぎ便の追加料金（1 回ぶんだけ） ★ */
const shippingInputElForSummary = document.getElementById('shipping_input');
if (shippingInputElForSummary && shippingInputElForSummary.value === 'express') {
  const expressPrice = await getVariantPrice(EXPRESS_FEE_VARIANT);
  subtotal       += expressPrice;   // 1 回分だけ加算
  optionSubtotal += expressPrice;
}








/* 4-d 版代（シルクスクリーン：箇所×色数） -------------------- */
let plateSubtotal = 0;
let plateLines = []; // 表示用（任意）
let plateNg = [];     // 2026-10-22：10枚に足りない版

const silkPlacements = (Array.isArray(placements) ? placements : [])
  .slice(0, MAX_PLACES)
  .map((p, idx) => ({ p, idx }))
  .filter(({ p }) => p && baseMethod(p.method) === 'silk' && (p.areaKey || p.area));

for (const { p, idx } of silkPlacements) {
  const areaKey = String(p.areaKey || p.area || '').trim();
  /* ★変更：大判のときは特大版の版代 */
  const pid = (p.big && isLargeEligible(p)) ? SILK_PLATE_XL_VARIANT : SILK_PLATE_VARIANTS?.[areaKey];
  if (!pid) continue;

  // 色数：あなたのカート投入と同じ関数を使う（最優先）。インク未選択なら【1色】〜【3色】の色数（2026-10-22）
  const colors = Number(getSilkColorCount(placements, idx)) || silkInkCount(p.method) || 0;
  if (colors <= 0) continue;

  /* 2026-10-22：リピートは版代なし */
  if (p.repeat) { plateLines.push(`${idx + 1}箇所目：リピート（版代なし）`); continue; }
  if (p.sharedPlate) { plateLines.push(`${idx + 1}箇所目：${sharedPlateText(p, totalQty)}`); continue; }   /* 2026-10-26 */
  const platePrice = await getVariantPrice(pid); // Shopifyのprice（cent）
  /* 2026-10-22：版代は「サイズ分けの数 × 色数」 */
  const nGroups = plateCountOf(p);
  plateSubtotal += platePrice * colors * nGroups;

  // 表示したいなら（任意）
  plateLines.push(nGroups > 1
    ? `${idx + 1}箇所目：${colors}色 × サイズ分け${nGroups}（${plateGroupsOf(p).map(g => g.sizes.join('・')).join('／')}）＝${colors * nGroups}版`
    : `${idx + 1}箇所目：${colors}色`);
  if (!p.repeat) plateShortGroups(p).forEach(g => plateNg.push(`${idx + 1}箇所目の${g.sizes.join('・')}の版が${g.qty}枚`));
  if (p.inkChange && canInkChange(p)) plateLines.push(`${idx + 1}箇所目のインク：${inkChangeText(p)}`);
  if (isSilkSmallQty(totalQty) && !p.repeat) plateLines.push(`${idx + 1}箇所目：10枚未満のためサンプル・少量の料金（印刷代は10枚の単価）`);
}

// 小計に加算
subtotal += plateSubtotal;

/* 4-d-1 シルクのオプション（セットアップ代・版の清掃代・特殊インク）2026-10-22 */
let silkOptSubtotal = 0;
const silkOptLines = [];
for (const { p, idx } of silkPlacements) {
  for (const ln of silkOptionLines(p, idx, totalQty)) {
    const price = await getVariantPrice(ln.variant);
    silkOptSubtotal += price * ln.qty;
    silkOptLines.push(ln.label);
  }
}
subtotal += silkOptSubtotal;

/* 4-d-2 調色料（シルクスクリーン：1色あたり × 色数） */
let chosyokuSubtotal = 0;
const chosyokuCount = isSample ? 0 : getChosyokuCount();
if (chosyokuCount > 0) {
  const chosyokuPrice = await getVariantPrice(CHOSYOKU_VARIANT);
  chosyokuSubtotal = chosyokuPrice * chosyokuCount;
  subtotal += chosyokuSubtotal;
}
/* 4-d-3 担当者が自動お見積りで入れた追加料金 2026-10-22 */
let staffFeeSubtotal = 0;
const staffFeeLabels = [];
if (!isSample) {
  for (const ln of staffFeeLines()) {
    const price = await getVariantPrice(ln.variant);
    staffFeeSubtotal += price * ln.qty;
    staffFeeLabels.push(ln.label);
  }
}
subtotal += staffFeeSubtotal;
const staffFeeMemoHtml = (STAFF_FEES && STAFF_FEES.memo) ? String(STAFF_FEES.memo).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c])).replace(/\n/g,'<br>') : '';
const chosyokuCodeHtml = getChosyokuCode().replace(/</g,'&lt;').replace(/\n/g,'<br>')
  || '<b style="color:#d32f2f;">未入力</b>';




/* 4-d 袋詰め */
if (bagging === 'あり') {
  const price = await getVariantPrice(BAGGING_VARIANT);
  subtotal       += price * totalQty;
  optionSubtotal += price * totalQty;
}
/* 4-e データ作成依頼 */
const _drPriceKey2 = parseInt(designRequestVal2, 10);
if ([1100, 3300, 5500].includes(_drPriceKey2)) {
  const price = await getVariantPrice(DESIGN_REQUEST_VARIANTS[_drPriceKey2]);
  subtotal       += price;
  optionSubtotal += price;
}
let totalText = `¥${ (subtotal/100).toLocaleString() }`;
 let unitText  = totalQty ? `¥${ Math.floor((subtotal/100)/totalQty).toLocaleString() }` : '–';
 if (needsQuote){
   totalText = '別途お見積り';
   unitText  = '–';
 }

/* 相談系：印刷代のみ後日確定。ボディ代等は金額を出す */
const printFeeLaterNote = (printFeeLater && !needsQuote)
  ? `<div class="order-summary__notice">
       ※印刷代は含まれていません。ご注文後に確定し、別途ご請求となります。
     </div>`
  : '';
/* 2026-10-22：版分けで10枚に足りない版があるときの注意 */
const plateNgNote = plateNg.length
  ? `<div class="order-summary__notice" style="color:#d93025;font-weight:800;">
       ※シルクスクリーンは1版10枚以上必要です（${plateNg.join('、')}）。版の分け方を「全サイズ共通（1版）」にするか、枚数を見直してください。
     </div>`
  : '';
// ✅ 100枚以上の注意文（小計が別途見積りでも出したいなら totalQty 判定でOK）
/* 2026-10-22：100枚以上も金額を出すため、「別途お見積り」の注意は出さない */
const over100Note = '';


  /* ⑤ HTML 出力 ---------------------------------------- */
// 各ラベルと値を「ラベル: 値」の行として出力
summaryBox.innerHTML = `
  <div class="order-summary__title">ご注文内容確認</div>
  ${ !isHiddenStep('step-order-type') ? `
  <div class="order-summary__row">
    <span class="order-summary__label">注文タイプ:</span>
    ${ isSample ? '無地購入' : '印刷あり' }
  </div>
  ` : '' }
  <div class="order-summary__row">
    <span class="order-summary__label">商品仕様:</span>
    ${ colorLines }
  </div>

${ (!isHiddenStep('step-print-sides') && !isSample) ? `
  <div class="order-summary__row">
    <span class="order-summary__label">印刷面:</span>
    ${ printSidesLabel }
  </div>
  ` : '' }



  ${ (!isHiddenStep('step-placement') && !isSample) ? `
  <div class="order-summary__row -stack">
    <span class="order-summary__label">印刷方法・印刷箇所:</span>
    <div class="order-summary__value">
      ${ pmLines ? `<table class="os-tbl"><thead><tr><th class="os-n">No</th><th>印刷箇所 ／ 印刷方法</th></tr></thead><tbody>${pmLines}</tbody></table>` : '<span class="os-none">未選択</span>' }
    </div>
  </div>
  <div class="order-summary__row">
    <span class="order-summary__label">位置指定:</span>
    ${ posLabel }
  </div>
  ${ posDetailRow }
  ` : '' }

  ${ !isSample ? `
  <div class="order-summary__row">
    <span class="order-summary__label">入稿方法:</span>
    ${ submitLabel }
  </div>
  <div class="order-summary__row -stack">
    <span class="order-summary__label">入稿データ:</span>
    <div class="order-summary__value">
      ${ getUploadSummaryHtml() }
    </div>
  </div>
  ` : '' }

${ (!SKIP_PROOF_IMAGE && !isSample) ? `
  <div class="order-summary__row">
    <span class="order-summary__label">完成イメージ連絡:</span>
    ${ (document.querySelector('#contactMethod input[name="contact_method"]:checked')?.value === 'line')
        ? `LINE（${ (document.getElementById('line_account_input')?.value || '').trim()
              || '<b style="color:#d32f2f;">未入力</b>' }）`
        : 'メール' }
  </div>
  ` : '' }

<div class="order-summary__row">
    <span class="order-summary__label">ボディ代:</span>
    <div class="order-summary__value">¥${ (bodySubtotal/100).toLocaleString() }</div>
  </div>

  ${ !isSample ? `
  <div class="order-summary__row">
    <span class="order-summary__label">印刷代:</span>
    <div class="order-summary__value">
      ${ needsQuote ? '別途お見積り'
         : printFeeLater ? '<span style="color:#d93025;font-weight:800;">ご注文後に確定</span>'
         : `¥${ (printingSubtotal).toLocaleString() }` }
      ${ silkMergeNotes.length && !needsQuote && !printFeeLater ? `<div style="margin-top:4px;font-size:14px;font-weight:700;color:#00636b;line-height:1.6;">（${silkMergeNotes.join(' / ')}。同じご注文のほかの商品と合わせた枚数で割引しています）</div>` : '' }
    </div>
  </div>
  ` : '' }

  ${ plateSubtotal > 0 ? `
    <div class="order-summary__row">
      <span class="order-summary__label">版代:</span>
      <div class="order-summary__value">
        ¥${ (plateSubtotal/100).toLocaleString() }
        ${plateLines.length ? `<div style="margin-top:4px;font-size:12px;font-weight:800;color:#777;line-height:1.5;">(${plateLines.join(' / ')})</div>` : ``}
      </div>
    </div>` : '' }

  ${ silkOptSubtotal > 0 ? `
    <div class="order-summary__row">
      <span class="order-summary__label">シルクの追加料金:</span>
      <div class="order-summary__value">
        ¥${ (silkOptSubtotal/100).toLocaleString() }
        <div style="margin-top:4px;font-size:12px;font-weight:800;color:#777;line-height:1.5;">(${silkOptLines.join(' / ')})</div>
      </div>
    </div>` : '' }

  ${ chosyokuCount > 0 ? `
    <div class="order-summary__row">
      <span class="order-summary__label">調色料:</span>
      <div class="order-summary__value">
        ¥${ (chosyokuSubtotal/100).toLocaleString() }
        <div class="order-summary__subnote">${ chosyokuCount }色／色番号：${ chosyokuCodeHtml }</div>
      </div>
    </div>` : '' }

  ${ (staffFeeSubtotal > 0 || (!isSample && staffFeeMemoHtml)) ? `
    <div class="order-summary__row">
      <span class="order-summary__label">追加料金（担当者のお見積り）:</span>
      <div class="order-summary__value">
        ${ staffFeeSubtotal > 0 ? `¥${ (staffFeeSubtotal/100).toLocaleString() }` : '' }
        ${ staffFeeLabels.length ? `<div style="margin-top:4px;font-size:12px;font-weight:800;color:#777;line-height:1.5;">(${staffFeeLabels.join(' / ')})</div>` : `` }
      </div>
    </div>
    ${ staffFeeMemoHtml ? `<div style="margin:2px 0 10px;padding:10px 12px;background:#fffdf3;border:1px solid #e3d9b5;border-radius:8px;font-size:14px;font-weight:500;color:#333;line-height:1.7;text-align:left;white-space:normal;word-break:break-word;"><div style="font-size:13px;font-weight:800;color:#6b5412;margin-bottom:2px;">担当者からのメモ</div>${ staffFeeMemoHtml }</div>` : `` }` : '' }

  ${ optionSubtotal > 0 ? `
    <div class="order-summary__row">
      <span class="order-summary__label">オプション代:</span>
      <div class="order-summary__value">¥${ (optionSubtotal/100).toLocaleString() }</div>
    </div>` : '' }

  <div class="order-summary__row">
    <span class="order-summary__label">お届け希望日:</span>
    ${ (() => {
        const m = document.getElementById('delivery_mode_input')?.value || '';
        const w = document.getElementById('wish_date_input')?.value || '';
        if (m === 'none') return '指定なし（最短で発送）';
        if (m === 'date' && w) return `${formatJaDate(shipParse(w))}（希望）`;
        if (m === 'date') return '<b style="color:#d32f2f;">日付が未選択</b>';
        return '未選択';
      })() }
  </div>

  ${ !isHiddenStep('step-bagging') ? `
  <div class="order-summary__row">
    <span class="order-summary__label">袋詰めオプション:</span>
    ${ bagging }
  </div>
  ` : '' }

  ${ !isSample ? `
  ${ !isHiddenStep('step-design-request') ? `
  <div class="order-summary__row">
    <span class="order-summary__label">データ作成依頼:</span>
    ${ designRequestLabel }
  </div>
  ` : '' }
  <div class="order-summary__row">
    <span class="order-summary__label">事例掲載:</span>
    ${ caseLabel }
  </div>
  ` : '' }

<div class="order-summary__footer">
    <span class="order-summary__qty">合計枚数: ${totalQty} 枚</span>
    <span class="order-summary__total">小計（税込）：${ totalText }</span>
<span class="order-summary__shipping-note">※送料は全国無料です（お届け日の指定も無料）。</span>
    <span class="order-summary__shipping-note">※出荷予定日より早く必要な場合は特急（有料）です。ご注文前にお問い合わせください。</span>
    <span class="order-summary__shipping-note">※在庫はご注文後に確保します。欠品時は担当よりご連絡します。</span>
  </div>

  ${printFeeLaterNote}

  ${over100Note}
  ${plateNgNote}

  <div class="order-summary__unit">１枚あたり：${ unitText }</div>
`;


  summaryBox.style.display = 'block';
}
window.updateSummary = updateSummary;
/* ---------- サマリー更新を呼ぶタイミング ---------- */
/* サイズ入力・カラー変更 */
sizeRows.addEventListener('input', updateSummary);
/* 印刷方法を選んだとき */
document.getElementById('print_method_select')
        ?.addEventListener('change', updateSummary);


/* 袋詰めオプション */
document.querySelectorAll('#bagging-options .order-type__btn')
        .forEach(btn=>btn.addEventListener('click', updateSummary));
/* ▼▼ ★ ここを追加 ★ ▼▼ */
toggleStepsDisabled(false);         // 初期状態＝印刷あり
/* ▲▲ 追加ここまで ▲▲ */




/* ===== 全ステップ完了時だけエラーを消す ===== */
function checkAllStepsAndClearError(){
  const em = document.getElementById('cart-error-msg');
  if (!em || em.style.display === 'none') return;

  const orderType = document.getElementById('order_type_input').value;
  const totalQty = Object.values(cartSelections).reduce((t,i) => t + i.qty, 0);

  if (!orderType || totalQty <= 0) return;

  if (orderType === 'print') {
    if (!placements.length) return;
    for (let i = 0; i < placements.length; i++) {
      if (!placements[i].method) return;
    }
    if (!isPosDetailDone()) return;   /* ★追加 */
    if (!isChosyokuDone()) return;    /* ★追加：調色の色番号 */
const st = 'ok';
    /* ★変更：hidden ではなく isContactStepDone()（LINE時はアカウント名まで見る） */
    const cm = isContactStepDone() ? 'ok' : '';
    const bg = document.getElementById('bagging_input')?.value || '';
    const dr = document.getElementById('design_request_input')?.value || '';
    const cc = document.getElementById('case_consent_input')?.value || '';
    if (!st || !cm || !bg || !dr || !cc) return;
  }

em.style.display = 'none';
  document.querySelectorAll('.tshirt-step.is-error').forEach(el => el.classList.remove('is-error'));
  var fe = document.getElementById('floating-error-msg');
  if (fe) fe.style.display = 'none';
}

document.querySelectorAll('#step-order-type .order-type__btn')
  .forEach(b => b.addEventListener('click', checkAllStepsAndClearError));
document.querySelectorAll('#contactMethod input[name="contact_method"]')
  .forEach(r => r.addEventListener('change', checkAllStepsAndClearError));
/* ★追加：LINEアカウント名を入力したらエラー解除を再判定 */
document.getElementById('line_account_input')
  ?.addEventListener('input', checkAllStepsAndClearError);
/* ★追加：印刷位置の指定内容を入力したらエラー解除を再判定 */
document.getElementById('pos_detail_input')
  ?.addEventListener('input', checkAllStepsAndClearError);
document.querySelectorAll('#bagging-options .order-type__btn')
  .forEach(b => b.addEventListener('click', checkAllStepsAndClearError));
document.getElementById('design_request_select')
  ?.addEventListener('change', checkAllStepsAndClearError);
document.querySelectorAll('#case-consent .order-type__btn')
  .forEach(b => b.addEventListener('click', checkAllStepsAndClearError));
const _mc2 = document.getElementById('modal-color');
if (_mc2) new MutationObserver(() => {
  if (_mc2.getAttribute('aria-hidden') === 'true') checkAllStepsAndClearError();
}).observe(_mc2, { attributes:true, attributeFilter:['aria-hidden'] });
const _mp2 = document.getElementById('modal-placement');
if (_mp2) new MutationObserver(() => {
  if (_mp2.getAttribute('aria-hidden') === 'true') checkAllStepsAndClearError();
}).observe(_mp2, { attributes:true, attributeFilter:['aria-hidden'] });




/* ===== Wizard Step Progressive ===== */
(function(){
const STEP_IDS = [
    'step-order-type',       // STEP1
    'step-color-size',       // STEP2
    'step-print-sides',      // ← ★追加
    'step-placement',        // STEP3
    'step-upload',           // STEP4
    'step-contact',          // STEP5
    'step-bagging',          // STEP6
    'step-design-request',   // STEP7
    'step-case',             // STEP8
    'step-delivery',         // STEP9（お届け希望日：2026-10-27 追加）
    'step-notes'             // STEP10（備考欄：無地購入でも表示）
  ].filter(id => !isHiddenStep(id));
  const steps = STEP_IDS.map(id => document.getElementById(id)).filter(Boolean);
  if (!steps.length) return;

let unlockedIndex = 0;

  /* ★追加：無地購入(sample)時に隠す印刷関連ステップ */
  const PRINT_ONLY = ['step-print-sides','step-placement','step-upload','step-contact','step-design-request','step-case'];
  const isSampleMode  = () => document.getElementById('order_type_input')?.value === 'sample';
  const isStepAllowed = (id) => !(isSampleMode() && PRINT_ONLY.includes(id));

function showUpTo(idx){
    unlockedIndex = Math.max(unlockedIndex, idx);

    /* ★追加: SKIP_PROOF_IMAGE のとき step-contact 到達で次もアンロック */
    if (SKIP_PROOF_IMAGE) {
      const contactIdx = STEP_IDS.indexOf('step-contact');
      if (contactIdx >= 0 && unlockedIndex >= contactIdx) {
        unlockedIndex = Math.max(unlockedIndex, contactIdx + 1);
      }
    }

steps.forEach((s, i) => {
      if (i <= unlockedIndex && isStepAllowed(STEP_IDS[i])){
        s.classList.remove('is-hidden');
        s.classList.remove('is-disabled');
      } else {
        s.classList.add('is-hidden');
      }
    });
    window.__renumberVisibleSteps && window.__renumberVisibleSteps();
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  }
function unlockNext(currentId){
    const idx = STEP_IDS.indexOf(currentId);
    if (idx < 0) return;
    let next = idx + 1;
    while (next < STEP_IDS.length && !isStepAllowed(STEP_IDS[next])) next++; // ★無地購入時は印刷関連を飛ばす
    if (next < steps.length){
      showUpTo(next);
      setTimeout(() => {
        steps[next].scrollIntoView({ behavior:'smooth', block:'nearest' });
      }, 100);
    }
  }

  /* 初期状態：STEP1だけ表示 */
  showUpTo(0);
  /* ★追加：途中保存から再開したときに全STEPを開く */
  window.__tfRevealSteps = () => showUpTo(steps.length - 1);

  /* ===== 自動進行フック ===== */

  /* STEP1: 注文タイプ選択 → STEP2 */
  document.querySelectorAll('#step-order-type .order-type__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => unlockNext('step-order-type'), 200);
    });
  });

 /* STEP2: カラーモーダルを閉じた → STEP3 */
  const colorModal = document.getElementById('modal-color');
  if (colorModal){
    const obs = new MutationObserver(() => {
      if (colorModal.getAttribute('aria-hidden') === 'true'){
        const qty = Object.values(cartSelections).reduce((t,i) => t + i.qty, 0);
        if (qty > 0) {
          setTimeout(() => {
            unlockNext('step-color-size');
            const uploadStep = document.getElementById('step-upload');
            if (uploadStep && !uploadStep.classList.contains('is-hidden')) {
              setTimeout(() => unlockNext('step-upload'), 100);
            }
          }, 200);
        }
      }
    });
    obs.observe(colorModal, { attributes:true, attributeFilter:['aria-hidden'] });
  }
  /* STEP2: サイズモーダルを直接閉じた場合も */
  const sizeModal2 = document.getElementById('modal-size');
  if (sizeModal2){
    const obs2 = new MutationObserver(() => {
      if (sizeModal2.getAttribute('aria-hidden') === 'true'){
        const qty = Object.values(cartSelections).reduce((t,i) => t + i.qty, 0);
        if (qty > 0) setTimeout(() => unlockNext('step-color-size'), 200);
      }
    });
    obs2.observe(sizeModal2, { attributes:true, attributeFilter:['aria-hidden'] });
  }

  /* STEP3: 加工位置モーダルを閉じた → STEP4「だけ」表示 */
/* STEP3: 加工位置モーダルを閉じた → STEP4表示、入稿方法が選択済みならSTEP5も */
  const plcModal = document.getElementById('modal-placement');
  if (plcModal){
    const obs = new MutationObserver(() => {
      if (plcModal.getAttribute('aria-hidden') === 'true'){
        if (placements.length > 0){
          showUpTo(3);
          showUpTo(4);
        }
      }
    });
    obs.observe(plcModal, { attributes:true, attributeFilter:['aria-hidden'] });
  }


  /* STEP5（連絡方法）: メール or LINE を選択 → STEP6 */
  document.querySelectorAll('#contactMethod input[name="contact_method"]').forEach(radio => {
    radio.addEventListener('change', () => {
      setTimeout(() => unlockNext('step-contact'), 200);
    });
  });
/* STEP: 印刷面（片面/両面）選択 → 次へ */
/* STEP: 印刷面（片面/両面）選択 → 次へ */
document.querySelectorAll('#print-sides-options .order-type__btn').forEach(btn => {
  btn.addEventListener('click', () => {
    setTimeout(() => {
      unlockNext('step-print-sides');
      const uploadStep = document.getElementById('step-upload');
      if (uploadStep && !uploadStep.classList.contains('is-hidden')) {
        setTimeout(() => unlockNext('step-upload'), 100);
      }
    }, 200);
  });
});
/* STEP6（袋詰め）: なし or あり を選択 → STEP7（データ作成依頼） */
  document.querySelectorAll('#bagging-options .order-type__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => unlockNext('step-bagging'), 200);
    });
  });

/* STEP7（データ作成依頼）: select変更 → STEP8（事例掲載） */
  document.getElementById('design_request_select')
    ?.addEventListener('change', (e) => {
      if (e.target.value) {
        setTimeout(() => unlockNext('step-design-request'), 200);
      }
    });

/* STEP8（事例掲載）: 掲載OK/NG 選択 → STEP9（お届け日の指定） */
  document.querySelectorAll('#case-consent .order-type__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => unlockNext('step-case'), 200);
    });
  });

/* STEP9（お届け日の指定）: 指定なし／日付を指定する を選択 → STEP10（備考欄） */
  document.querySelectorAll('#delivery-options .order-type__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      setTimeout(() => unlockNext('step-delivery'), 200);
    });
  });

})();



/* 最初に 1 回実行 */
updateSummary();
/* ==== ▲ 追加ここまで ▲==== */

/* =========================================================
   ★追加：入力途中の自動保存・再開（このブラウザ内・商品ページごと）
   ・内容が変わるたびに localStorage へ保存（7日間）
   ・次に同じ商品ページを開いたとき、フォーム上部に「続きから再開」を出す
   ・カートに入れたら削除
   ========================================================= */
(function(){
  const DRAFT_KEY  = 'odp_order_draft:' + location.pathname;
  const DRAFT_DAYS = 7;
  let draftArmed = false;      // true になるまで自動保存しない（再開／破棄を選ぶまで）
  let saveTimer  = null;

  const $ = (id) => document.getElementById(id);
  const checkedContact = () => document.querySelector('#contactMethod input[name="contact_method"]:checked')?.value || '';

  function collect(){
    return {
      v: 1,
      ts: Date.now(),
      orderType:     $('order_type_input')?.value || '',
      printSides:    $('print_sides_input')?.value || '',
      cartSelections: JSON.parse(JSON.stringify(cartSelections)),
      placements:    JSON.parse(JSON.stringify(placements || [])),
      posChoice:     $('pos_choice_input')?.value || 'auto',
      posDetail:     $('pos_detail_input')?.value || '',
      chosyokuCount: $('chosyoku_count_select')?.value || '0',
      chosyokuCode:  $('chosyoku_code_input')?.value || '',
      uploadedFiles: JSON.parse(JSON.stringify(uploadedFiles)),
      contact:       checkedContact(),
      lineAccount:   $('line_account_input')?.value || '',
      bagging:       $('bagging_input')?.value || '',
      designRequest: $('design_request_input')?.value || '',
      caseConsent:   $('case_consent_input')?.value || '',
      notes:         $('notes_input')?.value || '',
      deliveryMode:  $('delivery_mode_input')?.value || '',      /* 2026-10-27：お届け日の指定 */
      wishDate:      $('wish_date_input')?.value || '',
      shipping:      $('shipping_input')?.value || '',  /* ★追加：出荷スピード */
      staffFees:     STAFF_FEES ? JSON.parse(JSON.stringify(STAFF_FEES)) : null   /* 2026-10-22：担当者の追加料金 */
    };
  }
  function hasContent(d){
    return Object.values(d.cartSelections || {}).some(s => s && s.qty > 0)
        || (d.placements || []).length > 0
        || Object.keys(d.uploadedFiles || {}).length > 0;
  }
  function load(){
    try{
      const d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
      if (!d || d.v !== 1) return null;
      if (Date.now() - (d.ts || 0) > DRAFT_DAYS * 864e5){ localStorage.removeItem(DRAFT_KEY); return null; }
      return hasContent(d) ? d : null;
    }catch(e){ return null; }
  }
  function save(){
    if (!draftArmed) return;
    try{
      const d = collect();
      if (hasContent(d)) localStorage.setItem(DRAFT_KEY, JSON.stringify(d));
      else localStorage.removeItem(DRAFT_KEY);
    }catch(e){}
  }
  function clear(){ try{ localStorage.removeItem(DRAFT_KEY); }catch(e){} }
  window.__tfDraftClear = clear;

  /* =========================================================
     ★追加：お客様用URL（担当者が入力した内容をURLにしてお客様に送る）
     ・担当者モード：商品ページを ?staff=1 で開くとON（この端末に記憶）／?staff=0 でOFF
       → 左下の「お客様用URL」から、お客様ごとに商品を追加して保存し、URLをコピーして送る
       → URLは https://onday.jp/pages/order-link/〇〇（sections/odp-order-link.liquid が読み込んで商品ページへ移動）
       → 保存に失敗したときだけ、内容を入れた長いURL（#odplink=…）にする
     ・お客様がURLを開くと、その内容が入った状態で注文フローが開く（内容は変更できる）
     ・複数商品のURLは、カートに入れるたびに次の商品が開き、最後にカートへ進む
     ・お客様用URLから入れた商品には、注文に「_op_担当者作成URL」（メモ）が残る（カートには出ない）
     ========================================================= */
  const LINK_HASH    = 'odplink=';
  const LINK_NEXT    = 'odplink-next';
  const LINK_QUEUE   = 'odp_link_queue';
  const LINK_DAYS    = 30;
  const STAFF_FLAG   = 'odp_staff';
  const STAFF_BASKET = 'odp_staff_basket';
  const STAFF_KEY    = 'odp_staff_key';
  const STAFF_LOAD   = 'odp_staff_load';   /* 別の商品ページで「読み込む」を押したときの受け渡し */                                         /* 担当者用の合言葉（この端末に記憶） */
  const ORDER_LINK_API = 'https://rafees-congestion.vercel.app/api/order-link';  /* 短いURLの保存先（Shopifyのメタオブジェクト order_link） */
  const lsGet = (k) => { try{ return JSON.parse(localStorage.getItem(k) || 'null'); }catch(e){ return null; } };
  const lsSet = (k, v) => { try{ localStorage.setItem(k, JSON.stringify(v)); }catch(e){} };
  const lsDel = (k) => { try{ localStorage.removeItem(k); }catch(e){} };
  const handleOf  = (path) => (((path || '').split('/products/')[1] || '').split(/[/?#]/)[0] || '');
  const productPath = () => '/products/' + handleOf(location.pathname);
  const escHtml = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]));

  /* ---- URL用の圧縮（LZ-String のアルゴリズム（MIT License）。記号は - と _ だけ使う） ---- */
  const ODP_LZ = (function(){
    const keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
    const rev = {};
    for (let i = 0; i < keyStr.length; i++) rev[keyStr.charAt(i)] = i;
    function compress(uncompressed, bitsPerChar, getCharFromInt){
      if (uncompressed == null) return '';
      let i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = '', context_wc = '', context_w = '',
          context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
      const push = (bit) => {
        context_data_val = (context_data_val << 1) | bit;
        if (context_data_position == bitsPerChar - 1){ context_data_position = 0; context_data.push(getCharFromInt(context_data_val)); context_data_val = 0; }
        else context_data_position++;
      };
      const writeBits = (n, v) => { for (let k = 0; k < n; k++){ push(v & 1); v = v >> 1; } };
      const emitW = () => {
        if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)){
          if (context_w.charCodeAt(0) < 256){
            writeBits(context_numBits, 0);
            writeBits(8, context_w.charCodeAt(0));
          } else {
            writeBits(context_numBits, 1);
            writeBits(16, context_w.charCodeAt(0));
          }
          context_enlargeIn--;
          if (context_enlargeIn == 0){ context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
          delete context_dictionaryToCreate[context_w];
        } else {
          writeBits(context_numBits, context_dictionary[context_w]);
        }
        context_enlargeIn--;
        if (context_enlargeIn == 0){ context_enlargeIn = Math.pow(2, context_numBits); context_numBits++; }
      };
      for (ii = 0; ii < uncompressed.length; ii++){
        context_c = uncompressed.charAt(ii);
        if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)){
          context_dictionary[context_c] = context_dictSize++;
          context_dictionaryToCreate[context_c] = true;
        }
        context_wc = context_w + context_c;
        if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)){
          context_w = context_wc;
        } else {
          emitW();
          context_dictionary[context_wc] = context_dictSize++;
          context_w = String(context_c);
        }
      }
      if (context_w !== '') emitW();
      writeBits(context_numBits, 2);
      while (true){
        context_data_val = (context_data_val << 1);
        if (context_data_position == bitsPerChar - 1){ context_data.push(getCharFromInt(context_data_val)); break; }
        else context_data_position++;
      }
      return context_data.join('');
    }
    function decompress(length, resetValue, getNextValue){
      const dictionary = [];
      let enlargeIn = 4, dictSize = 4, numBits = 3, entry = '', result = [], w, c, i;
      const data = { val: getNextValue(0), position: resetValue, index: 1 };
      const readBits = (n) => {
        let bits = 0, maxpower = Math.pow(2, n), power = 1;
        while (power != maxpower){
          const resb = data.val & data.position;
          data.position >>= 1;
          if (data.position == 0){ data.position = resetValue; data.val = getNextValue(data.index++); }
          bits |= (resb > 0 ? 1 : 0) * power;
          power <<= 1;
        }
        return bits;
      };
      for (i = 0; i < 3; i++) dictionary[i] = i;
      const first = readBits(2);
      if (first === 0) c = String.fromCharCode(readBits(8));
      else if (first === 1) c = String.fromCharCode(readBits(16));
      else return '';
      dictionary[3] = c; w = c; result.push(c);
      while (true){
        if (data.index > length) return '';
        let cc = readBits(numBits);
        if (cc === 0){ dictionary[dictSize++] = String.fromCharCode(readBits(8)); cc = dictSize - 1; enlargeIn--; }
        else if (cc === 1){ dictionary[dictSize++] = String.fromCharCode(readBits(16)); cc = dictSize - 1; enlargeIn--; }
        else if (cc === 2) return result.join('');
        if (enlargeIn == 0){ enlargeIn = Math.pow(2, numBits); numBits++; }
        if (dictionary[cc]) entry = dictionary[cc];
        else if (cc === dictSize) entry = w + w.charAt(0);
        else return null;
        result.push(entry);
        dictionary[dictSize++] = w + entry.charAt(0);
        enlargeIn--;
        w = entry;
        if (enlargeIn == 0){ enlargeIn = Math.pow(2, numBits); numBits++; }
      }
    }
    return {
      enc: (s) => compress(s, 6, (a) => keyStr.charAt(a)),
      dec: (s) => {
        if (!s) return '';
        return decompress(s.length, 32, (index) => rev[s.charAt(index)]);
      }
    };
  })();

  /* URLに入れる内容：保存日時と画像URL（読み込み時に補う）は省いて短くする */
  function slimDraft(d){
    const x = JSON.parse(JSON.stringify(d));
    delete x.ts;
    (x.placements || []).forEach(p => { delete p.img; });
    return x;
  }

  /* URLの #odplink=… を読み取る（#odplink-next は複数商品の2つ目以降） */
  function readLinkFromUrl(){
    const h = location.hash || '';
    if (h.indexOf('#' + LINK_HASH) === 0){
      try{
        const pkg = JSON.parse(ODP_LZ.dec(h.slice(1 + LINK_HASH.length)) || 'null');
        if (!pkg || pkg.v !== 1 || !Array.isArray(pkg.items) || !pkg.items.length) return null;
        const q = { memo: pkg.m || '', items: pkg.items, idx: 0, ts: Date.now(), r: !!pkg.r, c: !!pkg.c };
        lsSet(LINK_QUEUE, q);
        return q;
      }catch(e){ return null; }
    }
    if (h === '#' + LINK_NEXT){
      const q = lsGet(LINK_QUEUE);
      if (q && Array.isArray(q.items) && q.idx < q.items.length && Date.now() - (q.ts || 0) < LINK_DAYS * 864e5) return q;
    }
    return null;
  }

  /* カートに入れた後：次の商品があればそのURLを返す（なければ null → カートへ） */
  window.__odpLinkNext = function(){
    if (!window.__odpLinkInfo) return null;
    const q = lsGet(LINK_QUEUE);
    if (!q || !Array.isArray(q.items)) return null;
    q.idx = (q.idx || 0) + 1;
    if (q.idx >= q.items.length){ lsDel(LINK_QUEUE); return null; }
    lsSet(LINK_QUEUE, q);
    return q.items[q.idx].p + '#' + LINK_NEXT;
  };

  /* 2026-10-27：items（お客様用URLの商品）のうち skip 番目以外で、p と同じ箇所の順番・同じ色数のシルクの枚数の合計 */
  function otherSilkQty(items, skip, p){
    const i = (Array.isArray(placements) ? placements : []).indexOf(p);
    if (i < 0 || !p || !isSilk(p.method)) return 0;
    const colors = getSilkColorCount(placements, i) || silkInkCount(p.method);
    let n = 0;
    (items || []).forEach((it, k) => {
      if (k === skip || !it || !it.d) return;
      const pl = Array.isArray(it.d.placements) ? it.d.placements : [];
      const q = pl[i];
      if (!q || !isSilk(q.method)) return;
      if ((getSilkColorCount(pl, i) || silkInkCount(q.method)) !== colors) return;
      n += Number(it.n) || Object.values(it.d.cartSelections || {}).reduce((a, x) => a + (Number(x && x.qty) || 0), 0);
    });
    return n;
  }

  /* ---------- 担当者用パネル ---------- */
  function isStaff(){
    const sp = new URLSearchParams(location.search).get('staff');
    try{
      if (sp === '1') localStorage.setItem(STAFF_FLAG, '1');
      if (sp === '0') localStorage.removeItem(STAFF_FLAG);
      return localStorage.getItem(STAFF_FLAG) === '1';
    }catch(e){ return sp === '1'; }
  }

  /* 2026-10-26：商品ページの担当者モードでも追加料金（セットアップ代・版の清掃代・特殊インク・データ作成費・メモ）を入れられるようにする
     ・備考欄（step-notes）の下に担当者だけ出す。入れた内容は STAFF_FEES → 確認欄・カート・途中保存・お客様用URL に入る
     ・お客様がお客様用URLを開いたときは、この欄は出ない（確認欄に金額とメモだけ出る） */
  function initStaffFeeBox(){
    const host = document.querySelector('#step-notes .tshirt-step__body') || document.getElementById('step-notes');
    if (!host || document.getElementById('odp-staff-fee')) return;
    const box = document.createElement('div');
    box.id = 'odp-staff-fee';
    box.setAttribute('style', "margin:16px 0 0;padding:14px 16px;border:2px dashed #c9a43a;border-radius:10px;background:#fffdf3;font-family:'Noto Sans JP',sans-serif;color:#222;");
    const num = (k, label, unit, sub, max) => `
      <div style="display:grid;grid-template-columns:1fr 110px 24px;gap:8px;align-items:center;padding:8px 0;border-bottom:1px dashed #e3d9b5;">
        <label for="odp-sf-${k}" style="font-size:16px;font-weight:700;line-height:1.4;">${label}<span style="display:block;font-size:13px;font-weight:500;color:#777;">${sub}<b data-sf-sum="${k}" style="margin-left:6px;color:#d93025;"></b></span></label>
        <input type="number" id="odp-sf-${k}" data-sf="${k}" min="0" max="${max}" inputmode="numeric" placeholder="0"
          style="width:100%;height:46px;padding:0 10px;font-size:17px;text-align:right;border:2px solid #cfcfcf;border-radius:8px;font-family:inherit;box-sizing:border-box;">
        <span style="font-size:15px;font-weight:700;">${unit}</span>
      </div>`;
    /* 2026-11-02：担当者が決める日付（出荷予定日・お届け日） */
    const todayYmd = (() => { const d = new Date(); return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); })();
    const dateRow = (k, label, sub) => `
      <div style="display:grid;grid-template-columns:1fr 180px;gap:8px;align-items:center;padding:8px 0;border-bottom:1px dashed #e3d9b5;">
        <label for="odp-sf-${k}" style="font-size:16px;font-weight:700;line-height:1.4;">${label}<span style="display:block;font-size:13px;font-weight:500;color:#777;">${sub}</span></label>
        <input type="date" id="odp-sf-${k}" data-sf="${k}" min="${todayYmd}"
          style="width:100%;height:46px;padding:0 8px;font-size:16px;border:2px solid #cfcfcf;border-radius:8px;font-family:inherit;box-sizing:border-box;background:#fff;">
      </div>`;
    box.innerHTML = `
      <div style="margin:0 0 4px;font-size:17px;font-weight:900;color:#6b5412;">追加料金・日付（担当者用）</div>
      <div style="margin:0 0 6px;font-size:14px;color:#666;line-height:1.6;">お客様には出ません。入れた料金・日付・メモは、確認欄・カート・お客様用URLに入ります。</div>
      ${num('setup', 'セットアップ代', '回', '1,100円／回', 99)}
      ${num('cleaning', '版の清掃代', '回', '1,100円／回', 99)}
      ${num('special', '特殊インク', '枚', '110円／枚', 9999)}
      <div style="display:grid;grid-template-columns:1fr 134px;gap:8px;align-items:center;padding:8px 0;border-bottom:1px dashed #e3d9b5;">
        <label for="odp-sf-design" style="font-size:16px;font-weight:700;">データ作成費</label>
        <select id="odp-sf-design" data-sf="design" style="width:100%;height:46px;padding:0 8px;font-size:16px;border:2px solid #cfcfcf;border-radius:8px;font-family:inherit;background:#fff;">
          <option value="0">なし</option><option value="1100">1,100円</option><option value="3300">3,300円</option><option value="5500">5,500円</option>
        </select>
      </div>
      <div style="display:grid;grid-template-columns:1fr 134px;gap:8px;align-items:center;padding:8px 0;border-bottom:1px dashed #e3d9b5;">
        <label for="odp-sf-express" style="font-size:16px;font-weight:700;">特急料金</label>
        <select id="odp-sf-express" data-sf="express" style="width:100%;height:46px;padding:0 8px;font-size:16px;border:2px solid #cfcfcf;border-radius:8px;font-family:inherit;background:#fff;">
          <option value="0">なし</option><option value="3300">3,300円</option><option value="5500">5,500円</option><option value="11000">11,000円</option>
        </select>
      </div>
      ${dateRow('ship', '出荷予定日', '自動計算の代わりに、この日を出します')}
      ${dateRow('wish', 'お届け日', '出荷予定日より前の日も入れられます。「日付を希望する」でこの日が選ばれます')}
      <label for="odp-sf-memo" style="display:block;margin:12px 0 6px;font-size:16px;font-weight:700;">メモ（お客様の確認欄と注文に出ます）</label>
      <textarea id="odp-sf-memo" data-sf="memo" maxlength="300" placeholder="例：ブラックだけゴールドのインクで印刷します"
        style="width:100%;min-height:80px;padding:10px;font-size:16px;line-height:1.6;border:2px solid #cfcfcf;border-radius:8px;font-family:inherit;box-sizing:border-box;"></textarea>
      <div style="margin:4px 0 0;font-size:13px;color:#777;">※電話番号・住所などは書かないでください。</div>`;
    host.appendChild(box);
    const yenOf = { setup: 1100, cleaning: 1100, special: 110 };
    const sums = () => {
      const f = STAFF_FEES || {};
      box.querySelectorAll('[data-sf-sum]').forEach(el => {
        const k = el.getAttribute('data-sf-sum'); const v = (Number(f[k]) || 0) * (yenOf[k] || 0);
        el.textContent = v > 0 ? '＝ ' + v.toLocaleString() + '円' : '';
      });
    };
    const sync = () => {
      const f = STAFF_FEES || {};
      box.querySelectorAll('[data-sf]').forEach(el => {
        const k = el.getAttribute('data-sf');
        el.value = k === 'memo' ? (f.memo || '') : (k === 'design' || k === 'express') ? String(f[k] || 0) : (f[k] ? String(f[k]) : '');
      });
      sums();
    };
    const onIn = () => {
      const x = {};
      box.querySelectorAll('[data-sf]').forEach(el => { x[el.getAttribute('data-sf')] = el.value; });
      const prevWish = (STAFF_FEES && STAFF_FEES.wish) || '';
      STAFF_FEES = normStaffFees(x);
      sums();
      /* 2026-11-02：お届け日を入れたら「日付を希望する」にしてその日を選ぶ（消したときは日付だけ外す） */
      const wish = (STAFF_FEES && STAFF_FEES.wish) || '';
      if (wish !== prevWish){
        const wi = document.getElementById('wish_date_input');
        if (wish){ try { setDeliveryMode('date'); } catch (e) {} if (wi) wi.value = wish; }
        else if (wi && wi.value === prevWish){ wi.value = ''; }
        try { unlockNext && unlockNext('step-delivery'); } catch (e) {}
      }
      try { updateSummary(); } catch (e) {}
    };
    box.querySelectorAll('[data-sf]').forEach(el => { el.addEventListener('input', onIn); el.addEventListener('change', onIn); });
    window.__odpStaffFeesSync = sync;
    sync();
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  }

  function initStaffPanel(){
    if (!isStaff() || !document.getElementById('tshirt-order-flow')) return;
    initStaffFeeBox();   /* 2026-10-26：担当者用の追加料金（備考欄の下） */

    /* ★2026-10-21 作り直し（3）：①保存したお客様の一覧 → ②お客様を開いて編集、の2画面
       ・一覧は Shopify（メタオブジェクト order_link）から読むので、スタッフ全員で同じものが見える
       ・編集中の内容はこの端末に一時保存（商品ページを移動しても続きから） */
    const STAFF_EDIT = 'odp_staff_edit';
    lsDel(STAFF_BASKET);   /* 前の作りの一時保存は使わない */

    const css = document.createElement('style');
    css.textContent = `
      .odp-staff-open{position:fixed;left:16px;bottom:96px;z-index:9998;padding:12px 18px;border:2px solid #00b8b8;border-radius:999px;background:#fff;color:#00636b;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:800;box-shadow:0 4px 14px rgba(0,0,0,.18);cursor:pointer;}
      .odp-staff{position:fixed;left:16px;bottom:96px;z-index:9999;width:min(440px,calc(100vw - 32px));max-height:calc(100vh - 140px);overflow:auto;padding:16px 18px 18px;border:2px solid #00b8b8;border-radius:10px;background:#fff;box-shadow:0 8px 28px rgba(0,0,0,.22);font-family:'Noto Sans JP',sans-serif;color:#222;font-size:16px;line-height:1.6;}
      .odp-staff *{box-sizing:border-box;}
      .odp-staff[hidden],.odp-staff-open[hidden],.odp-staff [hidden]{display:none !important;}
      .odp-staff__head{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 12px;}
      .odp-staff__title{margin:0;font-size:18px;font-weight:800;color:#00636b;}
      .odp-staff__x{border:0;background:none;font-size:26px;line-height:1;color:#666;cursor:pointer;padding:4px 8px;}
      .odp-staff__back{display:inline-block;margin:0 0 10px;padding:0;border:0;background:none;color:#00636b;font-family:inherit;font-size:15px;font-weight:700;cursor:pointer;}
      .odp-staff__label{display:block;margin:14px 0 6px;font-size:15px;font-weight:700;}
      .odp-staff__label.-first{margin-top:0;}
      .odp-staff input.odp-staff__input{display:block;width:100% !important;height:46px !important;margin:0 !important;padding:0 12px !important;border:1px solid #bbb !important;border-radius:6px !important;background:#fff !important;font-size:16px !important;font-family:inherit !important;line-height:44px !important;color:#222 !important;box-shadow:none !important;}
      .odp-staff__btn{display:flex;align-items:center;justify-content:center;width:100%;height:48px;margin:12px 0 0;padding:0 12px;border:0;border-radius:8px;font-family:inherit;font-size:16px;font-weight:800;white-space:nowrap;cursor:pointer;}
      .odp-staff__btn.-add{background:#00b8b8;color:#fff;}
      .odp-staff__btn.-red{background:#ea4a3f;color:#fff;}
      .odp-staff__btn.-line{background:#fff;color:#00636b;border:1px solid #00b8b8;}
      .odp-staff__btn:disabled{opacity:.45;cursor:default;}
      .odp-staff__two{display:flex;gap:8px;margin-top:12px;}
      .odp-staff__two .odp-staff__btn{flex:1 1 0;margin:0;}
      .odp-staff__list{margin:0;padding:0;border:1px solid #ddd;border-radius:6px;}
      .odp-staff__item{display:flex;align-items:center;gap:8px;padding:10px 12px;}
      .odp-staff__item + .odp-staff__item{border-top:1px solid #eee;}
      .odp-staff__name{flex:1 1 auto;min-width:0;line-height:1.45;}
      .odp-staff__name b{display:block;font-size:16px;font-weight:800;word-break:break-all;}
      .odp-staff__name span{display:block;font-size:13px;color:#666;}
      .odp-staff__here{display:inline-block;margin-left:4px;padding:0 6px;border-radius:4px;background:#fff3d6;color:#8a5a00;font-size:12px;font-weight:800;}
      .odp-staff__mini{flex:0 0 auto;height:36px;padding:0 10px;border:1px solid #ccc;border-radius:6px;background:#fff;color:#333;font-size:14px;font-weight:700;font-family:inherit;white-space:nowrap;cursor:pointer;}
      .odp-staff__mini.-teal{border-color:#00b8b8;color:#00636b;}
      .odp-staff__empty{padding:14px 12px;color:#666;font-size:15px;}
      .odp-staff__pick{flex:0 0 auto;width:22px !important;height:22px !important;margin:0 !important;accent-color:#ea4a3f;cursor:pointer;}
      .odp-staff__item.-picked{background:#fdf3f2;}
      .odp-staff__ord{display:inline-block;margin:3px 0 0;padding:1px 8px;border-radius:4px;background:#e3f6ee;color:#1d6b4a;font-size:13px;font-weight:800;font-style:normal;}
      .odp-staff__ord.-unpaid{background:#fff3d6;color:#8a5a00;}
      .odp-staff__bulk{display:flex;align-items:center;justify-content:space-between;gap:8px;margin:0 0 8px;font-size:14px;}
      .odp-staff__bulk .odp-staff__btn{width:auto;margin:0;padding:0 14px;height:40px;font-size:15px;white-space:nowrap;}
      .odp-staff__bulk .odp-staff__link{white-space:nowrap;}
      .odp-staff__bulk-hint{color:#666;text-align:right;}
      .odp-staff__state{margin:12px 0 0;}
      .odp-staff__check{display:flex;align-items:flex-start;gap:10px;margin:14px 0 0;padding:12px;border:1px solid #ddd;border-radius:6px;cursor:pointer;font-size:15px;font-weight:700;line-height:1.5;}
      .odp-staff__check input{flex:0 0 auto;width:22px !important;height:22px !important;margin:1px 0 0 !important;accent-color:#00b8b8;}
      .odp-staff__check small{display:block;margin-top:2px;font-size:13px;font-weight:500;color:#666;}
      .odp-staff__badge{display:inline-block;padding:2px 10px;border-radius:999px;font-size:13px;font-weight:800;}
      .odp-staff__badge.-saved{background:#e3f6ee;color:#1d6b4a;}
      .odp-staff__badge.-dirty{background:#fdeceb;color:#b9361d;}
      .odp-staff__url{margin:6px 0 0;font-size:14px;color:#444;word-break:break-all;}
      .odp-staff__msg{margin:10px 0 0;font-size:15px;font-weight:700;color:#00636b;line-height:1.6;}
      .odp-staff__msg.-err{color:#b9361d;}
      .odp-staff__links{display:flex;justify-content:space-between;gap:8px;margin:16px 0 0;padding:12px 0 0;border-top:1px solid #e5e5e5;}
      .odp-staff__link{border:0;background:none;padding:0;color:#666;font-family:inherit;font-size:14px;text-decoration:underline;cursor:pointer;}
      .odp-staff__link.-danger{color:#b9361d;}
      @media (max-width:768px){ .odp-staff-open,.odp-staff{bottom:84px;left:12px;} }
    `;
    document.head.appendChild(css);

    const openBtn = document.createElement('button');
    openBtn.type = 'button';
    openBtn.className = 'odp-staff-open';
    openBtn.textContent = 'お客様用URL';

    const panel = document.createElement('div');
    panel.className = 'odp-staff';
    panel.hidden = true;
    document.body.appendChild(openBtn);
    document.body.appendChild(panel);

    let listCache = null;      /* 一覧（最後に読んだもの） */
    let listOrdersOk = null;   /* 2026-10-27：注文済みかどうかを確認できたか（false＝アプリに注文を読む権限がない） */
    const listPick = new Set();   /* 2026-10-27：まとめて削除するお客様（URLの〇〇） */
    let boundHere = false;     /* ★このページの注文フローが、編集中のお客様の商品とつながっているか（追加・読み込み後） */
    let message = { text: '', err: false };

    const getEdit = () => lsGet(STAFF_EDIT);
    const setEdit = (e) => { lsSet(STAFF_EDIT, e); try{ updateSummary(); }catch(er){} };   /* 2026-10-27：合計枚数の単価を出し直す */
    /* 2026-10-27：担当者がお客様を編集中は、そのお客様のほかの商品・デザインの枚数で印刷代の単価を出す（お客様の画面と同じ） */
    if (!window.__odpLinkInfo) window.__odpSilkMergeQty = (p) => {
      const e = getEdit();
      if (!e || !Array.isArray(e.items) || !e.items.length) return 0;
      return otherSilkQty(e.items, curIndexHere(e), p);
    };
    const fmtTime = (iso) => {
      const d = new Date(iso || 0); if (isNaN(d)) return '';
      const z = n => String(n).padStart(2, '0');
      return `${d.getMonth() + 1}/${d.getDate()} ${z(d.getHours())}:${z(d.getMinutes())}`;
    };
    const shortTitle = (t) => String(t || '').split(/\s*[｜|]\s*/)[0];
    const msg = (text, err) => { message = { text: text || '', err: !!err }; const m = panel.querySelector('[data-staff="msg"]'); if (m){ m.hidden = !text; m.textContent = text || ''; m.classList.toggle('-err', !!err); } };

    function copyText(text){
      if (navigator.clipboard && window.isSecureContext) return navigator.clipboard.writeText(text);
      const ta = document.createElement('textarea');
      ta.value = text; ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      let ok = false; try{ ok = document.execCommand('copy'); }catch(e){}
      ta.remove();
      return ok ? Promise.resolve() : Promise.reject(new Error('copy'));
    }

    /* API（合言葉は最初の1回だけ聞く） */
    async function api(body){
      let key = '';
      try{ key = localStorage.getItem(STAFF_KEY) || ''; }catch(e){}
      if (!key){
        key = (prompt('担当者用の合言葉を入力してください（最初の1回だけ）') || '').trim();
        if (!key) throw Object.assign(new Error('nokey'), { code: 'nokey' });
        try{ localStorage.setItem(STAFF_KEY, key); }catch(e){}
      }
      const res = await fetch(ORDER_LINK_API, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Staff-Key': key },
        body   : JSON.stringify(body)
      });
      if (res.status === 401){
        try{ localStorage.removeItem(STAFF_KEY); }catch(e){}
        throw Object.assign(new Error('key'), { code: 'key' });
      }
      const j = await res.json().catch(() => null);
      if (!res.ok || !j || !j.ok) throw Object.assign(new Error('api'), { code: (j && j.error) || 'api' });
      return j;
    }
    const apiErrText = (e) => e && e.code === 'key' ? '合言葉が違います。もう一度押して、正しい合言葉を入れてください。'
      : e && e.code === 'nokey' ? '合言葉を入れてください。'
      : '通信できませんでした。時間をおいてもう一度押してください。';

    /* ---------- ① 一覧 ---------- */
    function renderList(){
      const rows = listCache === null
        ? '<div class="odp-staff__empty">読み込んでいます…</div>'
        : !listCache.length
          ? '<div class="odp-staff__empty">まだ保存したお客様はいません。</div>'
          : listCache.map((it, i) => `
              <div class="odp-staff__item${listPick.has(it.handle) ? ' -picked' : ''}">
                <input type="checkbox" class="odp-staff__pick" data-staff-pick="${escHtml(it.handle)}"${listPick.has(it.handle) ? ' checked' : ''} aria-label="まとめて削除に選ぶ">
                <div class="odp-staff__name"><b>${escHtml(it.memo || '（お客様名なし）')}</b><span>${it.count}商品・${fmtTime(it.updatedAt)}</span>${it.order
                  ? `<em class="odp-staff__ord${it.order.paid ? '' : ' -unpaid'}">${it.order.paid ? '注文済み' : '注文済み（未入金）'} ${escHtml(it.order.name)}</em>` : ''}</div>
                <button type="button" class="odp-staff__mini -teal" data-staff-open="${i}">開く</button>
                <button type="button" class="odp-staff__mini" data-staff-copy="${i}">URLコピー</button>
              </div>`).join('');
      panel.innerHTML = `
        <div class="odp-staff__head">
          <p class="odp-staff__title">お客様用URL（担当者用）</p>
          <button type="button" class="odp-staff__x" data-staff="close" aria-label="閉じる">×</button>
        </div>
        <button type="button" class="odp-staff__btn -add" data-staff="new" style="margin-top:0;">＋ 新しいお客様を作る</button>
        <label class="odp-staff__label">保存したお客様（新しい順）</label>
        ${(listCache && listCache.length) ? `
        <div class="odp-staff__bulk">
          ${listCache.some(x => x.order) ? '<button type="button" class="odp-staff__link" data-staff="pickordered">注文済みを選ぶ</button>' : '<span></span>'}
          ${listPick.size
            ? `<button type="button" class="odp-staff__btn -red" data-staff="bulkdel">選んだ${listPick.size}件を削除</button>`
            : '<span class="odp-staff__bulk-hint">チェックで、まとめて削除</span>'}
        </div>` : ''}
        <div class="odp-staff__list">${rows}</div>
        ${listOrdersOk === false ? '<p class="odp-staff__msg -err" style="font-size:13px;">注文済みかどうかを確認できませんでした（アプリに注文を読む権限が必要です）。</p>' : ''}
        <p class="odp-staff__msg${message.err ? ' -err' : ''}" data-staff="msg"${message.text ? '' : ' hidden'}>${escHtml(message.text)}</p>
        <div class="odp-staff__links">
          <button type="button" class="odp-staff__link" data-staff="reload">一覧を読み込み直す</button>
          <button type="button" class="odp-staff__link" data-staff="exit">担当者モードを終了</button>
        </div>`;
    }
    async function loadList(){
      listCache = null; renderList();
      try{
        const j = await api({ action: 'list' });
        listCache = j.list || [];
        listOrdersOk = typeof j.ordersOk === 'boolean' ? j.ordersOk : null;
        const has = new Set(listCache.map(x => x.handle));
        [...listPick].forEach(h => { if (!has.has(h)) listPick.delete(h); });
      }catch(e){
        listCache = [];
        msg(apiErrText(e), true);
      }
      if (!getEdit()) renderList();
    }

    /* ---------- ② 編集 ---------- */
    function renderEdit(){
      const e = getEdit();
      const here = productPath();
      const inList = e.items.some(it => it.p === here);
      const curI = curIndexHere(e);
      const saved = !!e.handle && !e.dirty;
      panel.innerHTML = `
        <div class="odp-staff__head">
          <p class="odp-staff__title">お客様用URL（担当者用）</p>
          <button type="button" class="odp-staff__x" data-staff="close" aria-label="閉じる">×</button>
        </div>
        <button type="button" class="odp-staff__back" data-staff="back">← 一覧に戻る</button>
        <label class="odp-staff__label -first">お客様名</label>
        <input type="text" class="odp-staff__input" data-staff="memo" placeholder="例：山田様（LINE）" value="${escHtml(e.memo || '')}">
        <label class="odp-staff__label">注文する商品</label>
        <div class="odp-staff__list">${
          e.items.length
            ? e.items.map((it, i) => `
                <div class="odp-staff__item">
                  <div class="odp-staff__name"><b>${escHtml(shortTitle(it.t))}${designNo(e, i) ? `（デザイン${designNo(e, i)}）` : ''}</b><span>${it.n}枚${i === curI ? '<span class="odp-staff__here">このページ</span>' : ''}</span></div>
                  <button type="button" class="odp-staff__mini -teal" data-staff-load="${i}">読み込む</button>
                  <button type="button" class="odp-staff__mini" data-staff-del="${i}">削除</button>
                </div>`).join('')
            : '<div class="odp-staff__empty">まだ商品がありません。注文フローに入力して「このページの商品を追加」を押してください。</div>'
        }</div>
        ${e.items.some(it => it.p !== here) ? `<button type="button" class="odp-staff__btn -line" data-staff="copyprint">1つ目の商品と同じ印刷にする（版代なし）</button>` : ''}
        <button type="button" class="odp-staff__btn -add" data-staff="add">${inList ? (designNo(e, curI) ? `デザイン${designNo(e, curI)}を今の内容に置き換え` : 'このページの商品を今の内容に置き換え') : 'このページの商品を追加'}</button>
        ${inList ? '<button type="button" class="odp-staff__btn -line" data-staff="addnew">同じ商品を別のデザインとして追加</button><p style="margin:6px 0 0;font-size:14px;color:#666;line-height:1.6;">注文フローを次のデザインの内容（印刷箇所・入稿データ・枚数など）に変えてから押してください。</p>' : ''}
        <label class="odp-staff__check"><input type="checkbox" data-staff="received"${e.received ? ' checked' : ''}><span>入稿データはメール・LINEで受け取り済み<br><small>お客様の画面でアップロード不要と表示し、確認画面も出しません</small></span></label>
        <label class="odp-staff__check"><input type="checkbox" data-staff="confirmed"${e.confirmed ? ' checked' : ''}><span>完成イメージ確認済み<br><small>出荷予定日に確認の日数（2営業日）を足しません。注文後に確認が要る場合はチェックしないでください</small></span></label>
        <div class="odp-staff__two">
          <button type="button" class="odp-staff__btn -red" data-staff="save"${e.items.length ? '' : ' disabled'}>保存する</button>
          <button type="button" class="odp-staff__btn -line" data-staff="copy"${e.handle ? '' : ' disabled'}>URLをコピー</button>
        </div>
        <div class="odp-staff__state">
          <span class="odp-staff__badge ${saved ? '-saved' : '-dirty'}">${saved ? '保存済み' : (e.handle ? '変更があります（まだ保存していません）' : 'まだ保存していません')}</span>
          ${e.url ? `<p class="odp-staff__url">${escHtml(e.url)}</p>` : ''}
        </div>
        <p class="odp-staff__msg${message.err ? ' -err' : ''}" data-staff="msg"${message.text ? '' : ' hidden'}>${escHtml(message.text)}</p>
        <div class="odp-staff__links">
          ${e.handle ? '<button type="button" class="odp-staff__link -danger" data-staff="remove">このお客様を削除</button>' : '<span></span>'}
          <button type="button" class="odp-staff__link" data-staff="exit">担当者モードを終了</button>
        </div>`;
    }

    function render(){ if (getEdit()) renderEdit(); else renderList(); }

    /* ★注文フローの今の内容を、編集中のお客様の「このページの商品」として入れる */
    /* 2026-10-27：asNew＝同じ商品でも別のデザインとして新しく入れる。
       そうでないときは、このページで読み込み中・追加した商品（e.cur）を置き換える（e.cur がなければ同じ商品の1つ目） */
    function curIndexHere(e){
      const here = productPath();
      if (Number.isInteger(e.cur) && e.items[e.cur] && e.items[e.cur].p === here) return e.cur;
      return e.items.findIndex(it => it.p === here);
    }
    function snapshotHere(e, asNew){
      const d = collect();
      const n = Object.values(d.cartSelections || {}).reduce((a, s) => a + (Number(s && s.qty) || 0), 0);
      if (!n) return -1;
      const title = (document.querySelector('.product__title h1, .product-title, h1')?.textContent || document.title).trim().replace(/\s+/g, ' ');
      const item = { p: productPath(), t: shortTitle(title).slice(0, 60), n, d: slimDraft(d) };
      const at = asNew ? -1 : curIndexHere(e);
      if (at >= 0){ e.items[at] = item; e.cur = at; }
      else { e.items.push(item); e.cur = e.items.length - 1; }
      recalcShared(e);   /* 2026-10-26 */
      return at;
    }
    /* 2026-10-27：同じ商品が2つ以上あるときの「デザイン〇」 */
    function designNo(e, i){
      const it = e.items[i];
      if (!it || e.items.filter(x => x.p === it.p).length < 2) return 0;
      return e.items.slice(0, i + 1).filter(x => x.p === it.p).length;
    }

    /* 2026-10-26：別の商品と同じ版で刷る商品の「印刷代の枚数」を、同じ版の商品の合計にそろえる */
    const hasSilkIt = (it) => ((it && it.d && it.d.placements) || []).some(p => p && isSilk(p.method));
    /* 2026-10-26：別の商品と同じ版の商品＝最初のシルクの箇所が「ほかと同じ版」。
       1箇所目が新しい版で2箇所目だけ「ほかと同じ版」（左胸と背面が同じ版など）は、その商品の中だけの共通なので数えない */
    const isSharedIt = (it) => { const f = ((it && it.d && it.d.placements) || []).find(p => p && isSilk(p.method)); return !!(f && f.sharedPlate); };
    function sharedTotal(e, hereQty){
      const here = productPath();
      const src = e.items.find(it => hasSilkIt(it) && !isSharedIt(it) && it.p !== here) || e.items.find(it => hasSilkIt(it) && !isSharedIt(it));
      let total = src ? src.n : 0;
      e.items.forEach(it => { if (it !== src && it.p !== here && isSharedIt(it)) total += it.n; });
      if (hereQty != null) total += hereQty;
      else { const h = e.items.find(it => it.p === here && it !== src && isSharedIt(it)); if (h) total += h.n; }
      return total;
    }
    function recalcShared(e){
      if (!e || !e.items.some(isSharedIt)) return;
      const total = sharedTotal(e, null);
      e.items.forEach(it => { if (isSharedIt(it)) it.d.placements.forEach(p => { if (p && isSilk(p.method) && p.sharedPlate) p.tierQty = total; }); });
      if (e.items.some(it => it.p === productPath() && isSharedIt(it))){
        (placements || []).forEach(p => { if (p && isSilk(p.method) && p.sharedPlate) p.tierQty = total; });
        try { renderRight(); updateSummary(); } catch (er) {}
      }
    }
    /* 2026-10-26：1つ目の商品と同じ印刷にする（印刷箇所・印刷方法・インクの色を同じ順番で写し、シルクは「ほかと同じ版」に） */
    function copyPrintFromFirst(e){
      const here = productPath();
      const src = e.items.find(it => it.p !== here);
      if (!src){ msg('先にほかの商品を追加してください。', true); return; }
      const miss = [], copied = [];
      (src.d.placements || []).forEach(p => {
        if (!p) return;
        const box = (pmBoxes || []).find(b => b.dataset.side === p.side && b.dataset.label === p.label);
        if (!box){ miss.push(p.label); return; }
        const q = JSON.parse(JSON.stringify(p));
        q.id = p.side + '_' + (p.areaKey || '') + '_' + Date.now() + '_' + copied.length;
        delete q.img;
        if (isSilk(q.method)){ q.sharedPlate = true; q.repeat = false; q.repeatInkChange = false; q.repeatOrderNo = ''; q.inkChange = false; q.inkByBody = null; q.plateSplit = 'one'; q.plateGroupsFixed = null; }
        copied.push(q);
      });
      if (!copied.length){ msg('この商品には、1つ目の商品と同じ印刷場所がありません。', true); return; }
      const d = collect();
      const hereQty = Object.values(d.cartSelections || {}).reduce((a, x) => a + (Number(x && x.qty) || 0), 0);
      const total = sharedTotal(e, hereQty);
      copied.forEach(q => { if (q.sharedPlate) q.tierQty = total; });
      d.placements = copied;
      (pmBoxes || []).forEach(b => b.classList.remove('is-selected'));
      restore(d);
      boundHere = true;
      msg(`「${shortTitle(src.t)}」と同じ印刷にしました（シルクは版代なし・印刷代は合計${total}枚の単価）。` +
          (miss.length ? `この商品にない印刷場所は入れていません：${miss.join('、')}。` : '') +
          'サイズと枚数を確かめて「このページの商品を追加」を押してください。', !!miss.length);
    }

    /* 商品を注文フローに読み込む */
    function loadItem(it, idx){
      { const e = getEdit(); if (e && Number.isInteger(idx)){ e.cur = idx; setEdit(e); } }   /* 2026-10-27：どの商品（デザイン）を読み込んだか */
      document.querySelector('.draft-bar')?.remove();
      draftArmed = true;
      restore(Object.assign({}, it.d, { v: 1 }));
      setTimeout(save, 800);
      setTimeout(() => { boundHere = true; }, 1200);   /* 読み込みが落ち着いてから、変更を見張る */
      msg('注文フローに読み込みました。直したら「保存する」を押してください（このページの内容もいっしょに保存されます）。');
      render();
    }

    async function openCustomer(row){
      msg('開いています…'); render();
      try{
        const j = await api({ action: 'get', handle: row.handle });
        const pkg = j.data || {};
        const items = (pkg.items || []).map(it => ({
          p: it.p,
          t: it.t || handleOf(it.p),
          n: it.n || Object.values((it.d && it.d.cartSelections) || {}).reduce((a, s) => a + (Number(s && s.qty) || 0), 0),
          d: it.d
        }));
        setEdit({ handle: j.handle, url: j.url, memo: j.memo || pkg.m || '', received: !!pkg.r, confirmed: !!pkg.c, items, dirty: false });
        msg(`「${j.memo || 'お客様名なし'}」を開きました。直したい商品の「読み込む」を押してください。`);
      }catch(e){
        msg(apiErrText(e), true);
      }
      render();
    }

    async function saveCustomer(){
      const e = getEdit();
      if (!e) return;
      /* ★このページの商品を追加・読み込みしたあとなら、注文フローの今の内容（備考なども）をいっしょに保存する */
      if (boundHere && e.items.some(it => it.p === productPath())){ snapshotHere(e); setEdit(e); }
      if (!e.items.length) return;
      recalcShared(e); setEdit(e);   /* 2026-10-26：保存のときに印刷代の枚数を数え直す */
      if (!(e.memo || '').trim()){ msg('お客様名を入れてから保存してください。', true); render(); panel.querySelector('[data-staff="memo"]')?.focus(); return; }
      msg('保存しています…'); render();
      try{
        const pkg = { v: 1, m: e.memo, r: !!e.received, c: !!e.confirmed, items: e.items.map(it => ({ p: it.p, t: it.t, n: it.n, d: it.d })) };
        const j = await api({
          action : 'save',
          handle : e.handle || '',
          memo   : e.memo,
          summary: e.items.map((it, i) => `${shortTitle(it.t)}${designNo(e, i) ? `・デザイン${designNo(e, i)}` : ''}（${it.n}枚）`).join('\n'),
          data   : pkg
        });
        const first = !e.handle;
        Object.assign(e, { handle: j.handle, url: j.url, dirty: false });
        setEdit(e);
        listCache = null;   /* 一覧に戻ったら読み込み直す */
        msg(first ? '保存しました。お客様に送るときは「URLをコピー」を押してください。' : '保存しました。前に送ったURLのままで、新しい内容が開きます。');
      }catch(err){
        msg(apiErrText(err), true);
      }
      render();
    }

    openBtn.addEventListener('click', () => {
      panel.hidden = false; openBtn.hidden = true;
      msg('');
      if (!getEdit() && listCache === null) loadList(); else render();
    });

    /* 別の商品ページで「読み込む」を押してこのページに来たとき */
    const pend = lsGet(STAFF_LOAD);
    if (pend && pend.p === productPath() && Date.now() - (pend.ts || 0) < 10 * 60 * 1000){
      lsDel(STAFF_LOAD);
      const e = getEdit();
      const pi = e ? ((Number.isInteger(pend.i) && e.items[pend.i] && e.items[pend.i].p === pend.p) ? pend.i : e.items.findIndex(x => x.p === pend.p)) : -1;
      const it = pi >= 0 ? e.items[pi] : null;
      if (it){
        panel.hidden = false; openBtn.hidden = true;
        setTimeout(() => loadItem(it, pi), 300);
      }
    }

    /* ★注文フローを変えたら「変更があります」にする（追加・読み込みしたあとだけ） */
    const markFormDirty = () => {
      if (!boundHere) return;
      const e = getEdit(); if (!e || !e.items.some(it => it.p === productPath())) return;
      if (!e.dirty){ e.dirty = true; setEdit(e); }
      const b = panel.querySelector('.odp-staff__badge');
      if (b){ b.className = 'odp-staff__badge -dirty'; b.textContent = e.handle ? '変更があります（まだ保存していません）' : 'まだ保存していません'; }
    };
    const flowRoot = document.getElementById('tshirt-order-flow');
    flowRoot?.addEventListener('input', markFormDirty);
    flowRoot?.addEventListener('change', markFormDirty);
    flowRoot?.addEventListener('click', (ev) => { if (ev.target.closest('button, label, input, select, .color-swatch, .pm-box')) setTimeout(markFormDirty, 0); });

    panel.addEventListener('change', (ev) => {
      if (ev.target.matches('[data-staff="received"]') || ev.target.matches('[data-staff="confirmed"]')){
        const e = getEdit(); if (!e) return;
        if (ev.target.matches('[data-staff="received"]')) e.received = !!ev.target.checked;
        else e.confirmed = !!ev.target.checked;
        e.dirty = true; setEdit(e);
        msg('変更しました。最後に「保存する」を押してください。');
        render();
      }
    });

    panel.addEventListener('input', (ev) => {
      if (ev.target.matches('[data-staff="memo"]')){
        const e = getEdit(); if (!e) return;
        e.memo = ev.target.value; e.dirty = true; setEdit(e);
        const b = panel.querySelector('.odp-staff__badge');
        if (b){ b.className = 'odp-staff__badge -dirty'; b.textContent = e.handle ? '変更があります（まだ保存していません）' : 'まだ保存していません'; }
      }
    });

    panel.addEventListener('click', (ev) => {
      const t = ev.target;

      /* 2026-10-27：一覧：まとめて削除に選ぶ */
      if (t.matches && t.matches('input[data-staff-pick]')){
        const h = t.dataset.staffPick;
        if (t.checked) listPick.add(h); else listPick.delete(h);
        renderList();
        return;
      }
      const sact = t.closest('[data-staff]');
      if (sact && sact.dataset.staff === 'pickordered'){
        const ordered = (listCache || []).filter(x => x.order);
        const all = ordered.every(x => listPick.has(x.handle));
        ordered.forEach(x => { if (all) listPick.delete(x.handle); else listPick.add(x.handle); });
        renderList();
        return;
      }
      if (sact && sact.dataset.staff === 'bulkdel'){
        const rows = (listCache || []).filter(x => listPick.has(x.handle));
        if (!rows.length) return;
        const names = rows.slice(0, 10).map(x => '・' + (x.memo || 'お客様名なし')).join('\n') + (rows.length > 10 ? `\n…ほか${rows.length - 10}件` : '');
        if (!confirm(`${rows.length}件のお客様を削除しますか？送ったURLも開けなくなります。\n\n${names}`)) return;
        (async () => {
          let done = 0, ng = 0;
          for (const x of rows){
            msg(`削除しています…（${done + ng + 1}／${rows.length}）`); renderList();
            try{ await api({ action: 'delete', handle: x.handle }); done++; listPick.delete(x.handle); }
            catch(err){ ng++; if (err && err.code === 'key'){ msg(apiErrText(err), true); renderList(); return; } }
          }
          const ed = getEdit();
          if (ed && ed.handle && rows.some(x => x.handle === ed.handle)) lsDel(STAFF_EDIT);
          await loadList();
          msg(ng ? `${done}件を削除しました。${ng}件は削除できませんでした。もう一度お試しください。` : `${done}件を削除しました。`, !!ng);
          if (!getEdit()) renderList();
        })();
        return;
      }

      /* 一覧：開く／URLコピー */
      const op = t.closest('[data-staff-open]');
      if (op){ const row = listCache && listCache[Number(op.dataset.staffOpen)]; if (row) openCustomer(row); return; }
      const cp = t.closest('[data-staff-copy]');
      if (cp){
        const row = listCache && listCache[Number(cp.dataset.staffCopy)];
        if (row) copyText(row.url).then(() => msg(`「${row.memo}」のURLをコピーしました。`), () => msg(`コピーできませんでした。URL：${row.url}`, true)).then(render);
        return;
      }

      /* 編集：読み込む／削除 */
      const ld = t.closest('[data-staff-load]');
      if (ld){
        const li = Number(ld.dataset.staffLoad);
        const it = getEdit().items[li];
        if (!it) return;
        if (it.p !== productPath()){
          lsSet(STAFF_LOAD, { p: it.p, i: li, ts: Date.now() });
          location.href = it.p;   /* その商品ページを開いてから読み込む */
          return;
        }
        loadItem(it, li);
        return;
      }
      const del = t.closest('[data-staff-del]');
      if (del){
        const e = getEdit(); const it = e.items[Number(del.dataset.staffDel)];
        if (!it || !confirm(`「${shortTitle(it.t)}」を外しますか？`)) return;
        const di = Number(del.dataset.staffDel);
        e.items.splice(di, 1);
        if (Number.isInteger(e.cur)){ if (e.cur === di){ e.cur = null; boundHere = false; } else if (e.cur > di) e.cur--; }   /* 2026-10-27 */
        recalcShared(e); e.dirty = true; setEdit(e);
        msg('外しました。最後に「保存する」を押してください。'); render();
        return;
      }

      const act = t.closest('[data-staff]')?.dataset.staff;
      if (!act) return;

      if (act === 'close'){ panel.hidden = true; openBtn.hidden = false; return; }
      if (act === 'exit'){
        try{ localStorage.removeItem(STAFF_FLAG); }catch(e){}
        panel.remove(); openBtn.remove();
        return;
      }
      if (act === 'reload'){ msg(''); loadList(); return; }

      if (act === 'new'){
        setEdit({ handle: '', url: '', memo: '', received: false, confirmed: false, items: [], dirty: true });
        msg('お客様名を入れて、注文フローに入力した商品を「このページの商品を追加」で入れてください。');
        render();
        panel.querySelector('[data-staff="memo"]')?.focus();
        return;
      }
      if (act === 'back'){
        const e = getEdit();
        if (e && e.dirty && (e.items.length || e.memo) && !confirm('保存していない変更があります。保存せずに一覧に戻りますか？')) return;
        lsDel(STAFF_EDIT); msg('');
        if (listCache === null) loadList(); else render();
        return;
      }
      if (act === 'addnew'){   /* 2026-10-27：同じ商品を別のデザインとして追加 */
        const e = getEdit();
        const at = snapshotHere(e, true);
        if (at === -1 && !Number.isInteger(e.cur)){ msg('注文フローでカラー・サイズ・枚数を入れてから押してください。', true); render(); return; }
        boundHere = true;
        e.dirty = true; setEdit(e);
        msg(`注文フローの今の内容を、デザイン${designNo(e, e.cur)}として追加しました。最後に「保存する」を押してください。`);
        render();
        return;
      }
      if (act === 'add'){
        const e = getEdit();
        const at = snapshotHere(e);
        if (at === -1 && !e.items.some(it => it.p === productPath())){ msg('注文フローでカラー・サイズ・枚数を入れてから押してください。', true); render(); return; }
        boundHere = true;
        e.dirty = true; setEdit(e);
        msg(at >= 0 ? '今の内容に置き換えました。最後に「保存する」を押してください。'
                    : '追加しました。ほかの商品もある場合は、その商品ページで入力して追加してください。最後に「保存する」を押してください。');
        render();
        return;
      }
      if (act === 'copyprint'){ const e = getEdit(); if (e){ copyPrintFromFirst(e); e.dirty = true; setEdit(e); render(); } return; }   /* 2026-10-26 */
      if (act === 'save'){ saveCustomer(); return; }
      if (act === 'copy'){
        const e = getEdit(); if (!e || !e.url) return;
        if (e.dirty && !confirm('保存していない変更があります。このままだと、お客様には前に保存した内容が開きます。コピーしますか？')) return;
        copyText(e.url).then(() => msg('URLをコピーしました。メールやLINEに貼り付けて送ってください。'), () => msg(`コピーできませんでした。URL：${e.url}`, true)).then(render);
        return;
      }
      if (act === 'remove'){
        const e = getEdit(); if (!e || !e.handle) return;
        if (!confirm(`「${e.memo || 'お客様名なし'}」を削除しますか？送ったURLも開けなくなります。`)) return;
        msg('削除しています…'); render();
        api({ action: 'delete', handle: e.handle }).then(() => {
          lsDel(STAFF_EDIT); msg('削除しました。'); loadList();
        }, (err) => { msg(apiErrText(err), true); render(); });
        return;
      }
    });

    render();
  }

  const scheduleSave = () => { clearTimeout(saveTimer); saveTimer = setTimeout(save, 400); };

  /* 変更検知：サマリーは変更のたびに描き直されるので、その変化を見る＋入力欄の input */
  const summaryBox = document.getElementById('order-summary');
  if (summaryBox) new MutationObserver(scheduleSave).observe(summaryBox, { childList: true, subtree: true, characterData: true });
  document.getElementById('tshirt-order-flow')?.addEventListener('input', scheduleSave);

  const click = (sel) => { const b = document.querySelector(sel); if (b) b.click(); return !!b; };
  const fire  = (el, type) => el && el.dispatchEvent(new Event(type, { bubbles: true }));

  function restore(d){
    /* 2026-10-22：担当者が自動お見積りで入れた追加料金 */
    STAFF_FEES = normStaffFees(d && d.staffFees);
    try { window.__odpStaffFeesSync && window.__odpStaffFeesSync(); } catch (e) {}   /* 2026-10-26：担当者用の欄にも反映 */
    /* STEP1 注文タイプ */
    if (d.orderType) click(`#step-order-type .order-type__btn[data-value="${d.orderType}"]`);
    /* 印刷面 */
    if (d.printSides) click(`#print-sides-options .order-type__btn[data-value="${d.printSides}"]`);
    /* STEP2 カラー／サイズ／枚数（印刷面の付け替え後に入れる） */
    Object.keys(cartSelections).forEach(k => delete cartSelections[k]);
    restoreStockBad = [];
    Object.entries(d.cartSelections || {}).forEach(([k, s]) => {
      if (!(s && s.qty > 0 && variants.some(v => v.id == s.variantId))) return;
      /* ★追加：在庫がないサイズは入れずに、あとで知らせる */
      const st = getSizeStock(colorOfVariant(s.variantId), s.size);
      if (st.status === 'discontinued' || st.status === 'soldout'){
        const eta = st.status === 'soldout' ? fmtEta(st.eta) : '';
        restoreStockBad.push(`${colorOfVariant(s.variantId)} ${s.size}（${s.qty}枚）：${st.status === 'discontinued' ? '販売終了' : (eta ? `入荷待ち・${eta}入荷予定` : '入荷待ち')}`);
        return;
      }
      cartSelections[k] = { variantId: +s.variantId, size: s.size, qty: s.qty };
    });
    Object.values(cartSelections).forEach(s => {
      const color = colorOfVariant(s.variantId);
      refreshSwatch(color);
      const single = document.querySelector(`.color-swatch--single[data-variant="${s.variantId}"] .color-qty-input`);
      if (single) single.value = s.qty;
    });
    /* STEP3 印刷箇所（いまの商品に存在する箇所だけ戻す） */
    placements.length = 0;
    (d.placements || []).forEach(p => {
      const box = (pmBoxes || []).find(b => b.dataset.side === p.side && b.dataset.label === p.label);
      if (!box) return;
      box.classList.add('is-selected');
      if (!p.img){ const im = box.querySelector('img'); p.img = im ? im.src : ''; }   /* ★追加：お客様用URLは画像URLを省いているので、ここで補う */
      placements.push(p);
    });
    if (d.posChoice) click(`#pos-choice .pos-choice__btn[data-value="${d.posChoice}"]`);
    if ($('pos_detail_input')) $('pos_detail_input').value = d.posDetail || '';
    renderRight();
    const cy = $('chosyoku_count_select');
    if (cy){ cy.value = String(d.chosyokuCount || '0'); fire(cy, 'change'); }
    if ($('chosyoku_code_input')) $('chosyoku_code_input').value = d.chosyokuCode || '';
    /* STEP4 入稿データ */
    Object.keys(uploadedFiles).forEach(k => delete uploadedFiles[k]);
    Object.assign(uploadedFiles, d.uploadedFiles || {});
    renderUploadRows();
    /* STEP5 連絡方法 */
    if (d.contact){
      const r = document.querySelector(`#contactMethod input[name="contact_method"][value="${d.contact}"]`);
      if (r){ r.checked = true; fire(r, 'change'); }
      if ($('line_account_input')){ $('line_account_input').value = d.lineAccount || ''; fire($('line_account_input'), 'input'); }
    }
    /* STEP6〜9 */
    if (d.bagging) click(`#bagging-options .order-type__btn[data-value="${d.bagging}"]`);
    const dr = $('design_request_select');
    if (dr && d.designRequest){ dr.value = d.designRequest; fire(dr, 'change'); }
    if (d.caseConsent) click(`#case-consent .order-type__btn[data-value="${d.caseConsent}"]`);
    if (d.deliveryMode){   /* 2026-10-27：お届け日の指定（日付は出荷予定日の計算後に範囲を確かめる） */
      click(`#delivery-options .order-type__btn[data-value="${d.deliveryMode}"]`);
      if (d.deliveryMode === 'date' && d.wishDate && $('wish_date_input')) $('wish_date_input').value = d.wishDate;
    }
    if ($('notes_input')) $('notes_input').value = d.notes || '';
    if (d.shipping) click(`#shipping-options .order-type__btn[data-value="${d.shipping}"]`);   /* ★追加：出荷スピード */

    /* 全STEPを開いて、サマリーを更新 */
    setTimeout(() => {
      window.__tfRevealSteps && window.__tfRevealSteps();
      updateSummary();
      window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
    }, 350);
  }

  /* ★追加：見積りページ・お客様用URLから読み込んだとき、在庫がなくて外したサイズを一番上で知らせる（restore で外した分） */
  let restoreStockBad = [];
  function showStockNote(){
    if (!restoreStockBad.length) return null;
    const body = document.getElementById('preorder-body');
    if (!body) return null;
    document.querySelector('.odp-stock-note')?.remove();
    const n = document.createElement('div');
    n.className = 'odp-stock-note';
    n.setAttribute('style', "margin:0 0 16px;padding:14px 16px;background:#fff3f2;border:2px solid #f3c2bd;border-radius:8px;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:700;color:#b9361d;line-height:1.7;scroll-margin-top:200px;");   /* ★固定メニューに隠れないよう上に余白 */
    n.innerHTML = '在庫がないため、次のサイズはご注文いただけません。<br>' + restoreStockBad.map(b => '・' + b).join('<br>') +
      '<br><span style="font-size:15px;font-weight:500;color:#555;">この枚数は外してあります。カラーやサイズを変更して、枚数を入れ直してください。</span>';
    body.insertBefore(n, body.firstChild);
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
    return n;
  }

  function fmt(ts){
    const d = new Date(ts);
    const z = n => String(n).padStart(2, '0');
    return `${d.getMonth() + 1}/${d.getDate()} ${z(d.getHours())}:${z(d.getMinutes())}`;
  }

  const draft = load();
  const body  = document.getElementById('preorder-body');

  /* ★追加：お客様用URLから開いたとき */
  const linkQ = readLinkFromUrl();
  let linkItem = null;
  if (linkQ){
    const it = linkQ.items[linkQ.idx];
    if (it && handleOf(it.p) && handleOf(it.p) !== handleOf(location.pathname)){
      location.replace(it.p + '#' + LINK_NEXT);   /* 別の商品のURLなら、その商品ページを開き直す */
      return;
    }
    linkItem = it || null;
    try{ history.replaceState(null, '', location.pathname + location.search + '#' + LINK_NEXT); }catch(e){}
    if (linkItem){
      /* 2026-10-27：同じ商品が2つ以上あるときは、何番目のデザインか */
      const same = linkQ.items.filter(x => x && x.p === linkItem.p);
      const design = same.length > 1 ? linkQ.items.slice(0, linkQ.idx + 1).filter(x => x && x.p === linkItem.p).length : 0;
      window.__odpLinkInfo = { memo: linkQ.memo || '', no: linkQ.idx + 1, total: linkQ.items.length, received: !!linkQ.r, confirmed: !!linkQ.c, h: linkQ.h || '', design };
      /* 2026-10-27：ほかの商品・デザインのシルクの枚数（カートで同じ印刷代の行にまとまる分） */
      const qItems = linkQ.items, qSkip = linkQ.idx;
      window.__odpSilkMergeQty = (p) => otherSilkQty(qItems, qSkip, p);
    }
  }

  if (linkItem && linkItem.d && body){
    draftArmed = true;
    restore(Object.assign({}, linkItem.d, { v: 1 }));
    const info = window.__odpLinkInfo;
    const note = document.createElement('div');
    note.className = 'odp-link-note';
    note.setAttribute('style', "margin:0 0 16px;padding:14px 16px;background:#e9fbfb;border:2px solid #00b8b8;border-radius:8px;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:700;color:#00636b;line-height:1.7;");
    note.innerHTML = '担当者がご相談の内容をもとに、ご注文内容を入力しました。<br>内容をご確認のうえ「カートに入れる」を押してください。変更したいところは、そのまま変更できます。'
      + (info && info.total > 1 ? `<br><span style="color:#b9361d;">※全${info.total}商品のうち${info.no}商品目です${info.design ? `（この商品のデザイン${info.design}）` : ''}。${info.no < info.total ? 'カートに入れると、次の商品が開きます。' : 'カートに入れると、カートに進みます。'}</span>` : '');
    body.insertBefore(note, body.firstChild);
    /* ★追加：入稿データ受け取り済みなら、入稿データの欄にそう出す */
    if (info && info.received){
      const uplBody = document.querySelector('#step-upload .tshirt-step__body');
      if (uplBody){
        const head = uplBody.querySelector('.tshirt-step__head');
        const rn = document.createElement('div');
        rn.className = 'odp-link-received';
        rn.setAttribute('style', "margin:0 0 12px;padding:12px 14px;background:#e3f6ee;border:2px solid #9fd8bf;border-radius:8px;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:700;color:#1d6b4a;line-height:1.7;");
        rn.innerHTML = '入稿データは、担当者がメール・LINEで受け取り済みです。<br><span style="font-size:15px;font-weight:500;color:#555;">アップロードは不要です。そのまま次へ進んでください。</span>';
        if (head && head.nextSibling) uplBody.insertBefore(rn, head.nextSibling); else uplBody.appendChild(rn);
      }
    }
    setTimeout(save, 800);
    setTimeout(() => { try{ updateSummary(); }catch(e){} }, 400);
    /* ★追加：在庫がなくて外したサイズがあれば、一番上に出してそこへ移動 */
    const stockNote = showStockNote();
    if (stockNote) setTimeout(() => stockNote.scrollIntoView({ behavior:'smooth', block:'start' }), 700);
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  /* ★追加：自動お見積りページ（/pages/quote）から引き継いだ内容は、確認バーを出さずにそのまま読み込む */
  } else if (draft && draft.src === 'quote' && body){
    draftArmed = true;
    /* ★追加：自動お見積りから来た印（見積り番号）を、このタブの間だけ覚えておく → 注文に「_op_自動見積りから」として残す */
    try{ sessionStorage.setItem('odp_quote_qid:' + location.pathname, draft.qid || 'あり'); }catch(e){}
    restore(draft);
    /* 2026-10-23：見積りでインクの色まで選んでいれば、「選んでください」は出さない */
    const hasSilk = (draft.placements || []).some(p => /^silk/.test(p.method || '') && (Array.isArray(p.inks) ? p.inks.filter(Boolean).length : 0) < (silkInkCount(p.method) || 1));
    const note = document.createElement('div');
    note.className = 'quote-import-note';
    note.setAttribute('style', "margin:0 0 16px;padding:14px 16px;background:#e9fbfb;border:2px solid #00b8b8;border-radius:8px;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:700;color:#00636b;line-height:1.7;");
    note.innerHTML = 'お見積りページで選んだ内容を読み込みました。<br>入稿データ・連絡方法などの残りの項目を選んで、カートに入れてください。'
      + (hasSilk ? '<br><span style="color:#b9361d;">※シルクスクリーンのインクの色を選んでください。</span>' : '')
      + (staffFeeLines().length ? '<br><span style="color:#00636b;">※担当者がお見積りに入れた追加料金も、合計に入っています（ご注文内容の確認欄でご確認ください）。</span>' : '');
    body.insertBefore(note, body.firstChild);
    showStockNote();   /* ★追加：在庫がなくて外したサイズがあれば、一番上に出す */
    setTimeout(save, 800);   /* 引き継ぎ印を消して通常の途中保存に切り替える */

    /* ★追加：入稿データの欄に案内を出して、そこまで移動する（全STEPが開いた後） */
    const uplStep = document.getElementById('step-upload');
    const uplBody = uplStep?.querySelector('.tshirt-step__body');
    if (uplStep && uplBody && !isHiddenStep('step-upload')){
      const head = uplBody.querySelector('.tshirt-step__head');
      const uplNote = document.createElement('div');
      uplNote.className = 'quote-upload-note';
      uplNote.setAttribute('style', "margin:0 0 12px;padding:12px 14px;background:#fff3f2;border:2px solid #f3c2bd;border-radius:8px;font-family:'Noto Sans JP',sans-serif;font-size:16px;font-weight:700;color:#b9361d;line-height:1.7;");
      uplNote.innerHTML = 'まずは印刷するデータをアップロードしてください。<br><span style="font-size:15px;font-weight:500;color:#555;">※ 後からメール・LINEでデータを送る場合は、そのまま次へ進んでください。</span>';
      if (head && head.nextSibling) uplBody.insertBefore(uplNote, head.nextSibling);
      else uplBody.appendChild(uplNote);
      setTimeout(() => {
        window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
        /* ★変更：在庫がなくて外したサイズがあるときは、そのお知らせへ移動（見逃さないように） */
        const sn = document.querySelector('.odp-stock-note');
        (sn || uplStep).scrollIntoView({ behavior:'smooth', block:'start' });
      }, 700);
    }
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();
  } else if (draft && body){
    const bar = document.createElement('div');
    bar.className = 'draft-bar';
    bar.innerHTML =
      `<p class="draft-bar__text">前回の入力途中の内容があります（${fmt(draft.ts)} 保存）。続きから再開しますか？</p>` +
      `<p class="draft-bar__sub">※ 再開せずに入力を始めると、前回の内容は消えます</p>` +
      `<div class="draft-bar__actions">` +
        `<button type="button" class="draft-bar__btn -resume" data-draft-resume>続きから再開する</button>` +
        `<button type="button" class="draft-bar__btn -discard" data-draft-discard>破棄して最初から</button>` +
      `</div>`;
    body.insertBefore(bar, body.firstChild);
    window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight();

    const done = () => { bar.remove(); draftArmed = true; window.__recalcPreorderAccordionHeight && window.__recalcPreorderAccordionHeight(); };
    bar.addEventListener('click', e => {
      if (e.target.closest('[data-draft-resume]')){ done(); restore(draft); }
      else if (e.target.closest('[data-draft-discard]')){ clear(); done(); }
    });
    /* 選ばずに入力を始めたら、新しい内容で上書きしていく */
    document.getElementById('tshirt-order-flow')?.addEventListener('click', e => {
      if (!draftArmed && !e.target.closest('.draft-bar') && e.target.closest('button, label, input, select')) done();
    }, true);
  } else {
    draftArmed = true;
  }

  initStaffPanel();   /* ★追加：担当者モードのときだけ「お客様用URLを作る」を出す */
})();




/* =========================
   印刷方法：select → hidden 同期
   ========================= */
(function(){
  const sel = document.getElementById('print_method_select');
  const hidden = document.getElementById('print_method_input');
  if(!sel || !hidden) return;

  function sync(){
    hidden.value = sel.value || '';
    if (typeof updateSummary === 'function') updateSummary();
  }
  sel.addEventListener('change', sync);
  sync();
})();

  }); /* DOMContentLoaded end */

/* =========================================================
   SP：加工位置を選んだら pm-right へ自動スクロール
========================================================= */
(function(){
  const isSP = () => window.matchMedia('(max-width: 800px)').matches;

  // モーダル内スクロールで pm-right に寄せる
  function scrollToPmRight(){
    if (!isSP()) return;

    const modal = document.querySelector('#modal-placement');
    if (!modal || modal.getAttribute('aria-hidden') !== 'false') return;

    const scroller = modal.querySelector('.tshirt-modal__content'); // ← ここがスクロールコンテナ
    const target   = modal.querySelector('.pm-right');             // ← 下にある右ブロック
    if (!scroller || !target) return;

    // scrollIntoView は window を動かす事があるので「モーダル内スクロール」で計算
    const sRect = scroller.getBoundingClientRect();
    const tRect = target.getBoundingClientRect();

    // scroller内の現在のスクロール位置 + 目的地差分
    const top = scroller.scrollTop + (tRect.top - sRect.top) - 12; // 12px だけ上に余白
    scroller.scrollTo({ top, behavior: 'smooth' });
  }

  // 加工位置カード（左）クリックを拾う（イベント委譲）
  document.addEventListener('click', function(e){
    if (!isSP()) return;

    // 加工位置の各タイル（.pm-box）をクリックしたとき
    const box = e.target.closest('#modal-placement .pm-box');
    if (!box) return;

    // UI更新（選択反映）が走ってからスクロールしたいので少し遅らせる
    setTimeout(scrollToPmRight, 50);
  }, { passive: true });
})();




/* ===== フローティングCTA：カートボタンが見えなくなったら表示 ===== */
/* ===== フローティングCTA：カートボタンが見えなくなったら表示 ===== */
document.addEventListener('DOMContentLoaded', function(){
  var floatingBar = document.getElementById('floating-cart-cta');
  var cartBtn = document.getElementById('bulk-add-btn');
  if (!floatingBar || !cartBtn) return;

  var isSP = function(){ return window.matchMedia('(max-width:768px)').matches; };

  var observer = new IntersectionObserver(function(entries){
    if (!isSP()) { floatingBar.classList.remove('is-visible'); return; }
    floatingBar.style.display = '';
    floatingBar.classList.toggle('is-visible', !entries[0].isIntersecting);
  }, { threshold: 0 });

  observer.observe(cartBtn);
});



  

})(); /* IIFE end */